var _g, _path, _path2, _path3, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g11, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g12, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _g13, _path66, _path67, _g14, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _g15, _path103, _g16, _path104, _g17, _path105, _g18, _path106, _path107, _path108, _path109, _g19, _path110, _path111, _path112, _path113, _path114, _g20, _path115, _g21, _path116, _g22, _path117, _g23, _path118, _path119, _path120, _path121, _g24, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _g25, _path142, _g26, _path143, _g27, _path144, _g28, _path145, _path146, _path147, _path148, _g29, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _g30, _path168, _g31, _path169, _g32, _path170, _g33, _path171, _path172, _path173, _path174, _g34, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _g35, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _g36, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _g37, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacilities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.8 334C414.8 402.85 341.75 391.45 251.65 391.45C161.55 391.45 88.5 402.9 88.5 334C88.5 265.1 161.55 209.3 251.65 209.3C341.75 209.3 414.8 265.15 414.8 334Z",
    className: "illustration_primary-lighter"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M427.05 389.8C427.05 405.45 347.8 418.1 250 418.1C152.2 418.1 72.9502 405.45 72.9502 389.8C72.9502 385.35 72.9502 380.55 72.9502 380.55L427 380.25C427.05 380.25 427.05 385.8 427.05 389.8Z",
    fill: "#0D6636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250 408.55C347.782 408.55 427.05 395.88 427.05 380.25C427.05 364.62 347.782 351.95 250 351.95C152.218 351.95 72.9502 364.62 72.9502 380.25C72.9502 395.88 152.218 408.55 250 408.55Z",
    fill: "#1DB55D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M402.65 326.3C402.65 383.7 335.05 374.15 251.65 374.15C168.25 374.15 100.65 383.7 100.65 326.3C100.65 268.9 168.25 222.4 251.65 222.4C335.05 222.4 402.65 268.95 402.65 326.3Z",
    fill: "#2A9DD6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.55 296.8C137.35 296.05 144.4 292.85 151.75 291.25C160.5 289.3 193.6 288.45 204.15 290.25C223.85 288.05 248.85 286.3 265.05 287.45C282.55 288.7 282.75 290.15 282.8 290.6C294.55 292.15 300.95 293.6 294.95 295.25C286.9 297.45 261.3 297.05 245.2 297.5C208.05 298.5 153.45 301.55 139.55 296.8Z",
    className: "illustration_primary-lighter"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.25 278.1C215.05 277.35 222.1 274.15 229.45 272.55C238.2 270.6 271.3 269.75 281.85 271.55C301.55 269.35 326.55 267.6 342.75 268.75C360.25 270 360.45 271.45 360.5 271.9C372.25 273.45 378.65 274.9 372.65 276.55C364.6 278.75 339 278.35 322.9 278.8C285.75 279.8 231.15 282.85 217.25 278.1Z",
    className: "illustration_primary-lighter"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.245 347.329L171.795 347.329L171.795 339.329L143.245 339.329L143.245 347.329Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.032 345.779L170.332 345.779L170.332 340.829L168.032 340.829L168.032 345.779Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.994 345.779L167.294 345.779L167.294 340.829L164.994 340.829L164.994 345.779Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.006 345.779L164.306 345.779L164.306 340.829L162.006 340.829L162.006 345.779Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.969 345.779L161.269 345.779L161.269 340.829L158.969 340.829L158.969 345.779Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.981 345.779L158.281 345.779L158.281 340.829L155.981 340.829L155.981 345.779Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.944 345.779L155.244 345.779L155.244 340.829L152.944 340.829L152.944 345.779Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.906 345.779L152.206 345.779L152.206 340.829L149.906 340.829L149.906 345.779Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.918 345.779L149.218 345.779L149.218 340.829L146.918 340.829L146.918 345.779Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.931 345.779L170.231 345.779L170.231 340.829L167.931 340.829L167.931 345.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.943 345.779L167.243 345.779L167.243 340.829L164.943 340.829L164.943 345.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.906 345.779L164.206 345.779L164.206 340.829L161.906 340.829L161.906 345.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.868 345.779L161.168 345.779L161.168 340.829L158.868 340.829L158.868 345.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.881 345.779L158.181 345.779L158.181 340.829L155.881 340.829L155.881 345.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.843 345.779L155.143 345.779L155.143 340.829L152.843 340.829L152.843 345.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.805 345.779L152.105 345.779L152.105 340.829L149.805 340.829L149.805 345.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.818 345.779L149.118 345.779L149.118 340.829L146.818 340.829L146.818 345.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.931 346.196L170.231 346.196L170.231 345.746L167.931 345.746L167.931 346.196Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.943 346.196L167.243 346.196L167.243 345.746L164.943 345.746L164.943 346.196Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.906 346.196L164.206 346.196L164.206 345.746L161.906 345.746L161.906 346.196Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.868 346.196L161.168 346.196L161.168 345.746L158.868 345.746L158.868 346.196Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.881 346.196L158.181 346.196L158.181 345.746L155.881 345.746L155.881 346.196Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.843 346.196L155.143 346.196L155.143 345.746L152.843 345.746L152.843 346.196Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.805 346.196L152.105 346.196L152.105 345.746L149.805 345.746L149.805 346.196Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.818 346.196L149.118 346.196L149.118 345.746L146.818 345.746L146.818 346.196Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.182 346.196L170.482 346.196L170.482 345.746L168.182 345.746L168.182 346.196Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.144 346.196L167.444 346.196L167.444 345.746L165.144 345.746L165.144 346.196Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.157 346.196L164.457 346.196L164.457 345.746L162.157 345.746L162.157 346.196Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.119 346.196L161.419 346.196L161.419 345.746L159.119 345.746L159.119 346.196Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.132 346.196L158.432 346.196L158.432 345.746L156.132 345.746L156.132 346.196Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.094 346.196L155.394 346.196L155.394 345.746L153.094 345.746L153.094 346.196Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.056 346.196L152.356 346.196L152.356 345.746L150.056 345.746L150.056 346.196Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.069 346.196L149.369 346.196L149.369 345.746L147.069 345.746L147.069 346.196Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.806 342.338L149.156 342.338L149.156 340.838L146.806 340.838L146.806 342.338Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.783 344.05L152.133 344.05L152.133 340.85L149.783 340.85L149.783 344.05Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.827 343.756L155.177 343.756L155.177 340.856L152.827 340.856L152.827 343.756Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.865 342.444L158.215 342.444L158.215 340.844L155.865 340.844L155.865 342.444Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.853 341.913L161.203 341.913L161.203 340.863L158.853 340.863L158.853 341.913Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.89 341.286L164.24 341.286L164.24 340.836L161.89 340.836L161.89 341.286Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.928 342.338L167.278 342.338L167.278 340.838L164.928 340.838L164.928 342.338Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.916 344.569L170.266 344.569L170.266 340.819L167.916 340.819L167.916 344.569Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 339.3H138.85V347.3H143.25V339.3Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.5 345.6H140.1V346.05H141.5V345.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.75 346.15H139.35V346.6H140.75V346.15Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.25 346.15H140.85V346.6H142.25V346.15Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.263 339.294L172.263 339.294L172.263 338.944L143.263 338.944L143.263 339.294Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.263 338.96L172.263 338.96L172.263 338.61L143.263 338.61L143.263 338.96Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 338.95H138.6V339.3H143.25V338.95Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 338.55H138.6V338.9H143.25V338.55Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.25 338.55H138.6V339.3H143.25V338.55Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 356.093L171.795 356.093L171.795 348.093L143.245 348.093L143.245 356.093Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.032 354.543L170.332 354.543L170.332 349.593L168.032 349.593L168.032 354.543Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.994 354.543L167.294 354.543L167.294 349.593L164.994 349.593L164.994 354.543Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.006 354.543L164.306 354.543L164.306 349.593L162.006 349.593L162.006 354.543Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.969 354.543L161.269 354.543L161.269 349.593L158.969 349.593L158.969 354.543Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.981 354.543L158.281 354.543L158.281 349.593L155.981 349.593L155.981 354.543Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.944 354.543L155.244 354.543L155.244 349.593L152.944 349.593L152.944 354.543Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.906 354.543L152.206 354.543L152.206 349.593L149.906 349.593L149.906 354.543Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.918 354.543L149.218 354.543L149.218 349.593L146.918 349.593L146.918 354.543Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.931 354.543L170.231 354.543L170.231 349.593L167.931 349.593L167.931 354.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.943 354.543L167.243 354.543L167.243 349.593L164.943 349.593L164.943 354.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.906 354.543L164.206 354.543L164.206 349.593L161.906 349.593L161.906 354.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.868 354.543L161.168 354.543L161.168 349.593L158.868 349.593L158.868 354.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.881 354.543L158.181 354.543L158.181 349.593L155.881 349.593L155.881 354.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.843 354.543L155.143 354.543L155.143 349.593L152.843 349.593L152.843 354.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.805 354.543L152.105 354.543L152.105 349.593L149.805 349.593L149.805 354.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.818 354.543L149.118 354.543L149.118 349.593L146.818 349.593L146.818 354.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.931 354.96L170.231 354.96L170.231 354.51L167.931 354.51L167.931 354.96Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.943 354.96L167.243 354.96L167.243 354.51L164.943 354.51L164.943 354.96Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.906 354.96L164.206 354.96L164.206 354.51L161.906 354.51L161.906 354.96Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.868 354.96L161.168 354.96L161.168 354.51L158.868 354.51L158.868 354.96Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.881 354.96L158.181 354.96L158.181 354.51L155.881 354.51L155.881 354.96Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.843 354.96L155.143 354.96L155.143 354.51L152.843 354.51L152.843 354.96Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.805 354.96L152.105 354.96L152.105 354.51L149.805 354.51L149.805 354.96Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.818 354.96L149.118 354.96L149.118 354.51L146.818 354.51L146.818 354.96Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.182 354.96L170.482 354.96L170.482 354.51L168.182 354.51L168.182 354.96Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.144 354.96L167.444 354.96L167.444 354.51L165.144 354.51L165.144 354.96Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.157 354.96L164.457 354.96L164.457 354.51L162.157 354.51L162.157 354.96Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.119 354.96L161.419 354.96L161.419 354.51L159.119 354.51L159.119 354.96Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.132 354.96L158.432 354.96L158.432 354.51L156.132 354.51L156.132 354.96Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.094 354.96L155.394 354.96L155.394 354.51L153.094 354.51L153.094 354.96Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.056 354.96L152.356 354.96L152.356 354.51L150.056 354.51L150.056 354.96Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.069 354.96L149.369 354.96L149.369 354.51L147.069 354.51L147.069 354.96Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.806 350.352L149.156 350.352L149.156 349.602L146.806 349.602L146.806 350.352Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.783 350.14L152.133 350.14L152.133 349.59L149.783 349.59L149.783 350.14Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.827 350.352L155.177 350.352L155.177 349.602L152.827 349.602L152.827 350.352Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.865 350.406L158.215 350.406L158.215 349.606L155.865 349.606L155.865 350.406Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.853 350.14L161.203 350.14L161.203 349.59L158.853 349.59L158.853 350.14Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.89 350.05L164.24 350.05L164.24 349.6L161.89 349.6L161.89 350.05Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.894 350.31L167.244 350.31L167.244 349.56L164.894 349.56L164.894 350.31Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.916 350.307L170.266 350.307L170.266 349.607L167.916 349.607L167.916 350.307Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 348.05H138.85V356.05H143.25V348.05Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.5 354.35H140.1V354.8H141.5V354.35Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.75 354.9H139.35V355.35H140.75V354.9Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.263 348.058L172.263 348.058L172.263 347.708L143.263 347.708L143.263 348.058Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.263 347.674L172.263 347.674L172.263 347.324L143.263 347.324L143.263 347.674Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 347.7H138.6V348.05H143.25V347.7Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 347.35H138.6V347.7H143.25V347.35Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.25 347.35H138.6V348.1H143.25V347.35Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 329.801L171.795 329.801L171.795 321.801L143.245 321.801L143.245 329.801Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.032 328.251L170.332 328.251L170.332 323.301L168.032 323.301L168.032 328.251Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.994 328.251L167.294 328.251L167.294 323.301L164.994 323.301L164.994 328.251Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.006 328.251L164.306 328.251L164.306 323.301L162.006 323.301L162.006 328.251Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.969 328.251L161.269 328.251L161.269 323.301L158.969 323.301L158.969 328.251Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.981 328.251L158.281 328.251L158.281 323.301L155.981 323.301L155.981 328.251Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.944 328.251L155.244 328.251L155.244 323.301L152.944 323.301L152.944 328.251Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.906 328.251L152.206 328.251L152.206 323.301L149.906 323.301L149.906 328.251Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.918 328.251L149.218 328.251L149.218 323.301L146.918 323.301L146.918 328.251Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.931 328.251L170.231 328.251L170.231 323.301L167.931 323.301L167.931 328.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.943 328.251L167.243 328.251L167.243 323.301L164.943 323.301L164.943 328.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.906 328.251L164.206 328.251L164.206 323.301L161.906 323.301L161.906 328.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.868 328.251L161.168 328.251L161.168 323.301L158.868 323.301L158.868 328.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.881 328.251L158.181 328.251L158.181 323.301L155.881 323.301L155.881 328.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.843 328.251L155.143 328.251L155.143 323.301L152.843 323.301L152.843 328.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.805 328.251L152.105 328.251L152.105 323.301L149.805 323.301L149.805 328.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.818 328.251L149.118 328.251L149.118 323.301L146.818 323.301L146.818 328.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.931 328.718L170.231 328.718L170.231 328.268L167.931 328.268L167.931 328.718Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.943 328.718L167.243 328.718L167.243 328.268L164.943 328.268L164.943 328.718Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.906 328.718L164.206 328.718L164.206 328.268L161.906 328.268L161.906 328.718Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.868 328.718L161.168 328.718L161.168 328.268L158.868 328.268L158.868 328.718Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.881 328.718L158.181 328.718L158.181 328.268L155.881 328.268L155.881 328.718Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.843 328.718L155.143 328.718L155.143 328.268L152.843 328.268L152.843 328.718Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.805 328.718L152.105 328.718L152.105 328.268L149.805 328.268L149.805 328.718Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.818 328.718L149.118 328.718L149.118 328.268L146.818 328.268L146.818 328.718Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.182 328.718L170.482 328.718L170.482 328.268L168.182 328.268L168.182 328.718Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.144 328.718L167.444 328.718L167.444 328.268L165.144 328.268L165.144 328.718Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.157 328.718L164.457 328.718L164.457 328.268L162.157 328.268L162.157 328.718Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.119 328.718L161.419 328.718L161.419 328.268L159.119 328.268L159.119 328.718Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.132 328.718L158.432 328.718L158.432 328.268L156.132 328.268L156.132 328.718Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.094 328.718L155.394 328.718L155.394 328.268L153.094 328.268L153.094 328.718Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.056 328.718L152.356 328.718L152.356 328.268L150.056 328.268L150.056 328.718Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.069 328.718L149.369 328.718L149.369 328.268L147.069 328.268L147.069 328.718Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.806 324.81L149.156 324.81L149.156 323.31L146.806 323.31L146.806 324.81Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.783 326.522L152.133 326.522L152.133 323.322L149.783 323.322L149.783 326.522Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.827 326.228L155.177 326.228L155.177 323.328L152.827 323.328L152.827 326.228Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.865 324.916L158.215 324.916L158.215 323.316L155.865 323.316L155.865 324.916Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.853 324.385L161.203 324.385L161.203 323.335L158.853 323.335L158.853 324.385Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.89 323.758L164.24 323.758L164.24 323.308L161.89 323.308L161.89 323.758Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.928 324.81L167.278 324.81L167.278 323.31L164.928 323.31L164.928 324.81Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.916 327.042L170.266 327.042L170.266 323.292L167.916 323.292L167.916 327.042Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 321.8H138.85V329.8H143.25V321.8Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.5 328.1H140.1V328.55H141.5V328.1Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.75 328.65H139.35V329.1H140.75V328.65Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.25 328.65H140.85V329.1H142.25V328.65Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.263 321.766L172.263 321.766L172.263 321.416L143.263 321.416L143.263 321.766Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.263 321.432L172.263 321.432L172.263 321.082L143.263 321.082L143.263 321.432Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 321.45H138.6V321.8H143.25V321.45Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 321.05H138.6V321.4H143.25V321.05Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.25 321.05H138.6V321.8H143.25V321.05Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 338.565L171.795 338.565L171.795 330.565L143.245 330.565L143.245 338.565Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.032 337.015L170.332 337.015L170.332 332.065L168.032 332.065L168.032 337.015Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.994 337.015L167.294 337.015L167.294 332.065L164.994 332.065L164.994 337.015Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.006 337.015L164.306 337.015L164.306 332.065L162.006 332.065L162.006 337.015Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.969 337.015L161.269 337.015L161.269 332.065L158.969 332.065L158.969 337.015Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.981 337.015L158.281 337.015L158.281 332.065L155.981 332.065L155.981 337.015Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.944 337.015L155.244 337.015L155.244 332.065L152.944 332.065L152.944 337.015Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.906 337.015L152.206 337.015L152.206 332.065L149.906 332.065L149.906 337.015Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.918 337.015L149.218 337.015L149.218 332.065L146.918 332.065L146.918 337.015Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.931 337.015L170.231 337.015L170.231 332.065L167.931 332.065L167.931 337.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.943 337.015L167.243 337.015L167.243 332.065L164.943 332.065L164.943 337.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.906 337.015L164.206 337.015L164.206 332.065L161.906 332.065L161.906 337.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.868 337.015L161.168 337.015L161.168 332.065L158.868 332.065L158.868 337.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.881 337.015L158.181 337.015L158.181 332.065L155.881 332.065L155.881 337.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.843 337.015L155.143 337.015L155.143 332.065L152.843 332.065L152.843 337.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.805 337.015L152.105 337.015L152.105 332.065L149.805 332.065L149.805 337.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.818 337.015L149.118 337.015L149.118 332.065L146.818 332.065L146.818 337.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.931 337.432L170.231 337.432L170.231 336.982L167.931 336.982L167.931 337.432Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.943 337.432L167.243 337.432L167.243 336.982L164.943 336.982L164.943 337.432Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.906 337.432L164.206 337.432L164.206 336.982L161.906 336.982L161.906 337.432Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.868 337.432L161.168 337.432L161.168 336.982L158.868 336.982L158.868 337.432Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.881 337.432L158.181 337.432L158.181 336.982L155.881 336.982L155.881 337.432Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.843 337.432L155.143 337.432L155.143 336.982L152.843 336.982L152.843 337.432Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.805 337.432L152.105 337.432L152.105 336.982L149.805 336.982L149.805 337.432Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.818 337.432L149.118 337.432L149.118 336.982L146.818 336.982L146.818 337.432Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.182 337.432L170.482 337.432L170.482 336.982L168.182 336.982L168.182 337.432Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.144 337.432L167.444 337.432L167.444 336.982L165.144 336.982L165.144 337.432Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.157 337.432L164.457 337.432L164.457 336.982L162.157 336.982L162.157 337.432Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.119 337.432L161.419 337.432L161.419 336.982L159.119 336.982L159.119 337.432Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.132 337.432L158.432 337.432L158.432 336.982L156.132 336.982L156.132 337.432Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.094 337.432L155.394 337.432L155.394 336.982L153.094 336.982L153.094 337.432Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.056 337.432L152.356 337.432L152.356 336.982L150.056 336.982L150.056 337.432Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.069 337.432L149.369 337.432L149.369 336.982L147.069 336.982L147.069 337.432Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.806 332.824L149.156 332.824L149.156 332.074L146.806 332.074L146.806 332.824Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.783 332.612L152.133 332.612L152.133 332.062L149.783 332.062L149.783 332.612Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.827 332.824L155.177 332.824L155.177 332.074L152.827 332.074L152.827 332.824Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.865 332.878L158.215 332.878L158.215 332.078L155.865 332.078L155.865 332.878Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.853 332.612L161.203 332.612L161.203 332.062L158.853 332.062L158.853 332.612Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.89 332.522L164.24 332.522L164.24 332.072L161.89 332.072L161.89 332.522Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.894 332.832L167.244 332.832L167.244 332.082L164.894 332.082L164.894 332.832Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.916 332.779L170.266 332.779L170.266 332.079L167.916 332.079L167.916 332.779Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 330.55H138.85V338.55H143.25V330.55Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.5 336.85H140.1V337.3H141.5V336.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.75 337.4H139.35V337.85H140.75V337.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.263 330.53L172.263 330.53L172.263 330.18L143.263 330.18L143.263 330.53Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.263 330.196L172.263 330.196L172.263 329.846L143.263 329.846L143.263 330.196Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 330.2H138.6V330.55H143.25V330.2Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 329.8H138.6V330.15H143.25V329.8Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.25 329.8H138.6V330.55H143.25V329.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 364.857L171.795 364.857L171.795 356.857L143.245 356.857L143.245 364.857Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.032 363.307L170.332 363.307L170.332 358.357L168.032 358.357L168.032 363.307Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.994 363.307L167.294 363.307L167.294 358.357L164.994 358.357L164.994 363.307Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.006 363.307L164.306 363.307L164.306 358.357L162.006 358.357L162.006 363.307Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.969 363.307L161.269 363.307L161.269 358.357L158.969 358.357L158.969 363.307Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.981 363.307L158.281 363.307L158.281 358.357L155.981 358.357L155.981 363.307Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.944 363.307L155.244 363.307L155.244 358.357L152.944 358.357L152.944 363.307Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.906 363.307L152.206 363.307L152.206 358.357L149.906 358.357L149.906 363.307Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.918 363.307L149.218 363.307L149.218 358.357L146.918 358.357L146.918 363.307Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.931 363.307L170.231 363.307L170.231 358.357L167.931 358.357L167.931 363.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.943 363.307L167.243 363.307L167.243 358.357L164.943 358.357L164.943 363.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.906 363.307L164.206 363.307L164.206 358.357L161.906 358.357L161.906 363.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.868 363.307L161.168 363.307L161.168 358.357L158.868 358.357L158.868 363.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.881 363.307L158.181 363.307L158.181 358.357L155.881 358.357L155.881 363.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.843 363.307L155.143 363.307L155.143 358.357L152.843 358.357L152.843 363.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.805 363.307L152.105 363.307L152.105 358.357L149.805 358.357L149.805 363.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.818 363.307L149.118 363.307L149.118 358.357L146.818 358.357L146.818 363.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.931 363.724L170.231 363.724L170.231 363.274L167.931 363.274L167.931 363.724Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.943 363.724L167.243 363.724L167.243 363.274L164.943 363.274L164.943 363.724Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.906 363.724L164.206 363.724L164.206 363.274L161.906 363.274L161.906 363.724Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.868 363.724L161.168 363.724L161.168 363.274L158.868 363.274L158.868 363.724Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.881 363.724L158.181 363.724L158.181 363.274L155.881 363.274L155.881 363.724Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.843 363.724L155.143 363.724L155.143 363.274L152.843 363.274L152.843 363.724Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.805 363.724L152.105 363.724L152.105 363.274L149.805 363.274L149.805 363.724Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.818 363.724L149.118 363.724L149.118 363.274L146.818 363.274L146.818 363.724Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.182 363.724L170.482 363.724L170.482 363.274L168.182 363.274L168.182 363.724Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.144 363.724L167.444 363.724L167.444 363.274L165.144 363.274L165.144 363.724Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.157 363.724L164.457 363.724L164.457 363.274L162.157 363.274L162.157 363.724Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.119 363.724L161.419 363.724L161.419 363.274L159.119 363.274L159.119 363.724Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.132 363.724L158.432 363.724L158.432 363.274L156.132 363.274L156.132 363.724Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.094 363.724L155.394 363.724L155.394 363.274L153.094 363.274L153.094 363.724Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.056 363.724L152.356 363.724L152.356 363.274L150.056 363.274L150.056 363.724Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.069 363.724L149.369 363.724L149.369 363.274L147.069 363.274L147.069 363.724Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.806 360.213L149.156 360.213L149.156 358.363L146.806 358.363L146.806 360.213Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.783 359.331L152.133 359.331L152.133 358.381L149.783 358.381L149.783 359.331Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.827 359.938L155.177 359.938L155.177 358.388L152.827 358.388L152.827 359.938Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.865 360.272L158.215 360.272L158.215 358.372L155.865 358.372L155.865 360.272Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.853 359.801L161.203 359.801L161.203 358.351L158.853 358.351L158.853 359.801Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.89 359.448L164.24 359.448L164.24 358.348L161.89 358.348L161.89 359.448Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.928 358.908L167.278 358.908L167.278 358.358L164.928 358.358L164.928 358.908Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.916 359.084L170.266 359.084L170.266 358.384L167.916 358.384L167.916 359.084Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 356.8H138.85V364.8H143.25V356.8Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.75 363.65H139.35V364.1H140.75V363.65Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.25 363.65H140.85V364.1H142.25V363.65Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.263 356.822L172.263 356.822L172.263 356.472L143.263 356.472L143.263 356.822Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.263 356.438L172.263 356.438L172.263 356.088L143.263 356.088L143.263 356.438Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 356.45H138.6V356.8H143.25V356.45Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 356.1H138.6V356.45H143.25V356.1Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.25 356.1H138.6V356.85H143.25V356.1Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.245 373.621L171.795 373.621L171.795 365.621L143.245 365.621L143.245 373.621Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.032 372.071L170.332 372.071L170.332 367.121L168.032 367.121L168.032 372.071Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.994 372.071L167.294 372.071L167.294 367.121L164.994 367.121L164.994 372.071Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.006 372.071L164.306 372.071L164.306 367.121L162.006 367.121L162.006 372.071Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.969 372.071L161.269 372.071L161.269 367.121L158.969 367.121L158.969 372.071Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.981 372.071L158.281 372.071L158.281 367.121L155.981 367.121L155.981 372.071Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.944 372.071L155.244 372.071L155.244 367.121L152.944 367.121L152.944 372.071Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.906 372.071L152.206 372.071L152.206 367.121L149.906 367.121L149.906 372.071Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.918 372.071L149.218 372.071L149.218 367.121L146.918 367.121L146.918 372.071Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.931 372.071L170.231 372.071L170.231 367.121L167.931 367.121L167.931 372.071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.943 372.071L167.243 372.071L167.243 367.121L164.943 367.121L164.943 372.071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.906 372.071L164.206 372.071L164.206 367.121L161.906 367.121L161.906 372.071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.868 372.071L161.168 372.071L161.168 367.121L158.868 367.121L158.868 372.071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.881 372.071L158.181 372.071L158.181 367.121L155.881 367.121L155.881 372.071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.843 372.071L155.143 372.071L155.143 367.121L152.843 367.121L152.843 372.071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.805 372.071L152.105 372.071L152.105 367.121L149.805 367.121L149.805 372.071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.818 372.071L149.118 372.071L149.118 367.121L146.818 367.121L146.818 372.071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.931 372.488L170.231 372.488L170.231 372.038L167.931 372.038L167.931 372.488Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.943 372.488L167.243 372.488L167.243 372.038L164.943 372.038L164.943 372.488Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.906 372.488L164.206 372.488L164.206 372.038L161.906 372.038L161.906 372.488Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.868 372.488L161.168 372.488L161.168 372.038L158.868 372.038L158.868 372.488Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.881 372.488L158.181 372.488L158.181 372.038L155.881 372.038L155.881 372.488Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.843 372.488L155.143 372.488L155.143 372.038L152.843 372.038L152.843 372.488Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.805 372.488L152.105 372.488L152.105 372.038L149.805 372.038L149.805 372.488Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.818 372.488L149.118 372.488L149.118 372.038L146.818 372.038L146.818 372.488Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.182 372.488L170.482 372.488L170.482 372.038L168.182 372.038L168.182 372.488Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.144 372.488L167.444 372.488L167.444 372.038L165.144 372.038L165.144 372.488Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.157 372.488L164.457 372.488L164.457 372.038L162.157 372.038L162.157 372.488Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.119 372.488L161.419 372.488L161.419 372.038L159.119 372.038L159.119 372.488Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.132 372.488L158.432 372.488L158.432 372.038L156.132 372.038L156.132 372.488Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.094 372.488L155.394 372.488L155.394 372.038L153.094 372.038L153.094 372.488Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.056 372.488L152.356 372.488L152.356 372.038L150.056 372.038L150.056 372.488Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.069 372.488L149.369 372.488L149.369 372.038L147.069 372.038L147.069 372.488Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.806 368.63L149.156 368.63L149.156 367.13L146.806 367.13L146.806 368.63Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.783 370.342L152.133 370.342L152.133 367.142L149.783 367.142L149.783 370.342Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.827 370.048L155.177 370.048L155.177 367.148L152.827 367.148L152.827 370.048Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.865 368.736L158.215 368.736L158.215 367.136L155.865 367.136L155.865 368.736Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.853 368.205L161.203 368.205L161.203 367.155L158.853 367.155L158.853 368.205Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.89 367.578L164.24 367.578L164.24 367.128L161.89 367.128L161.89 367.578Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.928 368.63L167.278 368.63L167.278 367.13L164.928 367.13L164.928 368.63Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.916 370.861L170.266 370.861L170.266 367.111L167.916 367.111L167.916 370.861Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 365.55H138.85V373.55H143.25V365.55Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.5 371.85H140.1V372.3H141.5V371.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.75 372.45H139.35V372.9H140.75V372.45Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.25 372.45H140.85V372.9H142.25V372.45Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.263 365.586L172.263 365.586L172.263 365.236L143.263 365.236L143.263 365.586Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.263 365.202L172.263 365.202L172.263 364.852L143.263 364.852L143.263 365.202Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 365.2H138.6V365.55H143.25V365.2Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.25 364.85H138.6V365.2H143.25V364.85Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.25 364.85H138.6V365.6H143.25V364.85Z",
    fill: "black"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.652 336.459L205.052 336.459L205.052 328.759L177.652 328.759L177.652 336.459Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.454 335.009L203.654 335.009L203.654 330.259L201.454 330.259L201.454 335.009Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.558 335.009L200.758 335.009L200.758 330.259L198.558 330.259L198.558 335.009Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.662 335.009L197.862 335.009L197.862 330.259L195.662 330.259L195.662 335.009Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.766 335.009L194.966 335.009L194.966 330.259L192.766 330.259L192.766 335.009Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.87 335.009L192.07 335.009L192.07 330.259L189.87 330.259L189.87 335.009Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.975 335.009L189.175 335.009L189.175 330.259L186.975 330.259L186.975 335.009Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.079 335.009L186.279 335.009L186.279 330.259L184.079 330.259L184.079 335.009Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.183 335.009L183.383 335.009L183.383 330.259L181.183 330.259L181.183 335.009Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.362 335.009L203.562 335.009L203.562 330.259L201.362 330.259L201.362 335.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.466 335.009L200.666 335.009L200.666 330.259L198.466 330.259L198.466 335.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.57 335.009L197.77 335.009L197.77 330.259L195.57 330.259L195.57 335.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.674 335.009L194.874 335.009L194.874 330.259L192.674 330.259L192.674 335.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.779 335.009L191.979 335.009L191.979 330.259L189.779 330.259L189.779 335.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.883 335.009L189.083 335.009L189.083 330.259L186.883 330.259L186.883 335.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.987 335.009L186.187 335.009L186.187 330.259L183.987 330.259L183.987 335.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.091 335.009L183.291 335.009L183.291 330.259L181.091 330.259L181.091 335.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.362 335.412L203.562 335.412L203.562 335.012L201.362 335.012L201.362 335.412Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.466 335.412L200.666 335.412L200.666 335.012L198.466 335.012L198.466 335.412Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.57 335.412L197.77 335.412L197.77 335.012L195.57 335.012L195.57 335.412Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.674 335.412L194.874 335.412L194.874 335.012L192.674 335.012L192.674 335.412Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.779 335.412L191.979 335.412L191.979 335.012L189.779 335.012L189.779 335.412Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.883 335.412L189.083 335.412L189.083 335.012L186.883 335.012L186.883 335.412Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.987 335.412L186.187 335.412L186.187 335.012L183.987 335.012L183.987 335.412Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.091 335.412L183.291 335.412L183.291 335.012L181.091 335.012L181.091 335.412Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.593 335.412L203.793 335.412L203.793 335.012L201.593 335.012L201.593 335.412Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.697 335.412L200.897 335.412L200.897 335.012L198.697 335.012L198.697 335.412Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.801 335.412L198.001 335.412L198.001 335.012L195.801 335.012L195.801 335.412Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.905 335.412L195.105 335.412L195.105 335.012L192.905 335.012L192.905 335.412Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.009 335.412L192.209 335.412L192.209 335.012L190.009 335.012L190.009 335.412Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.113 335.412L189.313 335.412L189.313 335.012L187.113 335.012L187.113 335.412Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.217 335.412L186.417 335.412L186.417 335.012L184.217 335.012L184.217 335.412Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.321 335.412L183.521 335.412L183.521 335.012L181.321 335.012L181.321 335.412Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.076 331.706L183.326 331.706L183.326 330.256L181.076 330.256L181.076 331.706Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.963 333.35L186.213 333.35L186.213 330.25L183.963 330.25L183.963 333.35Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.865 333.067L189.115 333.067L189.115 330.267L186.865 330.267L186.865 333.067Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.761 331.808L192.011 331.808L192.011 330.258L189.761 330.258L189.761 331.808Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.657 331.299L194.907 331.299L194.907 330.249L192.657 330.249L192.657 331.299Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.553 330.696L197.803 330.696L197.803 330.246L195.553 330.246L195.553 330.696Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.448 331.706L200.698 331.706L200.698 330.256L198.448 330.256L198.448 331.706Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.344 333.848L203.594 333.848L203.594 330.248L201.344 330.248L201.344 333.848Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.65 328.8H173.45V336.5H177.65V328.8Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.951 334.8H174.601V335.25H175.951V334.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.25 335.35H173.9V335.8H175.25V335.35Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.701 335.35H175.351V335.8H176.701V335.35Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.651 328.76L205.501 328.76L205.501 328.41L177.651 328.41L177.651 328.76Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.651 328.455L205.501 328.455L205.501 328.105L177.651 328.105L177.651 328.455Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.6 328.45H173.15V328.8H177.6V328.45Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.6 328.05H173.15V328.4H177.6V328.05Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.6 328.05H173.15V328.75H177.6V328.05Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.652 344.872L205.052 344.872L205.052 337.172L177.652 337.172L177.652 344.872Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.454 343.422L203.654 343.422L203.654 338.672L201.454 338.672L201.454 343.422Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.558 343.422L200.758 343.422L200.758 338.672L198.558 338.672L198.558 343.422Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.662 343.422L197.862 343.422L197.862 338.672L195.662 338.672L195.662 343.422Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.766 343.422L194.966 343.422L194.966 338.672L192.766 338.672L192.766 343.422Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.87 343.422L192.07 343.422L192.07 338.672L189.87 338.672L189.87 343.422Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.975 343.422L189.175 343.422L189.175 338.672L186.975 338.672L186.975 343.422Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.079 343.422L186.279 343.422L186.279 338.672L184.079 338.672L184.079 343.422Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.183 343.422L183.383 343.422L183.383 338.672L181.183 338.672L181.183 343.422Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.362 343.422L203.562 343.422L203.562 338.672L201.362 338.672L201.362 343.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.466 343.422L200.666 343.422L200.666 338.672L198.466 338.672L198.466 343.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.57 343.422L197.77 343.422L197.77 338.672L195.57 338.672L195.57 343.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.674 343.422L194.874 343.422L194.874 338.672L192.674 338.672L192.674 343.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.779 343.422L191.979 343.422L191.979 338.672L189.779 338.672L189.779 343.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.883 343.422L189.083 343.422L189.083 338.672L186.883 338.672L186.883 343.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.987 343.422L186.187 343.422L186.187 338.672L183.987 338.672L183.987 343.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.091 343.422L183.291 343.422L183.291 338.672L181.091 338.672L181.091 343.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.362 343.825L203.562 343.825L203.562 343.425L201.362 343.425L201.362 343.825Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.466 343.825L200.666 343.825L200.666 343.425L198.466 343.425L198.466 343.825Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.57 343.825L197.77 343.825L197.77 343.425L195.57 343.425L195.57 343.825Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.674 343.825L194.874 343.825L194.874 343.425L192.674 343.425L192.674 343.825Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.779 343.825L191.979 343.825L191.979 343.425L189.779 343.425L189.779 343.825Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.883 343.825L189.083 343.825L189.083 343.425L186.883 343.425L186.883 343.825Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.987 343.825L186.187 343.825L186.187 343.425L183.987 343.425L183.987 343.825Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.091 343.825L183.291 343.825L183.291 343.425L181.091 343.425L181.091 343.825Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.593 343.825L203.793 343.825L203.793 343.425L201.593 343.425L201.593 343.825Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.697 343.825L200.897 343.825L200.897 343.425L198.697 343.425L198.697 343.825Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.801 343.825L198.001 343.825L198.001 343.425L195.801 343.425L195.801 343.825Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.905 343.825L195.105 343.825L195.105 343.425L192.905 343.425L192.905 343.825Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.009 343.825L192.209 343.825L192.209 343.425L190.009 343.425L190.009 343.825Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.113 343.825L189.313 343.825L189.313 343.425L187.113 343.425L187.113 343.825Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.217 343.825L186.417 343.825L186.417 343.425L184.217 343.425L184.217 343.825Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.321 343.825L183.521 343.825L183.521 343.425L181.321 343.425L181.321 343.825Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.076 339.399L183.326 339.399L183.326 338.699L181.076 338.699L181.076 339.399Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.963 339.196L186.213 339.196L186.213 338.696L183.963 338.696L183.963 339.196Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.865 339.399L189.115 339.399L189.115 338.699L186.865 338.699L186.865 339.399Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.761 339.451L192.011 339.451L192.011 338.701L189.761 338.701L189.761 339.451Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.657 339.196L194.907 339.196L194.907 338.696L192.657 338.696L192.657 339.196Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.553 339.109L197.803 339.109L197.803 338.659L195.553 338.659L195.553 339.109Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.416 339.358L200.666 339.358L200.666 338.658L198.416 338.658L198.416 339.358Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.344 339.355L203.594 339.355L203.594 338.655L201.344 338.655L201.344 339.355Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.65 337.2H173.45V344.9H177.65V337.2Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.951 343.25H174.601V343.7H175.951V343.25Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.25 343.75H173.9V344.2H175.25V343.75Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.651 337.173L205.501 337.173L205.501 336.823L177.651 336.823L177.651 337.173Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.651 336.818L205.501 336.818L205.501 336.468L177.651 336.468L177.651 336.818Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.6 336.85H173.15V337.2H177.6V336.85Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.6 336.5H173.15V336.85H177.6V336.5Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.6 336.5H173.15V337.2H177.6V336.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.652 319.683L205.052 319.683L205.052 311.983L177.652 311.983L177.652 319.683Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.454 318.183L203.654 318.183L203.654 313.433L201.454 313.433L201.454 318.183Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.558 318.183L200.758 318.183L200.758 313.433L198.558 313.433L198.558 318.183Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.662 318.183L197.862 318.183L197.862 313.433L195.662 313.433L195.662 318.183Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.766 318.183L194.966 318.183L194.966 313.433L192.766 313.433L192.766 318.183Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.87 318.183L192.07 318.183L192.07 313.433L189.87 313.433L189.87 318.183Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.975 318.183L189.175 318.183L189.175 313.433L186.975 313.433L186.975 318.183Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.079 318.183L186.279 318.183L186.279 313.433L184.079 313.433L184.079 318.183Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.183 318.183L183.383 318.183L183.383 313.433L181.183 313.433L181.183 318.183Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.362 318.183L203.562 318.183L203.562 313.433L201.362 313.433L201.362 318.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.466 318.183L200.666 318.183L200.666 313.433L198.466 313.433L198.466 318.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.57 318.183L197.77 318.183L197.77 313.433L195.57 313.433L195.57 318.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.674 318.183L194.874 318.183L194.874 313.433L192.674 313.433L192.674 318.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.779 318.183L191.979 318.183L191.979 313.433L189.779 313.433L189.779 318.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.883 318.183L189.083 318.183L189.083 313.433L186.883 313.433L186.883 318.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.987 318.183L186.187 318.183L186.187 313.433L183.987 313.433L183.987 318.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.091 318.183L183.291 318.183L183.291 313.433L181.091 313.433L181.091 318.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.362 318.586L203.562 318.586L203.562 318.186L201.362 318.186L201.362 318.586Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.466 318.586L200.666 318.586L200.666 318.186L198.466 318.186L198.466 318.586Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.57 318.586L197.77 318.586L197.77 318.186L195.57 318.186L195.57 318.586Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.674 318.586L194.874 318.586L194.874 318.186L192.674 318.186L192.674 318.586Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.779 318.586L191.979 318.586L191.979 318.186L189.779 318.186L189.779 318.586Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.883 318.586L189.083 318.586L189.083 318.186L186.883 318.186L186.883 318.586Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.987 318.586L186.187 318.586L186.187 318.186L183.987 318.186L183.987 318.586Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.091 318.586L183.291 318.586L183.291 318.186L181.091 318.186L181.091 318.586Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.593 318.586L203.793 318.586L203.793 318.186L201.593 318.186L201.593 318.586Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.697 318.586L200.897 318.586L200.897 318.186L198.697 318.186L198.697 318.586Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.801 318.586L198.001 318.586L198.001 318.186L195.801 318.186L195.801 318.586Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.905 318.586L195.105 318.586L195.105 318.186L192.905 318.186L192.905 318.586Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.009 318.586L192.209 318.586L192.209 318.186L190.009 318.186L190.009 318.586Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.113 318.586L189.313 318.586L189.313 318.186L187.113 318.186L187.113 318.586Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.217 318.586L186.417 318.586L186.417 318.186L184.217 318.186L184.217 318.586Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.321 318.586L183.521 318.586L183.521 318.186L181.321 318.186L181.321 318.586Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.076 314.88L183.326 314.88L183.326 313.43L181.076 313.43L181.076 314.88Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.963 316.524L186.213 316.524L186.213 313.424L183.963 313.424L183.963 316.524Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.865 316.242L189.115 316.242L189.115 313.442L186.865 313.442L186.865 316.242Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.761 314.983L192.011 314.983L192.011 313.433L189.761 313.433L189.761 314.983Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.657 314.473L194.907 314.473L194.907 313.423L192.657 313.423L192.657 314.473Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.553 313.87L197.803 313.87L197.803 313.421L195.553 313.421L195.553 313.87Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.448 314.88L200.698 314.88L200.698 313.43L198.448 313.43L198.448 314.88Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.344 317.023L203.594 317.023L203.594 313.423L201.344 313.423L201.344 317.023Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.65 311.95H173.45V319.65H177.65V311.95Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.951 318H174.601V318.45H175.951V318Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.25 318.55H173.9V319H175.25V318.55Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.701 318.55H175.351V319H176.701V318.55Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.651 311.984L205.501 311.984L205.501 311.634L177.651 311.634L177.651 311.984Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.651 311.63L205.501 311.63L205.501 311.28L177.651 311.28L177.651 311.63Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.6 311.6H173.15V311.95H177.6V311.6Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.6 311.25H173.15V311.6H177.6V311.25Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.6 311.25H173.15V311.95H177.6V311.25Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.652 328.096L205.052 328.096L205.052 320.396L177.652 320.396L177.652 328.096Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.454 326.596L203.654 326.596L203.654 321.846L201.454 321.846L201.454 326.596Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.558 326.596L200.758 326.596L200.758 321.846L198.558 321.846L198.558 326.596Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.662 326.596L197.862 326.596L197.862 321.846L195.662 321.846L195.662 326.596Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.766 326.596L194.966 326.596L194.966 321.846L192.766 321.846L192.766 326.596Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.87 326.596L192.07 326.596L192.07 321.846L189.87 321.846L189.87 326.596Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.975 326.596L189.175 326.596L189.175 321.846L186.975 321.846L186.975 326.596Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.079 326.596L186.279 326.596L186.279 321.846L184.079 321.846L184.079 326.596Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.183 326.596L183.383 326.596L183.383 321.846L181.183 321.846L181.183 326.596Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.362 326.596L203.562 326.596L203.562 321.846L201.362 321.846L201.362 326.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.466 326.596L200.666 326.596L200.666 321.846L198.466 321.846L198.466 326.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.57 326.596L197.77 326.596L197.77 321.846L195.57 321.846L195.57 326.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.674 326.596L194.874 326.596L194.874 321.846L192.674 321.846L192.674 326.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.779 326.596L191.979 326.596L191.979 321.846L189.779 321.846L189.779 326.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.883 326.596L189.083 326.596L189.083 321.846L186.883 321.846L186.883 326.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.987 326.596L186.187 326.596L186.187 321.846L183.987 321.846L183.987 326.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.091 326.596L183.291 326.596L183.291 321.846L181.091 321.846L181.091 326.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.362 326.999L203.562 326.999L203.562 326.599L201.362 326.599L201.362 326.999Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.466 326.999L200.666 326.999L200.666 326.599L198.466 326.599L198.466 326.999Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.57 326.999L197.77 326.999L197.77 326.599L195.57 326.599L195.57 326.999Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.674 326.999L194.874 326.999L194.874 326.599L192.674 326.599L192.674 326.999Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.779 326.999L191.979 326.999L191.979 326.599L189.779 326.599L189.779 326.999Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.883 326.999L189.083 326.999L189.083 326.599L186.883 326.599L186.883 326.999Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.987 326.999L186.187 326.999L186.187 326.599L183.987 326.599L183.987 326.999Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.091 326.999L183.291 326.999L183.291 326.599L181.091 326.599L181.091 326.999Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.593 326.999L203.793 326.999L203.793 326.599L201.593 326.599L201.593 326.999Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.697 326.999L200.897 326.999L200.897 326.599L198.697 326.599L198.697 326.999Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.801 326.999L198.001 326.999L198.001 326.599L195.801 326.599L195.801 326.999Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.905 326.999L195.105 326.999L195.105 326.599L192.905 326.599L192.905 326.999Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.009 326.999L192.209 326.999L192.209 326.599L190.009 326.599L190.009 326.999Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.113 326.999L189.313 326.999L189.313 326.599L187.113 326.599L187.113 326.999Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.217 326.999L186.417 326.999L186.417 326.599L184.217 326.599L184.217 326.999Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.321 326.999L183.521 326.999L183.521 326.599L181.321 326.599L181.321 326.999Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.076 322.574L183.326 322.574L183.326 321.874L181.076 321.874L181.076 322.574Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.963 322.37L186.213 322.37L186.213 321.87L183.963 321.87L183.963 322.37Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.865 322.574L189.115 322.574L189.115 321.874L186.865 321.874L186.865 322.574Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.761 322.625L192.011 322.625L192.011 321.875L189.761 321.875L189.761 322.625Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.657 322.37L194.907 322.37L194.907 321.87L192.657 321.87L192.657 322.37Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.553 322.283L197.803 322.283L197.803 321.833L195.553 321.833L195.553 322.283Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.416 322.533L200.666 322.533L200.666 321.833L198.416 321.833L198.416 322.533Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.344 322.53L203.594 322.53L203.594 321.83L201.344 321.83L201.344 322.53Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.65 320.35H173.45V328.05H177.65V320.35Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.951 326.4H174.601V326.85H175.951V326.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.25 326.95H173.9V327.4H175.25V326.95Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.651 320.397L205.501 320.397L205.501 320.047L177.651 320.047L177.651 320.397Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.651 320.042L205.501 320.042L205.501 319.692L177.651 319.692L177.651 320.042Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.6 320H173.15V320.35H177.6V320Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.6 319.65H173.15V320H177.6V319.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.6 319.65H173.15V320.35H177.6V319.65Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.652 353.285L205.052 353.285L205.052 345.585L177.652 345.585L177.652 353.285Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.454 351.835L203.654 351.835L203.654 347.085L201.454 347.085L201.454 351.835Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.558 351.835L200.758 351.835L200.758 347.085L198.558 347.085L198.558 351.835Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.662 351.835L197.862 351.835L197.862 347.085L195.662 347.085L195.662 351.835Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.766 351.835L194.966 351.835L194.966 347.085L192.766 347.085L192.766 351.835Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.87 351.835L192.07 351.835L192.07 347.085L189.87 347.085L189.87 351.835Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.975 351.835L189.175 351.835L189.175 347.085L186.975 347.085L186.975 351.835Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.079 351.835L186.279 351.835L186.279 347.085L184.079 347.085L184.079 351.835Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.183 351.835L183.383 351.835L183.383 347.085L181.183 347.085L181.183 351.835Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.362 351.835L203.562 351.835L203.562 347.085L201.362 347.085L201.362 351.835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.466 351.835L200.666 351.835L200.666 347.085L198.466 347.085L198.466 351.835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.57 351.835L197.77 351.835L197.77 347.085L195.57 347.085L195.57 351.835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.674 351.835L194.874 351.835L194.874 347.085L192.674 347.085L192.674 351.835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.779 351.835L191.979 351.835L191.979 347.085L189.779 347.085L189.779 351.835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.883 351.835L189.083 351.835L189.083 347.085L186.883 347.085L186.883 351.835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.987 351.835L186.187 351.835L186.187 347.085L183.987 347.085L183.987 351.835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.091 351.835L183.291 351.835L183.291 347.085L181.091 347.085L181.091 351.835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.362 352.238L203.562 352.238L203.562 351.838L201.362 351.838L201.362 352.238Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.466 352.238L200.666 352.238L200.666 351.838L198.466 351.838L198.466 352.238Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.57 352.238L197.77 352.238L197.77 351.838L195.57 351.838L195.57 352.238Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.674 352.238L194.874 352.238L194.874 351.838L192.674 351.838L192.674 352.238Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.779 352.238L191.979 352.238L191.979 351.838L189.779 351.838L189.779 352.238Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.883 352.238L189.083 352.238L189.083 351.838L186.883 351.838L186.883 352.238Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.987 352.238L186.187 352.238L186.187 351.838L183.987 351.838L183.987 352.238Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.091 352.238L183.291 352.238L183.291 351.838L181.091 351.838L181.091 352.238Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.593 352.238L203.793 352.238L203.793 351.838L201.593 351.838L201.593 352.238Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.697 352.238L200.897 352.238L200.897 351.838L198.697 351.838L198.697 352.238Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.801 352.238L198.001 352.238L198.001 351.838L195.801 351.838L195.801 352.238Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.905 352.238L195.105 352.238L195.105 351.838L192.905 351.838L192.905 352.238Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.009 352.238L192.209 352.238L192.209 351.838L190.009 351.838L190.009 352.238Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.113 352.238L189.313 352.238L189.313 351.838L187.113 351.838L187.113 352.238Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.217 352.238L186.417 352.238L186.417 351.838L184.217 351.838L184.217 352.238Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.321 352.238L183.521 352.238L183.521 351.838L181.321 351.838L181.321 352.238Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.076 348.865L183.326 348.865L183.326 347.115L181.076 347.115L181.076 348.865Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.963 348.018L186.213 348.018L186.213 347.068L183.963 347.068L183.963 348.018Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.865 348.602L189.115 348.602L189.115 347.102L186.865 347.102L186.865 348.602Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.761 348.922L192.011 348.922L192.011 347.072L189.761 347.072L189.761 348.922Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.657 348.47L194.907 348.47L194.907 347.07L192.657 347.07L192.657 348.47Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.553 348.131L197.803 348.131L197.803 347.081L195.553 347.081L195.553 348.131Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.448 347.612L200.698 347.612L200.698 347.112L198.448 347.112L198.448 347.612Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.344 347.781L203.594 347.781L203.594 347.081L201.344 347.081L201.344 347.781Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.65 345.6H173.45V353.3H177.65V345.6Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.25 352.15H173.9V352.6H175.25V352.15Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.701 352.15H175.351V352.6H176.701V352.15Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.651 345.586L205.501 345.586L205.501 345.236L177.651 345.236L177.651 345.586Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.651 345.231L205.501 345.231L205.501 344.881L177.651 344.881L177.651 345.231Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.6 345.25H173.15V345.6H177.6V345.25Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.6 344.9H173.15V345.25H177.6V344.9Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.6 344.9H173.15V345.6H177.6V344.9Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.652 361.698L205.052 361.698L205.052 353.998L177.652 353.998L177.652 361.698Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.454 360.198L203.654 360.198L203.654 355.448L201.454 355.448L201.454 360.198Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.558 360.198L200.758 360.198L200.758 355.448L198.558 355.448L198.558 360.198Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.662 360.198L197.862 360.198L197.862 355.448L195.662 355.448L195.662 360.198Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.766 360.198L194.966 360.198L194.966 355.448L192.766 355.448L192.766 360.198Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.87 360.198L192.07 360.198L192.07 355.448L189.87 355.448L189.87 360.198Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.975 360.198L189.175 360.198L189.175 355.448L186.975 355.448L186.975 360.198Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.079 360.198L186.279 360.198L186.279 355.448L184.079 355.448L184.079 360.198Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.183 360.198L183.383 360.198L183.383 355.448L181.183 355.448L181.183 360.198Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.362 360.198L203.562 360.198L203.562 355.448L201.362 355.448L201.362 360.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.466 360.198L200.666 360.198L200.666 355.448L198.466 355.448L198.466 360.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.57 360.198L197.77 360.198L197.77 355.448L195.57 355.448L195.57 360.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.674 360.198L194.874 360.198L194.874 355.448L192.674 355.448L192.674 360.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.779 360.198L191.979 360.198L191.979 355.448L189.779 355.448L189.779 360.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.883 360.198L189.083 360.198L189.083 355.448L186.883 355.448L186.883 360.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.987 360.198L186.187 360.198L186.187 355.448L183.987 355.448L183.987 360.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.091 360.198L183.291 360.198L183.291 355.448L181.091 355.448L181.091 360.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.362 360.65L203.562 360.65L203.562 360.25L201.362 360.25L201.362 360.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.466 360.65L200.666 360.65L200.666 360.25L198.466 360.25L198.466 360.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.57 360.65L197.77 360.65L197.77 360.25L195.57 360.25L195.57 360.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.674 360.65L194.874 360.65L194.874 360.25L192.674 360.25L192.674 360.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.779 360.65L191.979 360.65L191.979 360.25L189.779 360.25L189.779 360.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.883 360.65L189.083 360.65L189.083 360.25L186.883 360.25L186.883 360.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.987 360.65L186.187 360.65L186.187 360.25L183.987 360.25L183.987 360.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.091 360.65L183.291 360.65L183.291 360.25L181.091 360.25L181.091 360.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.593 360.65L203.793 360.65L203.793 360.25L201.593 360.25L201.593 360.65Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.697 360.65L200.897 360.65L200.897 360.25L198.697 360.25L198.697 360.65Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.801 360.65L198.001 360.65L198.001 360.25L195.801 360.25L195.801 360.65Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.905 360.65L195.105 360.65L195.105 360.25L192.905 360.25L192.905 360.65Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.009 360.65L192.209 360.65L192.209 360.25L190.009 360.25L190.009 360.65Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.113 360.65L189.313 360.65L189.313 360.25L187.113 360.25L187.113 360.65Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.217 360.65L186.417 360.65L186.417 360.25L184.217 360.25L184.217 360.65Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.321 360.65L183.521 360.65L183.521 360.25L181.321 360.25L181.321 360.65Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.076 356.895L183.326 356.895L183.326 355.445L181.076 355.445L181.076 356.895Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.963 358.538L186.213 358.538L186.213 355.438L183.963 355.438L183.963 358.538Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.865 358.256L189.115 358.256L189.115 355.456L186.865 355.456L186.865 358.256Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.761 356.997L192.011 356.997L192.011 355.447L189.761 355.447L189.761 356.997Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.657 356.487L194.907 356.487L194.907 355.437L192.657 355.437L192.657 356.487Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.553 355.885L197.803 355.885L197.803 355.435L195.553 355.435L195.553 355.885Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.448 356.895L200.698 356.895L200.698 355.445L198.448 355.445L198.448 356.895Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.344 359.037L203.594 359.037L203.594 355.437L201.344 355.437L201.344 359.037Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.65 354H173.45V361.7H177.65V354Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.951 360.05H174.601V360.5H175.951V360.05Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.25 360.6H173.9V361.05H175.25V360.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.701 360.6H175.351V361.05H176.701V360.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.651 353.999L205.501 353.999L205.501 353.649L177.651 353.649L177.651 353.999Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.651 353.644L205.501 353.644L205.501 353.294L177.651 353.294L177.651 353.644Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.6 353.65H173.15V354H177.6V353.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.6 353.3H173.15V353.65H177.6V353.3Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.6 353.3H173.15V354H177.6V353.3Z",
    fill: "black"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.987 358.008L251.987 358.008L251.987 352.658L232.987 352.658L232.987 358.008Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.497 357.009L250.997 357.009L250.997 353.709L249.497 353.709L249.497 357.009Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.484 357.009L248.984 357.009L248.984 353.709L247.484 353.709L247.484 357.009Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.521 357.009L247.021 357.009L247.021 353.709L245.521 353.709L245.521 357.009Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.508 357.009L245.008 357.009L245.008 353.709L243.508 353.709L243.508 357.009Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.496 357.009L242.996 357.009L242.996 353.709L241.496 353.709L241.496 357.009Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.483 357.009L240.983 357.009L240.983 353.709L239.483 353.709L239.483 357.009Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.47 357.009L238.97 357.009L238.97 353.709L237.47 353.709L237.47 357.009Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.458 357.009L236.958 357.009L236.958 353.709L235.458 353.709L235.458 357.009Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 357.009L250.963 357.009L250.963 353.709L249.463 353.709L249.463 357.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 357.009L248.951 357.009L248.951 353.709L247.451 353.709L247.451 357.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 357.009L246.938 357.009L246.938 353.709L245.438 353.709L245.438 357.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 357.009L244.925 357.009L244.925 353.709L243.425 353.709L243.425 357.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 357.009L242.913 357.009L242.913 353.709L241.413 353.709L241.413 357.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 357.009L240.9 357.009L240.9 353.709L239.4 353.709L239.4 357.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 357.009L238.887 357.009L238.887 353.709L237.387 353.709L237.387 357.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 357.009L236.924 357.009L236.924 353.709L235.424 353.709L235.424 357.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 357.276L250.963 357.276L250.963 356.976L249.463 356.976L249.463 357.276Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 357.276L248.951 357.276L248.951 356.976L247.451 356.976L247.451 357.276Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 357.276L246.938 357.276L246.938 356.976L245.438 356.976L245.438 357.276Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 357.276L244.925 357.276L244.925 356.976L243.425 356.976L243.425 357.276Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 357.276L242.913 357.276L242.913 356.976L241.413 356.976L241.413 357.276Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 357.276L240.9 357.276L240.9 356.976L239.4 356.976L239.4 357.276Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 357.276L238.887 357.276L238.887 356.976L237.387 356.976L237.387 357.276Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 357.276L236.924 357.276L236.924 356.976L235.424 356.976L235.424 357.276Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.596 357.276L251.096 357.276L251.096 356.976L249.596 356.976L249.596 357.276Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.583 357.276L249.083 357.276L249.083 356.976L247.583 356.976L247.583 357.276Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.621 357.276L247.121 357.276L247.121 356.976L245.621 356.976L245.621 357.276Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.608 357.276L245.108 357.276L245.108 356.976L243.608 356.976L243.608 357.276Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.595 357.276L243.095 357.276L243.095 356.976L241.595 356.976L241.595 357.276Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.583 357.276L241.083 357.276L241.083 356.976L239.583 356.976L239.583 357.276Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57 357.276L239.07 357.276L239.07 356.976L237.57 356.976L237.57 357.276Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.557 357.276L237.057 357.276L237.057 356.976L235.557 356.976L235.557 357.276Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.399 354.722L236.949 354.722L236.949 353.722L235.399 353.722L235.399 354.722Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.355 355.86L238.905 355.86L238.905 353.71L237.355 353.71L237.355 355.86Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.372 355.664L240.922 355.664L240.922 353.714L239.372 353.714L239.372 355.664Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.385 354.792L242.935 354.792L242.935 353.742L241.385 353.742L241.385 354.792Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.398 354.44L244.948 354.44L244.948 353.74L243.398 353.74L243.398 354.44Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.41 354.023L246.96 354.023L246.96 353.723L245.41 353.723L245.41 354.023Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.423 354.722L248.973 354.722L248.973 353.722L247.423 353.722L247.423 354.722Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.436 356.205L250.986 356.205L250.986 353.705L249.436 353.705L249.436 356.205Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.001 352.7H230.101V358.05H233.001V352.7Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.85 356.85H230.9V357.15H231.85V356.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.35 357.25H230.4V357.55H231.35V357.25Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.35 357.25H231.4V357.55H232.35V357.25Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 352.686L252.297 352.686L252.297 352.436L232.997 352.436L232.997 352.686Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 352.448L252.297 352.448L252.297 352.198L232.997 352.198L232.997 352.448Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 352.45H229.9V352.7H233V352.45Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 352.2H229.9V352.45H233V352.2Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 352.2H229.9V352.7H233V352.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.987 363.849L251.987 363.849L251.987 358.499L232.987 358.499L232.987 363.849Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.497 362.799L250.997 362.799L250.997 359.499L249.497 359.499L249.497 362.799Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.484 362.799L248.984 362.799L248.984 359.499L247.484 359.499L247.484 362.799Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.521 362.799L247.021 362.799L247.021 359.499L245.521 359.499L245.521 362.799Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.508 362.799L245.008 362.799L245.008 359.499L243.508 359.499L243.508 362.799Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.496 362.799L242.996 362.799L242.996 359.499L241.496 359.499L241.496 362.799Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.483 362.799L240.983 362.799L240.983 359.499L239.483 359.499L239.483 362.799Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.47 362.799L238.97 362.799L238.97 359.499L237.47 359.499L237.47 362.799Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.458 362.799L236.958 362.799L236.958 359.499L235.458 359.499L235.458 362.799Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 362.799L250.963 362.799L250.963 359.499L249.463 359.499L249.463 362.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 362.799L248.951 362.799L248.951 359.499L247.451 359.499L247.451 362.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 362.799L246.938 362.799L246.938 359.499L245.438 359.499L245.438 362.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 362.799L244.925 362.799L244.925 359.499L243.425 359.499L243.425 362.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 362.799L242.913 362.799L242.913 359.499L241.413 359.499L241.413 362.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 362.799L240.9 362.799L240.9 359.499L239.4 359.499L239.4 362.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 362.799L238.887 362.799L238.887 359.499L237.387 359.499L237.387 362.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 362.799L236.924 362.799L236.924 359.499L235.424 359.499L235.424 362.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 363.116L250.963 363.116L250.963 362.816L249.463 362.816L249.463 363.116Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 363.116L248.951 363.116L248.951 362.816L247.451 362.816L247.451 363.116Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 363.116L246.938 363.116L246.938 362.816L245.438 362.816L245.438 363.116Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 363.116L244.925 363.116L244.925 362.816L243.425 362.816L243.425 363.116Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 363.116L242.913 363.116L242.913 362.816L241.413 362.816L241.413 363.116Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 363.116L240.9 363.116L240.9 362.816L239.4 362.816L239.4 363.116Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 363.116L238.887 363.116L238.887 362.816L237.387 362.816L237.387 363.116Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 363.116L236.924 363.116L236.924 362.816L235.424 362.816L235.424 363.116Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.596 363.116L251.096 363.116L251.096 362.816L249.596 362.816L249.596 363.116Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.583 363.116L249.083 363.116L249.083 362.816L247.583 362.816L247.583 363.116Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.621 363.116L247.121 363.116L247.121 362.816L245.621 362.816L245.621 363.116Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.608 363.116L245.108 363.116L245.108 362.816L243.608 362.816L243.608 363.116Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.595 363.116L243.095 363.116L243.095 362.816L241.595 362.816L241.595 363.116Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.583 363.116L241.083 363.116L241.083 362.816L239.583 362.816L239.583 363.116Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57 363.116L239.07 363.116L239.07 362.816L237.57 362.816L237.57 363.116Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.557 363.116L237.057 363.116L237.057 362.816L235.557 362.816L235.557 363.116Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.399 360.014L236.949 360.014L236.949 359.514L235.399 359.514L235.399 360.014Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.355 359.873L238.905 359.873L238.905 359.523L237.355 359.523L237.355 359.873Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.372 360.014L240.922 360.014L240.922 359.514L239.372 359.514L239.372 360.014Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.385 360.049L242.935 360.049L242.935 359.499L241.385 359.499L241.385 360.049Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.398 359.873L244.948 359.873L244.948 359.523L243.398 359.523L243.398 359.873Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.41 359.813L246.96 359.813L246.96 359.513L245.41 359.513L245.41 359.813Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.4 360.035L248.95 360.035L248.95 359.535L247.4 359.535L247.4 360.035Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.436 359.983L250.986 359.983L250.986 359.533L249.436 359.533L249.436 359.983Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.001 358.5H230.101V363.85H233.001V358.5Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.85 362.7H230.9V363H231.85V362.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.35 363.05H230.4V363.35H231.35V363.05Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 358.526L252.297 358.526L252.297 358.276L232.997 358.276L232.997 358.526Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 358.288L252.297 358.288L252.297 358.038L232.997 358.038L232.997 358.288Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 358.25H229.9V358.5H233V358.25Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 358H229.9V358.25H233V358Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 358H229.9V358.5H233V358Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.987 346.378L251.987 346.378L251.987 341.028L232.987 341.028L232.987 346.378Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.497 345.378L250.997 345.378L250.997 342.078L249.497 342.078L249.497 345.378Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.484 345.378L248.984 345.378L248.984 342.078L247.484 342.078L247.484 345.378Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.521 345.378L247.021 345.378L247.021 342.078L245.521 342.078L245.521 345.378Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.508 345.378L245.008 345.378L245.008 342.078L243.508 342.078L243.508 345.378Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.496 345.378L242.996 345.378L242.996 342.078L241.496 342.078L241.496 345.378Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.483 345.378L240.983 345.378L240.983 342.078L239.483 342.078L239.483 345.378Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.47 345.378L238.97 345.378L238.97 342.078L237.47 342.078L237.47 345.378Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.458 345.378L236.958 345.378L236.958 342.078L235.458 342.078L235.458 345.378Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 345.378L250.963 345.378L250.963 342.078L249.463 342.078L249.463 345.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 345.378L248.951 345.378L248.951 342.078L247.451 342.078L247.451 345.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 345.378L246.938 345.378L246.938 342.078L245.438 342.078L245.438 345.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 345.378L244.925 345.378L244.925 342.078L243.425 342.078L243.425 345.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 345.378L242.913 345.378L242.913 342.078L241.413 342.078L241.413 345.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 345.378L240.9 345.378L240.9 342.078L239.4 342.078L239.4 345.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 345.378L238.887 345.378L238.887 342.078L237.387 342.078L237.387 345.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 345.378L236.924 345.378L236.924 342.078L235.424 342.078L235.424 345.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 345.646L250.963 345.646L250.963 345.346L249.463 345.346L249.463 345.646Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 345.646L248.951 345.646L248.951 345.346L247.451 345.346L247.451 345.646Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 345.646L246.938 345.646L246.938 345.346L245.438 345.346L245.438 345.646Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 345.646L244.925 345.646L244.925 345.346L243.425 345.346L243.425 345.646Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 345.646L242.913 345.646L242.913 345.346L241.413 345.346L241.413 345.646Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 345.646L240.9 345.646L240.9 345.346L239.4 345.346L239.4 345.646Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 345.646L238.887 345.646L238.887 345.346L237.387 345.346L237.387 345.646Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 345.646L236.924 345.646L236.924 345.346L235.424 345.346L235.424 345.646Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.596 345.646L251.096 345.646L251.096 345.346L249.596 345.346L249.596 345.646Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.583 345.646L249.083 345.646L249.083 345.346L247.583 345.346L247.583 345.646Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.621 345.646L247.121 345.646L247.121 345.346L245.621 345.346L245.621 345.646Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.608 345.646L245.108 345.646L245.108 345.346L243.608 345.346L243.608 345.646Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.595 345.646L243.095 345.646L243.095 345.346L241.595 345.346L241.595 345.646Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.583 345.646L241.083 345.646L241.083 345.346L239.583 345.346L239.583 345.646Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57 345.646L239.07 345.646L239.07 345.346L237.57 345.346L237.57 345.646Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.557 345.646L237.057 345.646L237.057 345.346L235.557 345.346L235.557 345.646Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.399 343.092L236.949 343.092L236.949 342.092L235.399 342.092L235.399 343.092Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.355 344.229L238.905 344.229L238.905 342.079L237.355 342.079L237.355 344.229Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.372 344.034L240.922 344.034L240.922 342.084L239.372 342.084L239.372 344.034Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.385 343.162L242.935 343.162L242.935 342.112L241.385 342.112L241.385 343.162Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.398 342.809L244.948 342.809L244.948 342.109L243.398 342.109L243.398 342.809Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.41 342.393L246.96 342.393L246.96 342.093L245.41 342.093L245.41 342.393Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.423 343.092L248.973 343.092L248.973 342.092L247.423 342.092L247.423 343.092Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.436 344.575L250.986 344.575L250.986 342.075L249.436 342.075L249.436 344.575Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.001 341.05H230.101V346.4H233.001V341.05Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.85 345.25H230.9V345.55H231.85V345.25Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.35 345.6H230.4V345.9H231.35V345.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.35 345.6H231.4V345.9H232.35V345.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 341.056L252.297 341.056L252.297 340.806L232.997 340.806L232.997 341.056Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 340.818L252.297 340.818L252.297 340.568L232.997 340.568L232.997 340.818Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 340.8H229.9V341.05H233V340.8Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 340.55H229.9V340.8H233V340.55Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 340.55H229.9V341.05H233V340.55Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.987 352.218L251.987 352.218L251.987 346.868L232.987 346.868L232.987 352.218Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.497 351.168L250.997 351.168L250.997 347.868L249.497 347.868L249.497 351.168Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.484 351.168L248.984 351.168L248.984 347.868L247.484 347.868L247.484 351.168Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.521 351.168L247.021 351.168L247.021 347.868L245.521 347.868L245.521 351.168Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.508 351.168L245.008 351.168L245.008 347.868L243.508 347.868L243.508 351.168Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.496 351.168L242.996 351.168L242.996 347.868L241.496 347.868L241.496 351.168Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.483 351.168L240.983 351.168L240.983 347.868L239.483 347.868L239.483 351.168Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.47 351.168L238.97 351.168L238.97 347.868L237.47 347.868L237.47 351.168Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.458 351.168L236.958 351.168L236.958 347.868L235.458 347.868L235.458 351.168Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 351.168L250.963 351.168L250.963 347.868L249.463 347.868L249.463 351.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 351.168L248.951 351.168L248.951 347.868L247.451 347.868L247.451 351.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 351.168L246.938 351.168L246.938 347.868L245.438 347.868L245.438 351.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 351.168L244.925 351.168L244.925 347.868L243.425 347.868L243.425 351.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 351.168L242.913 351.168L242.913 347.868L241.413 347.868L241.413 351.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 351.168L240.9 351.168L240.9 347.868L239.4 347.868L239.4 351.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 351.168L238.887 351.168L238.887 347.868L237.387 347.868L237.387 351.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 351.168L236.924 351.168L236.924 347.868L235.424 347.868L235.424 351.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 351.436L250.963 351.436L250.963 351.136L249.463 351.136L249.463 351.436Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 351.436L248.951 351.436L248.951 351.136L247.451 351.136L247.451 351.436Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 351.436L246.938 351.436L246.938 351.136L245.438 351.136L245.438 351.436Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 351.436L244.925 351.436L244.925 351.136L243.425 351.136L243.425 351.436Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 351.436L242.913 351.436L242.913 351.136L241.413 351.136L241.413 351.436Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 351.436L240.9 351.436L240.9 351.136L239.4 351.136L239.4 351.436Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 351.436L238.887 351.436L238.887 351.136L237.387 351.136L237.387 351.436Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 351.436L236.924 351.436L236.924 351.136L235.424 351.136L235.424 351.436Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.596 351.436L251.096 351.436L251.096 351.136L249.596 351.136L249.596 351.436Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.583 351.436L249.083 351.436L249.083 351.136L247.583 351.136L247.583 351.436Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.621 351.436L247.121 351.436L247.121 351.136L245.621 351.136L245.621 351.436Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.608 351.436L245.108 351.436L245.108 351.136L243.608 351.136L243.608 351.436Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.595 351.436L243.095 351.436L243.095 351.136L241.595 351.136L241.595 351.436Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.583 351.436L241.083 351.436L241.083 351.136L239.583 351.136L239.583 351.436Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57 351.436L239.07 351.436L239.07 351.136L237.57 351.136L237.57 351.436Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.557 351.436L237.057 351.436L237.057 351.136L235.557 351.136L235.557 351.436Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.399 348.384L236.949 348.384L236.949 347.884L235.399 347.884L235.399 348.384Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.355 348.242L238.905 348.242L238.905 347.892L237.355 347.892L237.355 348.242Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.372 348.384L240.922 348.384L240.922 347.884L239.372 347.884L239.372 348.384Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.385 348.419L242.935 348.419L242.935 347.869L241.385 347.869L241.385 348.419Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.398 348.242L244.948 348.242L244.948 347.892L243.398 347.892L243.398 348.242Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.41 348.183L246.96 348.183L246.96 347.883L245.41 347.883L245.41 348.183Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.4 348.355L248.95 348.355L248.95 347.855L247.4 347.855L247.4 348.355Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.436 348.353L250.986 348.353L250.986 347.903L249.436 347.903L249.436 348.353Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.001 346.85H230.101V352.2H233.001V346.85Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.85 351.05H230.9V351.35H231.85V351.05Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.35 351.45H230.4V351.75H231.35V351.45Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 346.846L252.297 346.846L252.297 346.596L232.997 346.596L232.997 346.846Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 346.608L252.297 346.608L252.297 346.358L232.997 346.358L232.997 346.608Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 346.65H229.9V346.9H233V346.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 346.4H229.9V346.65H233V346.4Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 346.4H229.9V346.9H233V346.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.987 369.639L251.987 369.639L251.987 364.289L232.987 364.289L232.987 369.639Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.497 368.639L250.997 368.639L250.997 365.339L249.497 365.339L249.497 368.639Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.484 368.639L248.984 368.639L248.984 365.339L247.484 365.339L247.484 368.639Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.521 368.639L247.021 368.639L247.021 365.339L245.521 365.339L245.521 368.639Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.508 368.639L245.008 368.639L245.008 365.339L243.508 365.339L243.508 368.639Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.496 368.639L242.996 368.639L242.996 365.339L241.496 365.339L241.496 368.639Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.483 368.639L240.983 368.639L240.983 365.339L239.483 365.339L239.483 368.639Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.47 368.639L238.97 368.639L238.97 365.339L237.47 365.339L237.47 368.639Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.458 368.639L236.958 368.639L236.958 365.339L235.458 365.339L235.458 368.639Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 368.639L250.963 368.639L250.963 365.339L249.463 365.339L249.463 368.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 368.639L248.951 368.639L248.951 365.339L247.451 365.339L247.451 368.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 368.639L246.938 368.639L246.938 365.339L245.438 365.339L245.438 368.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 368.639L244.925 368.639L244.925 365.339L243.425 365.339L243.425 368.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 368.639L242.913 368.639L242.913 365.339L241.413 365.339L241.413 368.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 368.639L240.9 368.639L240.9 365.339L239.4 365.339L239.4 368.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 368.639L238.887 368.639L238.887 365.339L237.387 365.339L237.387 368.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 368.639L236.924 368.639L236.924 365.339L235.424 365.339L235.424 368.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 368.906L250.963 368.906L250.963 368.606L249.463 368.606L249.463 368.906Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 368.906L248.951 368.906L248.951 368.606L247.451 368.606L247.451 368.906Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 368.906L246.938 368.906L246.938 368.606L245.438 368.606L245.438 368.906Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 368.906L244.925 368.906L244.925 368.606L243.425 368.606L243.425 368.906Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 368.906L242.913 368.906L242.913 368.606L241.413 368.606L241.413 368.906Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 368.906L240.9 368.906L240.9 368.606L239.4 368.606L239.4 368.906Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 368.906L238.887 368.906L238.887 368.606L237.387 368.606L237.387 368.906Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 368.906L236.924 368.906L236.924 368.606L235.424 368.606L235.424 368.906Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.596 368.906L251.096 368.906L251.096 368.606L249.596 368.606L249.596 368.906Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.583 368.906L249.083 368.906L249.083 368.606L247.583 368.606L247.583 368.906Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.621 368.906L247.121 368.906L247.121 368.606L245.621 368.606L245.621 368.906Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.608 368.906L245.108 368.906L245.108 368.606L243.608 368.606L243.608 368.906Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.595 368.906L243.095 368.906L243.095 368.606L241.595 368.606L241.595 368.906Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.583 368.906L241.083 368.906L241.083 368.606L239.583 368.606L239.583 368.906Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57 368.906L239.07 368.906L239.07 368.606L237.57 368.606L237.57 368.906Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.557 368.906L237.057 368.906L237.057 368.606L235.557 368.606L235.557 368.906Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.399 366.583L236.949 366.583L236.949 365.333L235.399 365.333L235.399 366.583Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.355 365.996L238.905 365.996L238.905 365.346L237.355 365.346L237.355 365.996Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.372 366.4L240.922 366.4L240.922 365.35L239.372 365.35L239.372 366.4Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.385 366.622L242.935 366.622L242.935 365.372L241.385 365.372L241.385 366.622Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.398 366.309L244.948 366.309L244.948 365.359L243.398 365.359L243.398 366.309Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.41 366.075L246.96 366.075L246.96 365.375L245.41 365.375L245.41 366.075Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.423 365.715L248.973 365.715L248.973 365.365L247.423 365.365L247.423 365.715Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.436 365.832L250.986 365.832L250.986 365.332L249.436 365.332L249.436 365.832Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.001 364.35H230.101V369.7H233.001V364.35Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.35 368.9H230.4V369.2H231.35V368.9Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.35 368.9H231.4V369.2H232.35V368.9Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 364.316L252.297 364.316L252.297 364.066L232.997 364.066L232.997 364.316Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 364.078L252.297 364.078L252.297 363.828L232.997 363.828L232.997 364.078Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 364.1H229.9V364.35H233V364.1Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 363.85H229.9V364.1H233V363.85Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 363.85H229.9V364.35H233V363.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.987 375.479L251.987 375.479L251.987 370.129L232.987 370.129L232.987 375.479Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.497 374.479L250.997 374.479L250.997 371.179L249.497 371.179L249.497 374.479Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.484 374.479L248.984 374.479L248.984 371.179L247.484 371.179L247.484 374.479Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.521 374.479L247.021 374.479L247.021 371.179L245.521 371.179L245.521 374.479Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.508 374.479L245.008 374.479L245.008 371.179L243.508 371.179L243.508 374.479Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.496 374.479L242.996 374.479L242.996 371.179L241.496 371.179L241.496 374.479Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.483 374.479L240.983 374.479L240.983 371.179L239.483 371.179L239.483 374.479Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.47 374.479L238.97 374.479L238.97 371.179L237.47 371.179L237.47 374.479Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.458 374.479L236.958 374.479L236.958 371.179L235.458 371.179L235.458 374.479Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 374.479L250.963 374.479L250.963 371.179L249.463 371.179L249.463 374.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 374.479L248.951 374.479L248.951 371.179L247.451 371.179L247.451 374.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 374.479L246.938 374.479L246.938 371.179L245.438 371.179L245.438 374.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 374.479L244.925 374.479L244.925 371.179L243.425 371.179L243.425 374.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 374.479L242.913 374.479L242.913 371.179L241.413 371.179L241.413 374.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 374.479L240.9 374.479L240.9 371.179L239.4 371.179L239.4 374.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 374.479L238.887 374.479L238.887 371.179L237.387 371.179L237.387 374.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 374.479L236.924 374.479L236.924 371.179L235.424 371.179L235.424 374.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 374.746L250.963 374.746L250.963 374.446L249.463 374.446L249.463 374.746Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 374.746L248.951 374.746L248.951 374.446L247.451 374.446L247.451 374.746Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 374.746L246.938 374.746L246.938 374.446L245.438 374.446L245.438 374.746Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 374.746L244.925 374.746L244.925 374.446L243.425 374.446L243.425 374.746Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 374.746L242.913 374.746L242.913 374.446L241.413 374.446L241.413 374.746Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 374.746L240.9 374.746L240.9 374.446L239.4 374.446L239.4 374.746Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 374.746L238.887 374.746L238.887 374.446L237.387 374.446L237.387 374.746Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 374.746L236.924 374.746L236.924 374.446L235.424 374.446L235.424 374.746Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.596 374.746L251.096 374.746L251.096 374.446L249.596 374.446L249.596 374.746Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.583 374.746L249.083 374.746L249.083 374.446L247.583 374.446L247.583 374.746Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.621 374.746L247.121 374.746L247.121 374.446L245.621 374.446L245.621 374.746Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.608 374.746L245.108 374.746L245.108 374.446L243.608 374.446L243.608 374.746Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.595 374.746L243.095 374.746L243.095 374.446L241.595 374.446L241.595 374.746Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.583 374.746L241.083 374.746L241.083 374.446L239.583 374.446L239.583 374.746Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57 374.746L239.07 374.746L239.07 374.446L237.57 374.446L237.57 374.746Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.557 374.746L237.057 374.746L237.057 374.446L235.557 374.446L235.557 374.746Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.399 372.192L236.949 372.192L236.949 371.192L235.399 371.192L235.399 372.192Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.355 373.33L238.905 373.33L238.905 371.18L237.355 371.18L237.355 373.33Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.372 373.135L240.922 373.135L240.922 371.185L239.372 371.185L239.372 373.135Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.385 372.263L242.935 372.263L242.935 371.213L241.385 371.213L241.385 372.263Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.398 371.91L244.948 371.91L244.948 371.21L243.398 371.21L243.398 371.91Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.41 371.493L246.96 371.493L246.96 371.193L245.41 371.193L245.41 371.493Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.423 372.192L248.973 372.192L248.973 371.192L247.423 371.192L247.423 372.192Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.436 373.675L250.986 373.675L250.986 371.175L249.436 371.175L249.436 373.675Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.001 370.15H230.101V375.5H233.001V370.15Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.85 374.35H230.9V374.65H231.85V374.35Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.35 374.7H230.4V375H231.35V374.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.35 374.7H231.4V375H232.35V374.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 370.156L252.297 370.156L252.297 369.906L232.997 369.906L232.997 370.156Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 369.918L252.297 369.918L252.297 369.668L232.997 369.668L232.997 369.918Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 369.9H229.9V370.15H233V369.9Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 369.65H229.9V369.9H233V369.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 369.65H229.9V370.15H233V369.65Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.987 323.016L251.987 323.016L251.987 317.666L232.987 317.666L232.987 323.016Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.497 321.966L250.997 321.966L250.997 318.666L249.497 318.666L249.497 321.966Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.484 321.966L248.984 321.966L248.984 318.666L247.484 318.666L247.484 321.966Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.521 321.966L247.021 321.966L247.021 318.666L245.521 318.666L245.521 321.966Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.508 321.966L245.008 321.966L245.008 318.666L243.508 318.666L243.508 321.966Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.496 321.966L242.996 321.966L242.996 318.666L241.496 318.666L241.496 321.966Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.483 321.966L240.983 321.966L240.983 318.666L239.483 318.666L239.483 321.966Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.47 321.966L238.97 321.966L238.97 318.666L237.47 318.666L237.47 321.966Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.458 321.966L236.958 321.966L236.958 318.666L235.458 318.666L235.458 321.966Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 321.966L250.963 321.966L250.963 318.666L249.463 318.666L249.463 321.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 321.966L248.951 321.966L248.951 318.666L247.451 318.666L247.451 321.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 321.966L246.938 321.966L246.938 318.666L245.438 318.666L245.438 321.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 321.966L244.925 321.966L244.925 318.666L243.425 318.666L243.425 321.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 321.966L242.913 321.966L242.913 318.666L241.413 318.666L241.413 321.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 321.966L240.9 321.966L240.9 318.666L239.4 318.666L239.4 321.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 321.966L238.887 321.966L238.887 318.666L237.387 318.666L237.387 321.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 321.966L236.924 321.966L236.924 318.666L235.424 318.666L235.424 321.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 322.283L250.963 322.283L250.963 321.983L249.463 321.983L249.463 322.283Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 322.283L248.951 322.283L248.951 321.983L247.451 321.983L247.451 322.283Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 322.283L246.938 322.283L246.938 321.983L245.438 321.983L245.438 322.283Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 322.283L244.925 322.283L244.925 321.983L243.425 321.983L243.425 322.283Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 322.283L242.913 322.283L242.913 321.983L241.413 321.983L241.413 322.283Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 322.283L240.9 322.283L240.9 321.983L239.4 321.983L239.4 322.283Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 322.283L238.887 322.283L238.887 321.983L237.387 321.983L237.387 322.283Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 322.283L236.924 322.283L236.924 321.983L235.424 321.983L235.424 322.283Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.596 322.283L251.096 322.283L251.096 321.983L249.596 321.983L249.596 322.283Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.583 322.283L249.083 322.283L249.083 321.983L247.583 321.983L247.583 322.283Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.621 322.283L247.121 322.283L247.121 321.983L245.621 321.983L245.621 322.283Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.608 322.283L245.108 322.283L245.108 321.983L243.608 321.983L243.608 322.283Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.595 322.283L243.095 322.283L243.095 321.983L241.595 321.983L241.595 322.283Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.583 322.283L241.083 322.283L241.083 321.983L239.583 321.983L239.583 322.283Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57 322.283L239.07 322.283L239.07 321.983L237.57 321.983L237.57 322.283Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.557 322.283L237.057 322.283L237.057 321.983L235.557 321.983L235.557 322.283Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.399 319.679L236.949 319.679L236.949 318.679L235.399 318.679L235.399 319.679Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.355 320.817L238.905 320.817L238.905 318.667L237.355 318.667L237.355 320.817Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.372 320.621L240.922 320.621L240.922 318.671L239.372 318.671L239.372 320.621Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.385 319.75L242.935 319.75L242.935 318.7L241.385 318.7L241.385 319.75Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.398 319.397L244.948 319.397L244.948 318.697L243.398 318.697L243.398 319.397Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.41 318.98L246.96 318.98L246.96 318.68L245.41 318.68L245.41 318.98Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.423 319.679L248.973 319.679L248.973 318.679L247.423 318.679L247.423 319.679Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.436 321.162L250.986 321.162L250.986 318.662L249.436 318.662L249.436 321.162Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.001 317.65H230.101V323H233.001V317.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.85 321.85H230.9V322.15H231.85V321.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.35 322.2H230.4V322.5H231.35V322.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.35 322.2H231.4V322.5H232.35V322.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 317.643L252.297 317.643L252.297 317.393L232.997 317.393L232.997 317.643Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 317.405L252.297 317.405L252.297 317.155L232.997 317.155L232.997 317.405Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 317.45H229.9V317.7H233V317.45Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 317.2H229.9V317.45H233V317.2Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 317.2H229.9V317.7H233V317.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.987 328.806L251.987 328.806L251.987 323.456L232.987 323.456L232.987 328.806Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.497 327.806L250.997 327.806L250.997 324.506L249.497 324.506L249.497 327.806Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.484 327.806L248.984 327.806L248.984 324.506L247.484 324.506L247.484 327.806Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.521 327.806L247.021 327.806L247.021 324.506L245.521 324.506L245.521 327.806Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.508 327.806L245.008 327.806L245.008 324.506L243.508 324.506L243.508 327.806Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.496 327.806L242.996 327.806L242.996 324.506L241.496 324.506L241.496 327.806Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.483 327.806L240.983 327.806L240.983 324.506L239.483 324.506L239.483 327.806Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.47 327.806L238.97 327.806L238.97 324.506L237.47 324.506L237.47 327.806Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.458 327.806L236.958 327.806L236.958 324.506L235.458 324.506L235.458 327.806Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 327.806L250.963 327.806L250.963 324.506L249.463 324.506L249.463 327.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 327.806L248.951 327.806L248.951 324.506L247.451 324.506L247.451 327.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 327.806L246.938 327.806L246.938 324.506L245.438 324.506L245.438 327.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 327.806L244.925 327.806L244.925 324.506L243.425 324.506L243.425 327.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 327.806L242.913 327.806L242.913 324.506L241.413 324.506L241.413 327.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 327.806L240.9 327.806L240.9 324.506L239.4 324.506L239.4 327.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 327.806L238.887 327.806L238.887 324.506L237.387 324.506L237.387 327.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 327.806L236.924 327.806L236.924 324.506L235.424 324.506L235.424 327.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 328.073L250.963 328.073L250.963 327.773L249.463 327.773L249.463 328.073Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 328.073L248.951 328.073L248.951 327.773L247.451 327.773L247.451 328.073Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 328.073L246.938 328.073L246.938 327.773L245.438 327.773L245.438 328.073Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 328.073L244.925 328.073L244.925 327.773L243.425 327.773L243.425 328.073Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 328.073L242.913 328.073L242.913 327.773L241.413 327.773L241.413 328.073Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 328.073L240.9 328.073L240.9 327.773L239.4 327.773L239.4 328.073Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 328.073L238.887 328.073L238.887 327.773L237.387 327.773L237.387 328.073Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 328.073L236.924 328.073L236.924 327.773L235.424 327.773L235.424 328.073Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.596 328.073L251.096 328.073L251.096 327.773L249.596 327.773L249.596 328.073Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.583 328.073L249.083 328.073L249.083 327.773L247.583 327.773L247.583 328.073Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.621 328.073L247.121 328.073L247.121 327.773L245.621 327.773L245.621 328.073Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.608 328.073L245.108 328.073L245.108 327.773L243.608 327.773L243.608 328.073Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.595 328.073L243.095 328.073L243.095 327.773L241.595 327.773L241.595 328.073Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.583 328.073L241.083 328.073L241.083 327.773L239.583 327.773L239.583 328.073Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57 328.073L239.07 328.073L239.07 327.773L237.57 327.773L237.57 328.073Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.557 328.073L237.057 328.073L237.057 327.773L235.557 327.773L235.557 328.073Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.399 325.021L236.949 325.021L236.949 324.521L235.399 324.521L235.399 325.021Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.355 324.88L238.905 324.88L238.905 324.53L237.355 324.53L237.355 324.88Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.372 325.021L240.922 325.021L240.922 324.521L239.372 324.521L239.372 325.021Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.385 325.056L242.935 325.056L242.935 324.506L241.385 324.506L241.385 325.056Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.398 324.88L244.948 324.88L244.948 324.53L243.398 324.53L243.398 324.88Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.41 324.82L246.96 324.82L246.96 324.52L245.41 324.52L245.41 324.82Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.4 324.992L248.95 324.992L248.95 324.492L247.4 324.492L247.4 324.992Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.436 324.99L250.986 324.99L250.986 324.54L249.436 324.54L249.436 324.99Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.001 323.5H230.101V328.85H233.001V323.5Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.85 327.65H230.9V327.95H231.85V327.65Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.35 328.05H230.4V328.35H231.35V328.05Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 323.483L252.297 323.483L252.297 323.233L232.997 323.233L232.997 323.483Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 323.245L252.297 323.245L252.297 322.995L232.997 322.995L232.997 323.245Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 323.25H229.9V323.5H233V323.25Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 323H229.9V323.25H233V323Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 323H229.9V323.5H233V323Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.987 311.335L251.987 311.335L251.987 305.985L232.987 305.985L232.987 311.335Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.497 310.335L250.997 310.335L250.997 307.035L249.497 307.035L249.497 310.335Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.484 310.335L248.984 310.335L248.984 307.035L247.484 307.035L247.484 310.335Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.521 310.335L247.021 310.335L247.021 307.035L245.521 307.035L245.521 310.335Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.508 310.335L245.008 310.335L245.008 307.035L243.508 307.035L243.508 310.335Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.496 310.335L242.996 310.335L242.996 307.035L241.496 307.035L241.496 310.335Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.483 310.335L240.983 310.335L240.983 307.035L239.483 307.035L239.483 310.335Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.47 310.335L238.97 310.335L238.97 307.035L237.47 307.035L237.47 310.335Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.458 310.335L236.958 310.335L236.958 307.035L235.458 307.035L235.458 310.335Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 310.335L250.963 310.335L250.963 307.035L249.463 307.035L249.463 310.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 310.335L248.951 310.335L248.951 307.035L247.451 307.035L247.451 310.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 310.335L246.938 310.335L246.938 307.035L245.438 307.035L245.438 310.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 310.335L244.925 310.335L244.925 307.035L243.425 307.035L243.425 310.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 310.335L242.913 310.335L242.913 307.035L241.413 307.035L241.413 310.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 310.335L240.9 310.335L240.9 307.035L239.4 307.035L239.4 310.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 310.335L238.887 310.335L238.887 307.035L237.387 307.035L237.387 310.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 310.335L236.924 310.335L236.924 307.035L235.424 307.035L235.424 310.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 310.603L250.963 310.603L250.963 310.303L249.463 310.303L249.463 310.603Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 310.603L248.951 310.603L248.951 310.303L247.451 310.303L247.451 310.603Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 310.603L246.938 310.603L246.938 310.303L245.438 310.303L245.438 310.603Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 310.603L244.925 310.603L244.925 310.303L243.425 310.303L243.425 310.603Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 310.603L242.913 310.603L242.913 310.303L241.413 310.303L241.413 310.603Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 310.603L240.9 310.603L240.9 310.303L239.4 310.303L239.4 310.603Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 310.603L238.887 310.603L238.887 310.303L237.387 310.303L237.387 310.603Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 310.603L236.924 310.603L236.924 310.303L235.424 310.303L235.424 310.603Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.596 310.603L251.096 310.603L251.096 310.303L249.596 310.303L249.596 310.603Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.583 310.603L249.083 310.603L249.083 310.303L247.583 310.303L247.583 310.603Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.621 310.603L247.121 310.603L247.121 310.303L245.621 310.303L245.621 310.603Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.608 310.603L245.108 310.603L245.108 310.303L243.608 310.303L243.608 310.603Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.595 310.603L243.095 310.603L243.095 310.303L241.595 310.303L241.595 310.603Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.583 310.603L241.083 310.603L241.083 310.303L239.583 310.303L239.583 310.603Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57 310.603L239.07 310.603L239.07 310.303L237.57 310.303L237.57 310.603Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.557 310.603L237.057 310.603L237.057 310.303L235.557 310.303L235.557 310.603Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.399 308.049L236.949 308.049L236.949 307.049L235.399 307.049L235.399 308.049Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.355 309.187L238.905 309.187L238.905 307.036L237.355 307.036L237.355 309.187Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.372 308.991L240.922 308.991L240.922 307.041L239.372 307.041L239.372 308.991Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.385 308.12L242.935 308.12L242.935 307.069L241.385 307.069L241.385 308.12Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.398 307.766L244.948 307.766L244.948 307.066L243.398 307.066L243.398 307.766Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.41 307.35L246.96 307.35L246.96 307.05L245.41 307.05L245.41 307.35Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.423 308.049L248.973 308.049L248.973 307.049L247.423 307.049L247.423 308.049Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.436 309.532L250.986 309.532L250.986 307.032L249.436 307.032L249.436 309.532Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.001 306.05H230.101V311.4H233.001V306.05Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.85 310.2H230.9V310.5H231.85V310.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.35 310.6H230.4V310.9H231.35V310.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.35 310.6H231.4V310.9H232.35V310.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 306.013L252.297 306.013L252.297 305.763L232.997 305.763L232.997 306.013Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 305.775L252.297 305.775L252.297 305.525L232.997 305.525L232.997 305.775Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 305.8H229.9V306.05H233V305.8Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 305.55H229.9V305.8H233V305.55Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 305.55H229.9V306.05H233V305.55Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.987 317.175L251.987 317.175L251.987 311.825L232.987 311.825L232.987 317.175Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.497 316.176L250.997 316.176L250.997 312.876L249.497 312.876L249.497 316.176Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.484 316.176L248.984 316.176L248.984 312.876L247.484 312.876L247.484 316.176Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.521 316.176L247.021 316.176L247.021 312.876L245.521 312.876L245.521 316.176Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.508 316.176L245.008 316.176L245.008 312.876L243.508 312.876L243.508 316.176Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.496 316.176L242.996 316.176L242.996 312.876L241.496 312.876L241.496 316.176Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.483 316.176L240.983 316.176L240.983 312.876L239.483 312.876L239.483 316.176Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.47 316.176L238.97 316.176L238.97 312.876L237.47 312.876L237.47 316.176Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.458 316.176L236.958 316.176L236.958 312.876L235.458 312.876L235.458 316.176Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 316.176L250.963 316.176L250.963 312.876L249.463 312.876L249.463 316.176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 316.176L248.951 316.176L248.951 312.876L247.451 312.876L247.451 316.176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 316.176L246.938 316.176L246.938 312.876L245.438 312.876L245.438 316.176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 316.176L244.925 316.176L244.925 312.876L243.425 312.876L243.425 316.176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 316.176L242.913 316.176L242.913 312.876L241.413 312.876L241.413 316.176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 316.176L240.9 316.176L240.9 312.876L239.4 312.876L239.4 316.176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 316.176L238.887 316.176L238.887 312.876L237.387 312.876L237.387 316.176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 316.176L236.924 316.176L236.924 312.876L235.424 312.876L235.424 316.176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 316.443L250.963 316.443L250.963 316.143L249.463 316.143L249.463 316.443Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 316.443L248.951 316.443L248.951 316.143L247.451 316.143L247.451 316.443Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 316.443L246.938 316.443L246.938 316.143L245.438 316.143L245.438 316.443Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 316.443L244.925 316.443L244.925 316.143L243.425 316.143L243.425 316.443Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 316.443L242.913 316.443L242.913 316.143L241.413 316.143L241.413 316.443Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 316.443L240.9 316.443L240.9 316.143L239.4 316.143L239.4 316.443Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 316.443L238.887 316.443L238.887 316.143L237.387 316.143L237.387 316.443Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 316.443L236.924 316.443L236.924 316.143L235.424 316.143L235.424 316.443Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.596 316.443L251.096 316.443L251.096 316.143L249.596 316.143L249.596 316.443Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.583 316.443L249.083 316.443L249.083 316.143L247.583 316.143L247.583 316.443Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.621 316.443L247.121 316.443L247.121 316.143L245.621 316.143L245.621 316.443Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.608 316.443L245.108 316.443L245.108 316.143L243.608 316.143L243.608 316.443Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.595 316.443L243.095 316.443L243.095 316.143L241.595 316.143L241.595 316.443Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.583 316.443L241.083 316.443L241.083 316.143L239.583 316.143L239.583 316.443Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57 316.443L239.07 316.443L239.07 316.143L237.57 316.143L237.57 316.443Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.557 316.443L237.057 316.443L237.057 316.143L235.557 316.143L235.557 316.443Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.399 313.391L236.949 313.391L236.949 312.891L235.399 312.891L235.399 313.391Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.355 313.249L238.905 313.249L238.905 312.899L237.355 312.899L237.355 313.249Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.372 313.391L240.922 313.391L240.922 312.891L239.372 312.891L239.372 313.391Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.385 313.426L242.935 313.426L242.935 312.876L241.385 312.876L241.385 313.426Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.398 313.249L244.948 313.249L244.948 312.899L243.398 312.899L243.398 313.249Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.41 313.19L246.96 313.19L246.96 312.89L245.41 312.89L245.41 313.19Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.4 313.362L248.95 313.362L248.95 312.862L247.4 312.862L247.4 313.362Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.436 313.36L250.986 313.36L250.986 312.91L249.436 312.91L249.436 313.36Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.001 311.85H230.101V317.2H233.001V311.85Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.85 316.05H230.9V316.35H231.85V316.05Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.35 316.4H230.4V316.7H231.35V316.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 311.853L252.297 311.853L252.297 311.603L232.997 311.603L232.997 311.853Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 311.615L252.297 311.615L252.297 311.365L232.997 311.365L232.997 311.615Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 311.6H229.9V311.85H233V311.6Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 311.35H229.9V311.6H233V311.35Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 311.35H229.9V311.85H233V311.35Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.987 334.646L251.987 334.646L251.987 329.296L232.987 329.296L232.987 334.646Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.497 333.596L250.997 333.596L250.997 330.296L249.497 330.296L249.497 333.596Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.484 333.596L248.984 333.596L248.984 330.296L247.484 330.296L247.484 333.596Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.521 333.596L247.021 333.596L247.021 330.296L245.521 330.296L245.521 333.596Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.508 333.596L245.008 333.596L245.008 330.296L243.508 330.296L243.508 333.596Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.496 333.596L242.996 333.596L242.996 330.296L241.496 330.296L241.496 333.596Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.483 333.596L240.983 333.596L240.983 330.296L239.483 330.296L239.483 333.596Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.47 333.596L238.97 333.596L238.97 330.296L237.47 330.296L237.47 333.596Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.458 333.596L236.958 333.596L236.958 330.296L235.458 330.296L235.458 333.596Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 333.596L250.963 333.596L250.963 330.296L249.463 330.296L249.463 333.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 333.596L248.951 333.596L248.951 330.296L247.451 330.296L247.451 333.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 333.596L246.938 333.596L246.938 330.296L245.438 330.296L245.438 333.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 333.596L244.925 333.596L244.925 330.296L243.425 330.296L243.425 333.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 333.596L242.913 333.596L242.913 330.296L241.413 330.296L241.413 333.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 333.596L240.9 333.596L240.9 330.296L239.4 330.296L239.4 333.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 333.596L238.887 333.596L238.887 330.296L237.387 330.296L237.387 333.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 333.596L236.924 333.596L236.924 330.296L235.424 330.296L235.424 333.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 333.913L250.963 333.913L250.963 333.613L249.463 333.613L249.463 333.913Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 333.913L248.951 333.913L248.951 333.613L247.451 333.613L247.451 333.913Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 333.913L246.938 333.913L246.938 333.613L245.438 333.613L245.438 333.913Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 333.913L244.925 333.913L244.925 333.613L243.425 333.613L243.425 333.913Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 333.913L242.913 333.913L242.913 333.613L241.413 333.613L241.413 333.913Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 333.913L240.9 333.913L240.9 333.613L239.4 333.613L239.4 333.913Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 333.913L238.887 333.913L238.887 333.613L237.387 333.613L237.387 333.913Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 333.913L236.924 333.913L236.924 333.613L235.424 333.613L235.424 333.913Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.596 333.913L251.096 333.913L251.096 333.613L249.596 333.613L249.596 333.913Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.583 333.913L249.083 333.913L249.083 333.613L247.583 333.613L247.583 333.913Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.621 333.913L247.121 333.913L247.121 333.613L245.621 333.613L245.621 333.913Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.608 333.913L245.108 333.913L245.108 333.613L243.608 333.613L243.608 333.913Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.595 333.913L243.095 333.913L243.095 333.613L241.595 333.613L241.595 333.913Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.583 333.913L241.083 333.913L241.083 333.613L239.583 333.613L239.583 333.913Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57 333.913L239.07 333.913L239.07 333.613L237.57 333.613L237.57 333.913Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.557 333.913L237.057 333.913L237.057 333.613L235.557 333.613L235.557 333.913Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.399 331.54L236.949 331.54L236.949 330.29L235.399 330.29L235.399 331.54Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.355 330.954L238.905 330.954L238.905 330.304L237.355 330.304L237.355 330.954Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.372 331.357L240.922 331.357L240.922 330.307L239.372 330.307L239.372 331.357Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.385 331.579L242.935 331.579L242.935 330.329L241.385 330.329L241.385 331.579Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.398 331.266L244.948 331.266L244.948 330.316L243.398 330.316L243.398 331.266Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.41 331.032L246.96 331.032L246.96 330.332L245.41 330.332L245.41 331.032Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.423 330.672L248.973 330.672L248.973 330.322L247.423 330.322L247.423 330.672Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.436 330.79L250.986 330.79L250.986 330.29L249.436 330.29L249.436 330.79Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.001 329.3H230.101V334.65H233.001V329.3Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.35 333.85H230.4V334.15H231.35V333.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.35 333.85H231.4V334.15H232.35V333.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 329.323L252.297 329.323L252.297 329.073L232.997 329.073L232.997 329.323Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 329.085L252.297 329.085L252.297 328.835L232.997 328.835L232.997 329.085Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 329.05H229.9V329.3H233V329.05Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 328.8H229.9V329.05H233V328.8Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 328.8H229.9V329.3H233V328.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.987 340.436L251.987 340.436L251.987 335.086L232.987 335.086L232.987 340.436Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.497 339.436L250.997 339.436L250.997 336.136L249.497 336.136L249.497 339.436Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.484 339.436L248.984 339.436L248.984 336.136L247.484 336.136L247.484 339.436Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.521 339.436L247.021 339.436L247.021 336.136L245.521 336.136L245.521 339.436Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.508 339.436L245.008 339.436L245.008 336.136L243.508 336.136L243.508 339.436Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.496 339.436L242.996 339.436L242.996 336.136L241.496 336.136L241.496 339.436Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.483 339.436L240.983 339.436L240.983 336.136L239.483 336.136L239.483 339.436Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.47 339.436L238.97 339.436L238.97 336.136L237.47 336.136L237.47 339.436Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.458 339.436L236.958 339.436L236.958 336.136L235.458 336.136L235.458 339.436Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 339.436L250.963 339.436L250.963 336.136L249.463 336.136L249.463 339.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 339.436L248.951 339.436L248.951 336.136L247.451 336.136L247.451 339.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 339.436L246.938 339.436L246.938 336.136L245.438 336.136L245.438 339.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 339.436L244.925 339.436L244.925 336.136L243.425 336.136L243.425 339.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 339.436L242.913 339.436L242.913 336.136L241.413 336.136L241.413 339.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 339.436L240.9 339.436L240.9 336.136L239.4 336.136L239.4 339.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 339.436L238.887 339.436L238.887 336.136L237.387 336.136L237.387 339.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 339.436L236.924 339.436L236.924 336.136L235.424 336.136L235.424 339.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.463 339.703L250.963 339.703L250.963 339.403L249.463 339.403L249.463 339.703Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.451 339.703L248.951 339.703L248.951 339.403L247.451 339.403L247.451 339.703Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.438 339.703L246.938 339.703L246.938 339.403L245.438 339.403L245.438 339.703Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.425 339.703L244.925 339.703L244.925 339.403L243.425 339.403L243.425 339.703Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.413 339.703L242.913 339.703L242.913 339.403L241.413 339.403L241.413 339.703Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 339.703L240.9 339.703L240.9 339.403L239.4 339.403L239.4 339.703Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.387 339.703L238.887 339.703L238.887 339.403L237.387 339.403L237.387 339.703Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.424 339.703L236.924 339.703L236.924 339.403L235.424 339.403L235.424 339.703Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.596 339.703L251.096 339.703L251.096 339.403L249.596 339.403L249.596 339.703Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.583 339.703L249.083 339.703L249.083 339.403L247.583 339.403L247.583 339.703Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.621 339.703L247.121 339.703L247.121 339.403L245.621 339.403L245.621 339.703Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.608 339.703L245.108 339.703L245.108 339.403L243.608 339.403L243.608 339.703Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.595 339.703L243.095 339.703L243.095 339.403L241.595 339.403L241.595 339.703Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.583 339.703L241.083 339.703L241.083 339.403L239.583 339.403L239.583 339.703Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57 339.703L239.07 339.703L239.07 339.403L237.57 339.403L237.57 339.703Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.557 339.703L237.057 339.703L237.057 339.403L235.557 339.403L235.557 339.703Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.399 337.149L236.949 337.149L236.949 336.149L235.399 336.149L235.399 337.149Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.355 338.287L238.905 338.287L238.905 336.137L237.355 336.137L237.355 338.287Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.372 338.092L240.922 338.092L240.922 336.142L239.372 336.142L239.372 338.092Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.385 337.22L242.935 337.22L242.935 336.17L241.385 336.17L241.385 337.22Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.398 336.867L244.948 336.867L244.948 336.167L243.398 336.167L243.398 336.867Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.41 336.45L246.96 336.45L246.96 336.15L245.41 336.15L245.41 336.45Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.423 337.149L248.973 337.149L248.973 336.149L247.423 336.149L247.423 337.149Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.436 338.632L250.986 338.632L250.986 336.132L249.436 336.132L249.436 338.632Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.001 335.15H230.101V340.5H233.001V335.15Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.85 339.3H230.9V339.6H231.85V339.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.35 339.7H230.4V340H231.35V339.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.35 339.7H231.4V340H232.35V339.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 335.114L252.297 335.114L252.297 334.864L232.997 334.864L232.997 335.114Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.997 334.875L252.297 334.875L252.297 334.625L232.997 334.625L232.997 334.875Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 334.9H229.9V335.15H233V334.9Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 334.65H229.9V334.9H233V334.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 334.65H229.9V335.15H233V334.65Z",
    fill: "black"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.642 365.225L276.642 365.225L276.642 359.875L257.642 359.875L257.642 365.225Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.201 364.175L275.701 364.175L275.701 360.875L274.201 360.875L274.201 364.175Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.188 364.175L273.688 364.175L273.688 360.875L272.188 360.875L272.188 364.175Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.176 364.175L271.676 364.175L271.676 360.875L270.176 360.875L270.176 364.175Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.163 364.175L269.663 364.175L269.663 360.875L268.163 360.875L268.163 364.175Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15 364.175L267.65 364.175L267.65 360.875L266.15 360.875L266.15 364.175Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.138 364.175L265.638 364.175L265.638 360.875L264.138 360.875L264.138 364.175Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.125 364.175L263.625 364.175L263.625 360.875L262.125 360.875L262.125 364.175Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.162 364.175L261.662 364.175L261.662 360.875L260.162 360.875L260.162 364.175Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 364.175L275.618 364.175L275.618 360.875L274.118 360.875L274.118 364.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 364.175L273.605 364.175L273.605 360.875L272.105 360.875L272.105 364.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 364.175L271.592 364.175L271.592 360.875L270.092 360.875L270.092 364.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 364.175L269.58 364.175L269.58 360.875L268.08 360.875L268.08 364.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 364.175L267.617 364.175L267.617 360.875L266.117 360.875L266.117 364.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 364.175L265.604 364.175L265.604 360.875L264.104 360.875L264.104 364.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 364.175L263.591 364.175L263.591 360.875L262.091 360.875L262.091 364.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 364.175L261.579 364.175L261.579 360.875L260.079 360.875L260.079 364.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 364.442L275.618 364.442L275.618 364.142L274.118 364.142L274.118 364.442Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 364.442L273.605 364.442L273.605 364.142L272.105 364.142L272.105 364.442Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 364.442L271.592 364.442L271.592 364.142L270.092 364.142L270.092 364.442Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 364.442L269.58 364.442L269.58 364.142L268.08 364.142L268.08 364.442Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 364.442L267.617 364.442L267.617 364.142L266.117 364.142L266.117 364.442Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 364.442L265.604 364.442L265.604 364.142L264.104 364.142L264.104 364.442Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 364.442L263.591 364.442L263.591 364.142L262.091 364.142L262.091 364.442Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 364.442L261.579 364.442L261.579 364.142L260.079 364.142L260.079 364.442Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.301 364.442L275.801 364.442L275.801 364.142L274.301 364.142L274.301 364.442Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.288 364.442L273.788 364.442L273.788 364.142L272.288 364.142L272.288 364.442Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.275 364.442L271.775 364.442L271.775 364.142L270.275 364.142L270.275 364.442Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.263 364.442L269.763 364.442L269.763 364.142L268.263 364.142L268.263 364.442Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25 364.442L267.75 364.442L267.75 364.142L266.25 364.142L266.25 364.442Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.237 364.442L265.737 364.442L265.737 364.142L264.237 364.142L264.237 364.442Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.225 364.442L263.725 364.442L263.725 364.142L262.225 364.142L262.225 364.442Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.262 364.442L261.762 364.442L261.762 364.142L260.262 364.142L260.262 364.442Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.053 361.888L261.604 361.888L261.604 360.888L260.053 360.888L260.053 361.888Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.06 363.026L263.61 363.026L263.61 360.876L262.06 360.876L262.06 363.026Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.076 362.831L265.626 362.831L265.626 360.881L264.076 360.881L264.076 362.831Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.09 361.959L267.64 361.959L267.64 360.909L266.09 360.909L266.09 361.959Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.052 361.606L269.602 361.606L269.602 360.906L268.052 360.906L268.052 361.606Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.065 361.189L271.615 361.189L271.615 360.889L270.065 360.889L270.065 361.189Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.077 361.888L273.627 361.888L273.627 360.888L272.077 360.888L272.077 361.888Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.09 363.371L275.64 363.371L275.64 360.871L274.09 360.871L274.09 363.371Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.65 359.85H254.75V365.2H257.65V359.85Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.55 364.05H255.6V364.35H256.55V364.05Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.05 364.45H255.1V364.75H256.05V364.45Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.05 364.45H256.1V364.75H257.05V364.45Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 359.853L276.952 359.853L276.952 359.603L257.652 359.603L257.652 359.853Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 359.615L276.952 359.615L276.952 359.365L257.652 359.365L257.652 359.615Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 359.65H254.6V359.9H257.7V359.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 359.4H254.6V359.65H257.7V359.4Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.7 359.4H254.6V359.9H257.7V359.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.642 371.015L276.642 371.015L276.642 365.665L257.642 365.665L257.642 371.015Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.201 370.015L275.701 370.015L275.701 366.715L274.201 366.715L274.201 370.015Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.188 370.015L273.688 370.015L273.688 366.715L272.188 366.715L272.188 370.015Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.176 370.015L271.676 370.015L271.676 366.715L270.176 366.715L270.176 370.015Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.163 370.015L269.663 370.015L269.663 366.715L268.163 366.715L268.163 370.015Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15 370.015L267.65 370.015L267.65 366.715L266.15 366.715L266.15 370.015Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.138 370.015L265.638 370.015L265.638 366.715L264.138 366.715L264.138 370.015Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.125 370.015L263.625 370.015L263.625 366.715L262.125 366.715L262.125 370.015Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.162 370.015L261.662 370.015L261.662 366.715L260.162 366.715L260.162 370.015Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 370.015L275.618 370.015L275.618 366.715L274.118 366.715L274.118 370.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 370.015L273.605 370.015L273.605 366.715L272.105 366.715L272.105 370.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 370.015L271.592 370.015L271.592 366.715L270.092 366.715L270.092 370.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 370.015L269.58 370.015L269.58 366.715L268.08 366.715L268.08 370.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 370.015L267.617 370.015L267.617 366.715L266.117 366.715L266.117 370.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 370.015L265.604 370.015L265.604 366.715L264.104 366.715L264.104 370.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 370.015L263.591 370.015L263.591 366.715L262.091 366.715L262.091 370.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 370.015L261.579 370.015L261.579 366.715L260.079 366.715L260.079 370.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 370.282L275.618 370.282L275.618 369.982L274.118 369.982L274.118 370.282Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 370.282L273.605 370.282L273.605 369.982L272.105 369.982L272.105 370.282Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 370.282L271.592 370.282L271.592 369.982L270.092 369.982L270.092 370.282Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 370.282L269.58 370.282L269.58 369.982L268.08 369.982L268.08 370.282Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 370.282L267.617 370.282L267.617 369.982L266.117 369.982L266.117 370.282Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 370.282L265.604 370.282L265.604 369.982L264.104 369.982L264.104 370.282Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 370.282L263.591 370.282L263.591 369.982L262.091 369.982L262.091 370.282Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 370.282L261.579 370.282L261.579 369.982L260.079 369.982L260.079 370.282Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.301 370.282L275.801 370.282L275.801 369.982L274.301 369.982L274.301 370.282Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.288 370.282L273.788 370.282L273.788 369.982L272.288 369.982L272.288 370.282Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.275 370.282L271.775 370.282L271.775 369.982L270.275 369.982L270.275 370.282Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.263 370.282L269.763 370.282L269.763 369.982L268.263 369.982L268.263 370.282Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25 370.282L267.75 370.282L267.75 369.982L266.25 369.982L266.25 370.282Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.237 370.282L265.737 370.282L265.737 369.982L264.237 369.982L264.237 370.282Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.225 370.282L263.725 370.282L263.725 369.982L262.225 369.982L262.225 370.282Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.262 370.282L261.762 370.282L261.762 369.982L260.262 369.982L260.262 370.282Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.053 367.23L261.604 367.23L261.604 366.73L260.053 366.73L260.053 367.23Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.06 367.089L263.61 367.089L263.61 366.739L262.06 366.739L262.06 367.089Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.076 367.23L265.626 367.23L265.626 366.73L264.076 366.73L264.076 367.23Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.09 367.266L267.64 367.266L267.64 366.716L266.09 366.716L266.09 367.266Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.052 367.089L269.602 367.089L269.602 366.739L268.052 366.739L268.052 367.089Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.065 367.029L271.615 367.029L271.615 366.729L270.065 366.729L270.065 367.029Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.055 367.202L273.605 367.202L273.605 366.702L272.055 366.702L272.055 367.202Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.09 367.2L275.64 367.2L275.64 366.75L274.09 366.75L274.09 367.2Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.65 365.7H254.75V371.05H257.65V365.7Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.55 369.9H255.6V370.2H256.55V369.9Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.05 370.25H255.1V370.55H256.05V370.25Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 365.693L276.952 365.693L276.952 365.443L257.652 365.443L257.652 365.693Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 365.455L276.952 365.455L276.952 365.205L257.652 365.205L257.652 365.455Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 365.45H254.6V365.7H257.7V365.45Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 365.2H254.6V365.45H257.7V365.2Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.7 365.2H254.6V365.7H257.7V365.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.642 353.545L276.642 353.545L276.642 348.195L257.642 348.195L257.642 353.545Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.201 352.545L275.701 352.545L275.701 349.245L274.201 349.245L274.201 352.545Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.188 352.545L273.688 352.545L273.688 349.245L272.188 349.245L272.188 352.545Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.176 352.545L271.676 352.545L271.676 349.245L270.176 349.245L270.176 352.545Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.163 352.545L269.663 352.545L269.663 349.245L268.163 349.245L268.163 352.545Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15 352.545L267.65 352.545L267.65 349.245L266.15 349.245L266.15 352.545Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.138 352.545L265.638 352.545L265.638 349.245L264.138 349.245L264.138 352.545Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.125 352.545L263.625 352.545L263.625 349.245L262.125 349.245L262.125 352.545Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.162 352.545L261.662 352.545L261.662 349.245L260.162 349.245L260.162 352.545Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 352.545L275.618 352.545L275.618 349.245L274.118 349.245L274.118 352.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 352.545L273.605 352.545L273.605 349.245L272.105 349.245L272.105 352.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 352.545L271.592 352.545L271.592 349.245L270.092 349.245L270.092 352.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 352.545L269.58 352.545L269.58 349.245L268.08 349.245L268.08 352.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 352.545L267.617 352.545L267.617 349.245L266.117 349.245L266.117 352.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 352.545L265.604 352.545L265.604 349.245L264.104 349.245L264.104 352.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 352.545L263.591 352.545L263.591 349.245L262.091 349.245L262.091 352.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 352.545L261.579 352.545L261.579 349.245L260.079 349.245L260.079 352.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 352.812L275.618 352.812L275.618 352.512L274.118 352.512L274.118 352.812Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 352.812L273.605 352.812L273.605 352.512L272.105 352.512L272.105 352.812Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 352.812L271.592 352.812L271.592 352.512L270.092 352.512L270.092 352.812Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 352.812L269.58 352.812L269.58 352.512L268.08 352.512L268.08 352.812Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 352.812L267.617 352.812L267.617 352.512L266.117 352.512L266.117 352.812Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 352.812L265.604 352.812L265.604 352.512L264.104 352.512L264.104 352.812Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 352.812L263.591 352.812L263.591 352.512L262.091 352.512L262.091 352.812Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 352.812L261.579 352.812L261.579 352.512L260.079 352.512L260.079 352.812Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.301 352.812L275.801 352.812L275.801 352.512L274.301 352.512L274.301 352.812Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.288 352.812L273.788 352.812L273.788 352.512L272.288 352.512L272.288 352.812Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.275 352.812L271.775 352.812L271.775 352.512L270.275 352.512L270.275 352.812Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.263 352.812L269.763 352.812L269.763 352.512L268.263 352.512L268.263 352.812Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25 352.812L267.75 352.812L267.75 352.512L266.25 352.512L266.25 352.812Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.237 352.812L265.737 352.812L265.737 352.512L264.237 352.512L264.237 352.812Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.225 352.812L263.725 352.812L263.725 352.512L262.225 352.512L262.225 352.812Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.262 352.812L261.762 352.812L261.762 352.512L260.262 352.512L260.262 352.812Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.053 350.258L261.604 350.258L261.604 349.258L260.053 349.258L260.053 350.258Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.06 351.396L263.61 351.396L263.61 349.246L262.06 349.246L262.06 351.396Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.076 351.2L265.626 351.2L265.626 349.25L264.076 349.25L264.076 351.2Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.09 350.329L267.64 350.329L267.64 349.279L266.09 349.279L266.09 350.329Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.052 349.976L269.602 349.976L269.602 349.276L268.052 349.276L268.052 349.976Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.065 349.559L271.615 349.559L271.615 349.259L270.065 349.259L270.065 349.559Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.077 350.258L273.627 350.258L273.627 349.258L272.077 349.258L272.077 350.258Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.09 351.741L275.64 351.741L275.64 349.241L274.09 349.241L274.09 351.741Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.65 348.25H254.75V353.6H257.65V348.25Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.55 352.4H255.6V352.7H256.55V352.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.05 352.8H255.1V353.1H256.05V352.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.05 352.8H256.1V353.1H257.05V352.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 348.222L276.952 348.222L276.952 347.972L257.652 347.972L257.652 348.222Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 347.984L276.952 347.984L276.952 347.734L257.652 347.734L257.652 347.984Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 348H254.6V348.25H257.7V348Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 347.75H254.6V348H257.7V347.75Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.7 347.75H254.6V348.25H257.7V347.75Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.642 359.385L276.642 359.385L276.642 354.035L257.642 354.035L257.642 359.385Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.201 358.335L275.701 358.335L275.701 355.035L274.201 355.035L274.201 358.335Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.188 358.335L273.688 358.335L273.688 355.035L272.188 355.035L272.188 358.335Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.176 358.335L271.676 358.335L271.676 355.035L270.176 355.035L270.176 358.335Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.163 358.335L269.663 358.335L269.663 355.035L268.163 355.035L268.163 358.335Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15 358.335L267.65 358.335L267.65 355.035L266.15 355.035L266.15 358.335Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.138 358.335L265.638 358.335L265.638 355.035L264.138 355.035L264.138 358.335Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.125 358.335L263.625 358.335L263.625 355.035L262.125 355.035L262.125 358.335Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.162 358.335L261.662 358.335L261.662 355.035L260.162 355.035L260.162 358.335Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 358.335L275.618 358.335L275.618 355.035L274.118 355.035L274.118 358.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 358.335L273.605 358.335L273.605 355.035L272.105 355.035L272.105 358.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 358.335L271.592 358.335L271.592 355.035L270.092 355.035L270.092 358.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 358.335L269.58 358.335L269.58 355.035L268.08 355.035L268.08 358.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 358.335L267.617 358.335L267.617 355.035L266.117 355.035L266.117 358.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 358.335L265.604 358.335L265.604 355.035L264.104 355.035L264.104 358.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 358.335L263.591 358.335L263.591 355.035L262.091 355.035L262.091 358.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 358.335L261.579 358.335L261.579 355.035L260.079 355.035L260.079 358.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 358.652L275.618 358.652L275.618 358.352L274.118 358.352L274.118 358.652Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 358.652L273.605 358.652L273.605 358.352L272.105 358.352L272.105 358.652Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 358.652L271.592 358.652L271.592 358.352L270.092 358.352L270.092 358.652Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 358.652L269.58 358.652L269.58 358.352L268.08 358.352L268.08 358.652Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 358.652L267.617 358.652L267.617 358.352L266.117 358.352L266.117 358.652Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 358.652L265.604 358.652L265.604 358.352L264.104 358.352L264.104 358.652Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 358.652L263.591 358.652L263.591 358.352L262.091 358.352L262.091 358.652Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 358.652L261.579 358.652L261.579 358.352L260.079 358.352L260.079 358.652Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.301 358.652L275.801 358.652L275.801 358.352L274.301 358.352L274.301 358.652Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.288 358.652L273.788 358.652L273.788 358.352L272.288 358.352L272.288 358.652Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.275 358.652L271.775 358.652L271.775 358.352L270.275 358.352L270.275 358.652Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.263 358.652L269.763 358.652L269.763 358.352L268.263 358.352L268.263 358.652Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25 358.652L267.75 358.652L267.75 358.352L266.25 358.352L266.25 358.652Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.237 358.652L265.737 358.652L265.737 358.352L264.237 358.352L264.237 358.652Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.225 358.652L263.725 358.652L263.725 358.352L262.225 358.352L262.225 358.652Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.262 358.652L261.762 358.652L261.762 358.352L260.262 358.352L260.262 358.652Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.053 355.55L261.604 355.55L261.604 355.05L260.053 355.05L260.053 355.55Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.06 355.409L263.61 355.409L263.61 355.059L262.06 355.059L262.06 355.409Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.076 355.55L265.626 355.55L265.626 355.05L264.076 355.05L264.076 355.55Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.09 355.585L267.64 355.585L267.64 355.035L266.09 355.035L266.09 355.585Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.052 355.409L269.602 355.409L269.602 355.059L268.052 355.059L268.052 355.409Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.065 355.349L271.615 355.349L271.615 355.049L270.065 355.049L270.065 355.349Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.055 355.572L273.605 355.572L273.605 355.072L272.055 355.072L272.055 355.572Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.09 355.52L275.64 355.52L275.64 355.07L274.09 355.07L274.09 355.52Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.65 354.05H254.75V359.4H257.65V354.05Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.55 358.25H255.6V358.55H256.55V358.25Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.05 358.6H255.1V358.9H256.05V358.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 354.062L276.952 354.062L276.952 353.812L257.652 353.812L257.652 354.062Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 353.824L276.952 353.824L276.952 353.574L257.652 353.574L257.652 353.824Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 353.8H254.6V354.05H257.7V353.8Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 353.55H254.6V353.8H257.7V353.55Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.7 353.55H254.6V354.05H257.7V353.55Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.642 376.855L276.642 376.855L276.642 371.505L257.642 371.505L257.642 376.855Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.201 375.805L275.701 375.805L275.701 372.505L274.201 372.505L274.201 375.805Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.188 375.805L273.688 375.805L273.688 372.505L272.188 372.505L272.188 375.805Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.176 375.805L271.676 375.805L271.676 372.505L270.176 372.505L270.176 375.805Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.163 375.805L269.663 375.805L269.663 372.505L268.163 372.505L268.163 375.805Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15 375.805L267.65 375.805L267.65 372.505L266.15 372.505L266.15 375.805Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.138 375.805L265.638 375.805L265.638 372.505L264.138 372.505L264.138 375.805Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.125 375.805L263.625 375.805L263.625 372.505L262.125 372.505L262.125 375.805Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.162 375.805L261.662 375.805L261.662 372.505L260.162 372.505L260.162 375.805Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 375.805L275.618 375.805L275.618 372.505L274.118 372.505L274.118 375.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 375.805L273.605 375.805L273.605 372.505L272.105 372.505L272.105 375.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 375.805L271.592 375.805L271.592 372.505L270.092 372.505L270.092 375.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 375.805L269.58 375.805L269.58 372.505L268.08 372.505L268.08 375.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 375.805L267.617 375.805L267.617 372.505L266.117 372.505L266.117 375.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 375.805L265.604 375.805L265.604 372.505L264.104 372.505L264.104 375.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 375.805L263.591 375.805L263.591 372.505L262.091 372.505L262.091 375.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 375.805L261.579 375.805L261.579 372.505L260.079 372.505L260.079 375.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 376.123L275.618 376.123L275.618 375.823L274.118 375.823L274.118 376.123Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 376.123L273.605 376.123L273.605 375.823L272.105 375.823L272.105 376.123Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 376.123L271.592 376.123L271.592 375.823L270.092 375.823L270.092 376.123Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 376.123L269.58 376.123L269.58 375.823L268.08 375.823L268.08 376.123Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 376.123L267.617 376.123L267.617 375.823L266.117 375.823L266.117 376.123Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 376.123L265.604 376.123L265.604 375.823L264.104 375.823L264.104 376.123Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 376.123L263.591 376.123L263.591 375.823L262.091 375.823L262.091 376.123Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 376.123L261.579 376.123L261.579 375.823L260.079 375.823L260.079 376.123Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.301 376.123L275.801 376.123L275.801 375.823L274.301 375.823L274.301 376.123Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.288 376.123L273.788 376.123L273.788 375.823L272.288 375.823L272.288 376.123Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.275 376.123L271.775 376.123L271.775 375.823L270.275 375.823L270.275 376.123Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.263 376.123L269.763 376.123L269.763 375.823L268.263 375.823L268.263 376.123Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25 376.123L267.75 376.123L267.75 375.823L266.25 375.823L266.25 376.123Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.237 376.123L265.737 376.123L265.737 375.823L264.237 375.823L264.237 376.123Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.225 376.123L263.725 376.123L263.725 375.823L262.225 375.823L262.225 376.123Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.262 376.123L261.762 376.123L261.762 375.823L260.262 375.823L260.262 376.123Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.053 373.749L261.604 373.749L261.604 372.499L260.053 372.499L260.053 373.749Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.06 373.163L263.61 373.163L263.61 372.513L262.06 372.513L262.06 373.163Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.076 373.567L265.626 373.567L265.626 372.517L264.076 372.517L264.076 373.567Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.09 373.788L267.64 373.788L267.64 372.538L266.09 372.538L266.09 373.788Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.052 373.476L269.602 373.476L269.602 372.526L268.052 372.526L268.052 373.476Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.065 373.241L271.615 373.241L271.615 372.541L270.065 372.541L270.065 373.241Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.077 372.882L273.627 372.882L273.627 372.532L272.077 372.532L272.077 372.882Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.09 372.999L275.64 372.999L275.64 372.499L274.09 372.499L274.09 372.999Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.65 371.5H254.75V376.85H257.65V371.5Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.05 376.05H255.1V376.35H256.05V376.05Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.05 376.05H256.1V376.35H257.05V376.05Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 371.533L276.952 371.533L276.952 371.283L257.652 371.283L257.652 371.533Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 371.295L276.952 371.295L276.952 371.045L257.652 371.045L257.652 371.295Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 371.25H254.6V371.5H257.7V371.25Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 371H254.6V371.25H257.7V371Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.7 371H254.6V371.5H257.7V371Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.642 382.645L276.642 382.645L276.642 377.295L257.642 377.295L257.642 382.645Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.201 381.646L275.701 381.646L275.701 378.346L274.201 378.346L274.201 381.646Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.188 381.646L273.688 381.646L273.688 378.346L272.188 378.346L272.188 381.646Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.176 381.646L271.676 381.646L271.676 378.346L270.176 378.346L270.176 381.646Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.163 381.646L269.663 381.646L269.663 378.346L268.163 378.346L268.163 381.646Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15 381.646L267.65 381.646L267.65 378.346L266.15 378.346L266.15 381.646Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.138 381.646L265.638 381.646L265.638 378.346L264.138 378.346L264.138 381.646Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.125 381.646L263.625 381.646L263.625 378.346L262.125 378.346L262.125 381.646Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.162 381.646L261.662 381.646L261.662 378.346L260.162 378.346L260.162 381.646Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 381.646L275.618 381.646L275.618 378.346L274.118 378.346L274.118 381.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 381.646L273.605 381.646L273.605 378.346L272.105 378.346L272.105 381.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 381.646L271.592 381.646L271.592 378.346L270.092 378.346L270.092 381.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 381.646L269.58 381.646L269.58 378.346L268.08 378.346L268.08 381.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 381.646L267.617 381.646L267.617 378.346L266.117 378.346L266.117 381.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 381.646L265.604 381.646L265.604 378.346L264.104 378.346L264.104 381.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 381.646L263.591 381.646L263.591 378.346L262.091 378.346L262.091 381.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 381.646L261.579 381.646L261.579 378.346L260.079 378.346L260.079 381.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 381.913L275.618 381.913L275.618 381.613L274.118 381.613L274.118 381.913Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 381.913L273.605 381.913L273.605 381.613L272.105 381.613L272.105 381.913Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 381.913L271.592 381.913L271.592 381.613L270.092 381.613L270.092 381.913Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 381.913L269.58 381.913L269.58 381.613L268.08 381.613L268.08 381.913Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 381.913L267.617 381.913L267.617 381.613L266.117 381.613L266.117 381.913Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 381.913L265.604 381.913L265.604 381.613L264.104 381.613L264.104 381.913Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 381.913L263.591 381.913L263.591 381.613L262.091 381.613L262.091 381.913Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 381.913L261.579 381.913L261.579 381.613L260.079 381.613L260.079 381.913Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.301 381.913L275.801 381.913L275.801 381.613L274.301 381.613L274.301 381.913Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.288 381.913L273.788 381.913L273.788 381.613L272.288 381.613L272.288 381.913Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.275 381.913L271.775 381.913L271.775 381.613L270.275 381.613L270.275 381.913Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.263 381.913L269.763 381.913L269.763 381.613L268.263 381.613L268.263 381.913Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25 381.913L267.75 381.913L267.75 381.613L266.25 381.613L266.25 381.913Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.237 381.913L265.737 381.913L265.737 381.613L264.237 381.613L264.237 381.913Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.225 381.913L263.725 381.913L263.725 381.613L262.225 381.613L262.225 381.913Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.262 381.913L261.762 381.913L261.762 381.613L260.262 381.613L260.262 381.913Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.053 379.359L261.604 379.359L261.604 378.359L260.053 378.359L260.053 379.359Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.06 380.497L263.61 380.497L263.61 378.347L262.06 378.347L262.06 380.497Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.076 380.301L265.626 380.301L265.626 378.351L264.076 378.351L264.076 380.301Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.09 379.429L267.64 379.429L267.64 378.379L266.09 378.379L266.09 379.429Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.052 379.076L269.602 379.076L269.602 378.376L268.052 378.376L268.052 379.076Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.065 378.66L271.615 378.66L271.615 378.36L270.065 378.36L270.065 378.66Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.077 379.359L273.627 379.359L273.627 378.359L272.077 378.359L272.077 379.359Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.09 380.842L275.64 380.842L275.64 378.342L274.09 378.342L274.09 380.842Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.65 377.35H254.75V382.7H257.65V377.35Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.55 381.5H255.6V381.8H256.55V381.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.05 381.9H255.1V382.2H256.05V381.9Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.05 381.9H256.1V382.2H257.05V381.9Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 377.323L276.952 377.323L276.952 377.073L257.652 377.073L257.652 377.323Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 377.085L276.952 377.085L276.952 376.835L257.652 376.835L257.652 377.085Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 377.1H254.6V377.35H257.7V377.1Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 376.85H254.6V377.1H257.7V376.85Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.7 376.85H254.6V377.35H257.7V376.85Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.642 330.182L276.642 330.182L276.642 324.832L257.642 324.832L257.642 330.182Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.201 329.182L275.701 329.182L275.701 325.882L274.201 325.882L274.201 329.182Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.188 329.182L273.688 329.182L273.688 325.882L272.188 325.882L272.188 329.182Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.176 329.182L271.676 329.182L271.676 325.882L270.176 325.882L270.176 329.182Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.163 329.182L269.663 329.182L269.663 325.882L268.163 325.882L268.163 329.182Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15 329.182L267.65 329.182L267.65 325.882L266.15 325.882L266.15 329.182Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.138 329.182L265.638 329.182L265.638 325.882L264.138 325.882L264.138 329.182Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.125 329.182L263.625 329.182L263.625 325.882L262.125 325.882L262.125 329.182Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.162 329.182L261.662 329.182L261.662 325.882L260.162 325.882L260.162 329.182Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 329.182L275.618 329.182L275.618 325.882L274.118 325.882L274.118 329.182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 329.182L273.605 329.182L273.605 325.882L272.105 325.882L272.105 329.182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 329.182L271.592 329.182L271.592 325.882L270.092 325.882L270.092 329.182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 329.182L269.58 329.182L269.58 325.882L268.08 325.882L268.08 329.182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 329.182L267.617 329.182L267.617 325.882L266.117 325.882L266.117 329.182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 329.182L265.604 329.182L265.604 325.882L264.104 325.882L264.104 329.182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 329.182L263.591 329.182L263.591 325.882L262.091 325.882L262.091 329.182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 329.182L261.579 329.182L261.579 325.882L260.079 325.882L260.079 329.182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 329.45L275.618 329.45L275.618 329.15L274.118 329.15L274.118 329.45Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 329.45L273.605 329.45L273.605 329.15L272.105 329.15L272.105 329.45Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 329.45L271.592 329.45L271.592 329.15L270.092 329.15L270.092 329.45Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 329.45L269.58 329.45L269.58 329.15L268.08 329.15L268.08 329.45Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 329.45L267.617 329.45L267.617 329.15L266.117 329.15L266.117 329.45Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 329.45L265.604 329.45L265.604 329.15L264.104 329.15L264.104 329.45Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 329.45L263.591 329.45L263.591 329.15L262.091 329.15L262.091 329.45Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 329.45L261.579 329.45L261.579 329.15L260.079 329.15L260.079 329.45Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.301 329.45L275.801 329.45L275.801 329.15L274.301 329.15L274.301 329.45Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.288 329.45L273.788 329.45L273.788 329.15L272.288 329.15L272.288 329.45Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.275 329.45L271.775 329.45L271.775 329.15L270.275 329.15L270.275 329.45Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.263 329.45L269.763 329.45L269.763 329.15L268.263 329.15L268.263 329.45Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25 329.45L267.75 329.45L267.75 329.15L266.25 329.15L266.25 329.45Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.237 329.45L265.737 329.45L265.737 329.15L264.237 329.15L264.237 329.45Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.225 329.45L263.725 329.45L263.725 329.15L262.225 329.15L262.225 329.45Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.262 329.45L261.762 329.45L261.762 329.15L260.262 329.15L260.262 329.45Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.053 326.896L261.604 326.896L261.604 325.896L260.053 325.896L260.053 326.896Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.06 328.033L263.61 328.033L263.61 325.883L262.06 325.883L262.06 328.033Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.076 327.838L265.626 327.838L265.626 325.888L264.076 325.888L264.076 327.838Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.09 326.966L267.64 326.966L267.64 325.916L266.09 325.916L266.09 326.966Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.052 326.613L269.602 326.613L269.602 325.913L268.052 325.913L268.052 326.613Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.065 326.196L271.615 326.196L271.615 325.896L270.065 325.896L270.065 326.196Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.077 326.896L273.627 326.896L273.627 325.896L272.077 325.896L272.077 326.896Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.09 328.379L275.64 328.379L275.64 325.879L274.09 325.879L274.09 328.379Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.65 324.85H254.75V330.2H257.65V324.85Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.55 329.05H255.6V329.35H256.55V329.05Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.05 329.4H255.1V329.7H256.05V329.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.05 329.4H256.1V329.7H257.05V329.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 324.86L276.952 324.86L276.952 324.61L257.652 324.61L257.652 324.86Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 324.622L276.952 324.622L276.952 324.372L257.652 324.372L257.652 324.622Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 324.6H254.6V324.85H257.7V324.6Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 324.35H254.6V324.6H257.7V324.35Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.7 324.35H254.6V324.85H257.7V324.35Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.642 336.022L276.642 336.022L276.642 330.672L257.642 330.672L257.642 336.022Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.201 334.972L275.701 334.972L275.701 331.672L274.201 331.672L274.201 334.972Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.188 334.972L273.688 334.972L273.688 331.672L272.188 331.672L272.188 334.972Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.176 334.972L271.676 334.972L271.676 331.672L270.176 331.672L270.176 334.972Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.163 334.972L269.663 334.972L269.663 331.672L268.163 331.672L268.163 334.972Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15 334.972L267.65 334.972L267.65 331.672L266.15 331.672L266.15 334.972Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.138 334.972L265.638 334.972L265.638 331.672L264.138 331.672L264.138 334.972Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.125 334.972L263.625 334.972L263.625 331.672L262.125 331.672L262.125 334.972Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.162 334.972L261.662 334.972L261.662 331.672L260.162 331.672L260.162 334.972Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 334.972L275.618 334.972L275.618 331.672L274.118 331.672L274.118 334.972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 334.972L273.605 334.972L273.605 331.672L272.105 331.672L272.105 334.972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 334.972L271.592 334.972L271.592 331.672L270.092 331.672L270.092 334.972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 334.972L269.58 334.972L269.58 331.672L268.08 331.672L268.08 334.972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 334.972L267.617 334.972L267.617 331.672L266.117 331.672L266.117 334.972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 334.972L265.604 334.972L265.604 331.672L264.104 331.672L264.104 334.972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 334.972L263.591 334.972L263.591 331.672L262.091 331.672L262.091 334.972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 334.972L261.579 334.972L261.579 331.672L260.079 331.672L260.079 334.972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 335.24L275.618 335.24L275.618 334.94L274.118 334.94L274.118 335.24Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 335.24L273.605 335.24L273.605 334.94L272.105 334.94L272.105 335.24Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 335.24L271.592 335.24L271.592 334.94L270.092 334.94L270.092 335.24Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 335.24L269.58 335.24L269.58 334.94L268.08 334.94L268.08 335.24Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 335.24L267.617 335.24L267.617 334.94L266.117 334.94L266.117 335.24Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 335.24L265.604 335.24L265.604 334.94L264.104 334.94L264.104 335.24Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 335.24L263.591 335.24L263.591 334.94L262.091 334.94L262.091 335.24Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 335.24L261.579 335.24L261.579 334.94L260.079 334.94L260.079 335.24Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.301 335.24L275.801 335.24L275.801 334.94L274.301 334.94L274.301 335.24Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.288 335.24L273.788 335.24L273.788 334.94L272.288 334.94L272.288 335.24Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.275 335.24L271.775 335.24L271.775 334.94L270.275 334.94L270.275 335.24Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.263 335.24L269.763 335.24L269.763 334.94L268.263 334.94L268.263 335.24Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25 335.24L267.75 335.24L267.75 334.94L266.25 334.94L266.25 335.24Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.237 335.24L265.737 335.24L265.737 334.94L264.237 334.94L264.237 335.24Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.225 335.24L263.725 335.24L263.725 334.94L262.225 334.94L262.225 335.24Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.262 335.24L261.762 335.24L261.762 334.94L260.262 334.94L260.262 335.24Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.053 332.187L261.604 332.188L261.604 331.688L260.053 331.687L260.053 332.187Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.06 332.046L263.61 332.046L263.61 331.696L262.06 331.696L262.06 332.046Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.076 332.187L265.626 332.188L265.626 331.688L264.076 331.687L264.076 332.187Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.09 332.223L267.64 332.223L267.64 331.673L266.09 331.673L266.09 332.223Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.052 332.046L269.602 332.046L269.602 331.696L268.052 331.696L268.052 332.046Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.065 331.987L271.615 331.987L271.615 331.687L270.065 331.687L270.065 331.987Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.055 332.159L273.605 332.159L273.605 331.659L272.055 331.659L272.055 332.159Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.09 332.157L275.64 332.157L275.64 331.707L274.09 331.707L274.09 332.157Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.65 330.65H254.75V336H257.65V330.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.55 334.85H255.6V335.15H256.55V334.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.05 335.25H255.1V335.55H256.05V335.25Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 330.65L276.952 330.65L276.952 330.4L257.652 330.4L257.652 330.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 330.412L276.952 330.412L276.952 330.162L257.652 330.162L257.652 330.412Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 330.45H254.6V330.7H257.7V330.45Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 330.2H254.6V330.45H257.7V330.2Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.7 330.2H254.6V330.7H257.7V330.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.642 318.552L276.642 318.552L276.642 313.202L257.642 313.202L257.642 318.552Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.201 317.502L275.701 317.502L275.701 314.202L274.201 314.202L274.201 317.502Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.188 317.502L273.688 317.502L273.688 314.202L272.188 314.202L272.188 317.502Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.176 317.502L271.676 317.502L271.676 314.202L270.176 314.202L270.176 317.502Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.163 317.502L269.663 317.502L269.663 314.202L268.163 314.202L268.163 317.502Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15 317.502L267.65 317.502L267.65 314.202L266.15 314.202L266.15 317.502Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.138 317.502L265.638 317.502L265.638 314.202L264.138 314.202L264.138 317.502Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.125 317.502L263.625 317.502L263.625 314.202L262.125 314.202L262.125 317.502Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.162 317.502L261.662 317.502L261.662 314.202L260.162 314.202L260.162 317.502Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 317.502L275.618 317.502L275.618 314.202L274.118 314.202L274.118 317.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 317.502L273.605 317.502L273.605 314.202L272.105 314.202L272.105 317.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 317.502L271.592 317.502L271.592 314.202L270.092 314.202L270.092 317.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 317.502L269.58 317.502L269.58 314.202L268.08 314.202L268.08 317.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 317.502L267.617 317.502L267.617 314.202L266.117 314.202L266.117 317.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 317.502L265.604 317.502L265.604 314.202L264.104 314.202L264.104 317.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 317.502L263.591 317.502L263.591 314.202L262.091 314.202L262.091 317.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 317.502L261.579 317.502L261.579 314.202L260.079 314.202L260.079 317.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 317.819L275.618 317.819L275.618 317.519L274.118 317.519L274.118 317.819Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 317.819L273.605 317.819L273.605 317.519L272.105 317.519L272.105 317.819Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 317.819L271.592 317.819L271.592 317.519L270.092 317.519L270.092 317.819Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 317.819L269.58 317.819L269.58 317.519L268.08 317.519L268.08 317.819Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 317.819L267.617 317.819L267.617 317.519L266.117 317.519L266.117 317.819Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 317.819L265.604 317.819L265.604 317.519L264.104 317.519L264.104 317.819Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 317.819L263.591 317.819L263.591 317.519L262.091 317.519L262.091 317.819Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 317.819L261.579 317.819L261.579 317.519L260.079 317.519L260.079 317.819Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.301 317.819L275.801 317.819L275.801 317.519L274.301 317.519L274.301 317.819Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.288 317.819L273.788 317.819L273.788 317.519L272.288 317.519L272.288 317.819Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.275 317.819L271.775 317.819L271.775 317.519L270.275 317.519L270.275 317.819Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.263 317.819L269.763 317.819L269.763 317.519L268.263 317.519L268.263 317.819Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25 317.819L267.75 317.819L267.75 317.519L266.25 317.519L266.25 317.819Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.237 317.819L265.737 317.819L265.737 317.519L264.237 317.519L264.237 317.819Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.225 317.819L263.725 317.819L263.725 317.519L262.225 317.519L262.225 317.819Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.262 317.819L261.762 317.819L261.762 317.519L260.262 317.519L260.262 317.819Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.053 315.215L261.604 315.215L261.604 314.215L260.053 314.215L260.053 315.215Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.06 316.353L263.61 316.353L263.61 314.203L262.06 314.203L262.06 316.353Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.076 316.158L265.626 316.158L265.626 314.208L264.076 314.208L264.076 316.158Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.09 315.286L267.64 315.286L267.64 314.236L266.09 314.236L266.09 315.286Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.052 314.933L269.602 314.933L269.602 314.233L268.052 314.233L268.052 314.933Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.065 314.516L271.615 314.516L271.615 314.216L270.065 314.216L270.065 314.516Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.077 315.215L273.627 315.215L273.627 314.215L272.077 314.215L272.077 315.215Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.09 316.698L275.64 316.698L275.64 314.198L274.09 314.198L274.09 316.698Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.65 313.2H254.75V318.55H257.65V313.2Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.55 317.4H255.6V317.7H256.55V317.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.05 317.75H255.1V318.05H256.05V317.75Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.05 317.75H256.1V318.05H257.05V317.75Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 313.229L276.952 313.229L276.952 312.979L257.652 312.979L257.652 313.229Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 312.991L276.952 312.991L276.952 312.741L257.652 312.741L257.652 312.991Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 312.95H254.6V313.2H257.7V312.95Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 312.7H254.6V312.95H257.7V312.7Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.7 312.7H254.6V313.2H257.7V312.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.642 324.342L276.642 324.342L276.642 318.992L257.642 318.992L257.642 324.342Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.201 323.342L275.701 323.342L275.701 320.042L274.201 320.042L274.201 323.342Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.188 323.342L273.688 323.342L273.688 320.042L272.188 320.042L272.188 323.342Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.176 323.342L271.676 323.342L271.676 320.042L270.176 320.042L270.176 323.342Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.163 323.342L269.663 323.342L269.663 320.042L268.163 320.042L268.163 323.342Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15 323.342L267.65 323.342L267.65 320.042L266.15 320.042L266.15 323.342Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.138 323.342L265.638 323.342L265.638 320.042L264.138 320.042L264.138 323.342Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.125 323.342L263.625 323.342L263.625 320.042L262.125 320.042L262.125 323.342Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.162 323.342L261.662 323.342L261.662 320.042L260.162 320.042L260.162 323.342Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 323.342L275.618 323.342L275.618 320.042L274.118 320.042L274.118 323.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 323.342L273.605 323.342L273.605 320.042L272.105 320.042L272.105 323.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 323.342L271.592 323.342L271.592 320.042L270.092 320.042L270.092 323.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 323.342L269.58 323.342L269.58 320.042L268.08 320.042L268.08 323.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 323.342L267.617 323.342L267.617 320.042L266.117 320.042L266.117 323.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 323.342L265.604 323.342L265.604 320.042L264.104 320.042L264.104 323.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 323.342L263.591 323.342L263.591 320.042L262.091 320.042L262.091 323.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 323.342L261.579 323.342L261.579 320.042L260.079 320.042L260.079 323.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 323.609L275.618 323.609L275.618 323.309L274.118 323.309L274.118 323.609Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 323.609L273.605 323.609L273.605 323.309L272.105 323.309L272.105 323.609Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 323.609L271.592 323.609L271.592 323.309L270.092 323.309L270.092 323.609Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 323.609L269.58 323.609L269.58 323.309L268.08 323.309L268.08 323.609Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 323.609L267.617 323.609L267.617 323.309L266.117 323.309L266.117 323.609Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 323.609L265.604 323.609L265.604 323.309L264.104 323.309L264.104 323.609Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 323.609L263.591 323.609L263.591 323.309L262.091 323.309L262.091 323.609Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 323.609L261.579 323.609L261.579 323.309L260.079 323.309L260.079 323.609Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.301 323.609L275.801 323.609L275.801 323.309L274.301 323.309L274.301 323.609Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.288 323.609L273.788 323.609L273.788 323.309L272.288 323.309L272.288 323.609Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.275 323.609L271.775 323.609L271.775 323.309L270.275 323.309L270.275 323.609Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.263 323.609L269.763 323.609L269.763 323.309L268.263 323.309L268.263 323.609Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25 323.609L267.75 323.609L267.75 323.309L266.25 323.309L266.25 323.609Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.237 323.609L265.737 323.609L265.737 323.309L264.237 323.309L264.237 323.609Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.225 323.609L263.725 323.609L263.725 323.309L262.225 323.309L262.225 323.609Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.262 323.609L261.762 323.609L261.762 323.309L260.262 323.309L260.262 323.609Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.053 320.557L261.604 320.557L261.604 320.057L260.053 320.057L260.053 320.557Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.06 320.416L263.61 320.416L263.61 320.066L262.06 320.066L262.06 320.416Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.076 320.557L265.626 320.557L265.626 320.057L264.076 320.057L264.076 320.557Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.09 320.593L267.64 320.593L267.64 320.043L266.09 320.043L266.09 320.593Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.052 320.416L269.602 320.416L269.602 320.066L268.052 320.066L268.052 320.416Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.065 320.356L271.615 320.356L271.615 320.056L270.065 320.056L270.065 320.356Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.055 320.529L273.605 320.529L273.605 320.029L272.055 320.029L272.055 320.529Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.09 320.527L275.64 320.527L275.64 320.077L274.09 320.077L274.09 320.527Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.65 319.05H254.75V324.4H257.65V319.05Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.55 323.2H255.6V323.5H256.55V323.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.05 323.6H255.1V323.9H256.05V323.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 319.02L276.952 319.02L276.952 318.77L257.652 318.77L257.652 319.02Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 318.782L276.952 318.782L276.952 318.532L257.652 318.532L257.652 318.782Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 318.8H254.6V319.05H257.7V318.8Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 318.55H254.6V318.8H257.7V318.55Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.7 318.55H254.6V319.05H257.7V318.55Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.642 341.812L276.642 341.812L276.642 336.462L257.642 336.462L257.642 341.812Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.201 340.812L275.701 340.812L275.701 337.513L274.201 337.513L274.201 340.812Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.188 340.812L273.688 340.812L273.688 337.513L272.188 337.513L272.188 340.812Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.176 340.812L271.676 340.812L271.676 337.513L270.176 337.513L270.176 340.812Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.163 340.812L269.663 340.812L269.663 337.513L268.163 337.513L268.163 340.812Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15 340.812L267.65 340.812L267.65 337.513L266.15 337.513L266.15 340.812Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.138 340.812L265.638 340.812L265.638 337.513L264.138 337.513L264.138 340.812Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.125 340.812L263.625 340.812L263.625 337.513L262.125 337.513L262.125 340.812Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.162 340.812L261.662 340.812L261.662 337.513L260.162 337.513L260.162 340.812Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 340.812L275.618 340.812L275.618 337.513L274.118 337.513L274.118 340.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 340.812L273.605 340.812L273.605 337.513L272.105 337.513L272.105 340.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 340.812L271.592 340.812L271.592 337.513L270.092 337.513L270.092 340.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 340.812L269.58 340.812L269.58 337.513L268.08 337.513L268.08 340.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 340.812L267.617 340.812L267.617 337.513L266.117 337.513L266.117 340.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 340.812L265.604 340.812L265.604 337.513L264.104 337.513L264.104 340.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 340.812L263.591 340.812L263.591 337.513L262.091 337.513L262.091 340.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 340.812L261.579 340.812L261.579 337.513L260.079 337.513L260.079 340.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 341.08L275.618 341.08L275.618 340.78L274.118 340.78L274.118 341.08Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 341.08L273.605 341.08L273.605 340.78L272.105 340.78L272.105 341.08Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 341.08L271.592 341.08L271.592 340.78L270.092 340.78L270.092 341.08Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 341.08L269.58 341.08L269.58 340.78L268.08 340.78L268.08 341.08Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 341.08L267.617 341.08L267.617 340.78L266.117 340.78L266.117 341.08Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 341.08L265.604 341.08L265.604 340.78L264.104 340.78L264.104 341.08Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 341.08L263.591 341.08L263.591 340.78L262.091 340.78L262.091 341.08Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 341.08L261.579 341.08L261.579 340.78L260.079 340.78L260.079 341.08Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.301 341.08L275.801 341.08L275.801 340.78L274.301 340.78L274.301 341.08Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.288 341.08L273.788 341.08L273.788 340.78L272.288 340.78L272.288 341.08Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.275 341.08L271.775 341.08L271.775 340.78L270.275 340.78L270.275 341.08Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.263 341.08L269.763 341.08L269.763 340.78L268.263 340.78L268.263 341.08Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25 341.08L267.75 341.08L267.75 340.78L266.25 340.78L266.25 341.08Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.237 341.08L265.737 341.08L265.737 340.78L264.237 340.78L264.237 341.08Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.225 341.08L263.725 341.08L263.725 340.78L262.225 340.78L262.225 341.08Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.262 341.08L261.762 341.08L261.762 340.78L260.262 340.78L260.262 341.08Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.053 338.756L261.604 338.756L261.604 337.506L260.053 337.506L260.053 338.756Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.06 338.17L263.61 338.17L263.61 337.52L262.06 337.52L262.06 338.17Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.076 338.574L265.626 338.574L265.626 337.524L264.076 337.524L264.076 338.574Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.09 338.795L267.64 338.795L267.64 337.545L266.09 337.545L266.09 338.795Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.052 338.483L269.602 338.483L269.602 337.533L268.052 337.533L268.052 338.483Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.065 338.248L271.615 338.248L271.615 337.548L270.065 337.548L270.065 338.248Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.077 337.889L273.627 337.889L273.627 337.539L272.077 337.539L272.077 337.889Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.09 338.006L275.64 338.006L275.64 337.506L274.09 337.506L274.09 338.006Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.65 336.5H254.75V341.85H257.65V336.5Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.05 341.05H255.1V341.35H256.05V341.05Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.05 341.05H256.1V341.35H257.05V341.05Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 336.49L276.952 336.49L276.952 336.24L257.652 336.24L257.652 336.49Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 336.252L276.952 336.252L276.952 336.002L257.652 336.002L257.652 336.252Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 336.25H254.6V336.5H257.7V336.25Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 336H254.6V336.25H257.7V336Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.7 336H254.6V336.5H257.7V336Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.642 347.653L276.642 347.653L276.642 342.303L257.642 342.303L257.642 347.653Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.201 346.603L275.701 346.603L275.701 343.303L274.201 343.303L274.201 346.603Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.188 346.603L273.688 346.603L273.688 343.303L272.188 343.303L272.188 346.603Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.176 346.603L271.676 346.603L271.676 343.303L270.176 343.303L270.176 346.603Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.163 346.603L269.663 346.603L269.663 343.303L268.163 343.303L268.163 346.603Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15 346.603L267.65 346.603L267.65 343.303L266.15 343.303L266.15 346.603Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.138 346.603L265.638 346.603L265.638 343.303L264.138 343.303L264.138 346.603Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.125 346.603L263.625 346.603L263.625 343.303L262.125 343.303L262.125 346.603Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.162 346.603L261.662 346.603L261.662 343.303L260.162 343.303L260.162 346.603Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 346.603L275.618 346.603L275.618 343.303L274.118 343.303L274.118 346.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 346.603L273.605 346.603L273.605 343.303L272.105 343.303L272.105 346.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 346.603L271.592 346.603L271.592 343.303L270.092 343.303L270.092 346.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 346.603L269.58 346.603L269.58 343.303L268.08 343.303L268.08 346.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 346.603L267.617 346.603L267.617 343.303L266.117 343.303L266.117 346.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 346.603L265.604 346.603L265.604 343.303L264.104 343.303L264.104 346.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 346.603L263.591 346.603L263.591 343.303L262.091 343.303L262.091 346.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 346.603L261.579 346.603L261.579 343.303L260.079 343.303L260.079 346.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.118 346.92L275.618 346.92L275.618 346.62L274.118 346.62L274.118 346.92Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.105 346.92L273.605 346.92L273.605 346.62L272.105 346.62L272.105 346.92Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.092 346.92L271.592 346.92L271.592 346.62L270.092 346.62L270.092 346.92Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 346.92L269.58 346.92L269.58 346.62L268.08 346.62L268.08 346.92Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.117 346.92L267.617 346.92L267.617 346.62L266.117 346.62L266.117 346.92Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.104 346.92L265.604 346.92L265.604 346.62L264.104 346.62L264.104 346.92Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.091 346.92L263.591 346.92L263.591 346.62L262.091 346.62L262.091 346.92Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.079 346.92L261.579 346.92L261.579 346.62L260.079 346.62L260.079 346.92Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.301 346.92L275.801 346.92L275.801 346.62L274.301 346.62L274.301 346.92Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.288 346.92L273.788 346.92L273.788 346.62L272.288 346.62L272.288 346.92Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.275 346.92L271.775 346.92L271.775 346.62L270.275 346.62L270.275 346.92Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.263 346.92L269.763 346.92L269.763 346.62L268.263 346.62L268.263 346.92Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25 346.92L267.75 346.92L267.75 346.62L266.25 346.62L266.25 346.92Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.237 346.92L265.737 346.92L265.737 346.62L264.237 346.62L264.237 346.92Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.225 346.92L263.725 346.92L263.725 346.62L262.225 346.62L262.225 346.92Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.262 346.92L261.762 346.92L261.762 346.62L260.262 346.62L260.262 346.92Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.053 344.316L261.604 344.316L261.604 343.316L260.053 343.316L260.053 344.316Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.06 345.454L263.61 345.454L263.61 343.304L262.06 343.304L262.06 345.454Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.076 345.258L265.626 345.258L265.626 343.308L264.076 343.308L264.076 345.258Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.09 344.386L267.64 344.386L267.64 343.336L266.09 343.336L266.09 344.386Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.052 344.034L269.602 344.034L269.602 343.334L268.052 343.334L268.052 344.034Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.065 343.617L271.615 343.617L271.615 343.317L270.065 343.317L270.065 343.617Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.077 344.316L273.627 344.316L273.627 343.316L272.077 343.316L272.077 344.316Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.09 345.799L275.64 345.799L275.64 343.299L274.09 343.299L274.09 345.799Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.65 342.3H254.75V347.65H257.65V342.3Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.55 346.5H255.6V346.8H256.55V346.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.05 346.85H255.1V347.15H256.05V346.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.05 346.85H256.1V347.15H257.05V346.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 342.33L276.952 342.33L276.952 342.08L257.652 342.08L257.652 342.33Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.652 342.092L276.952 342.092L276.952 341.842L257.652 341.842L257.652 342.092Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 342.05H254.6V342.3H257.7V342.05Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 341.8H254.6V342.05H257.7V341.8Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.7 341.8H254.6V342.3H257.7V341.8Z",
    fill: "black"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.032 343.594L228.032 343.594L228.032 338.244L209.032 338.244L209.032 343.594Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.591 342.594L227.091 342.594L227.091 339.294L225.591 339.294L225.591 342.594Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.579 342.594L225.079 342.594L225.079 339.294L223.579 339.294L223.579 342.594Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.566 342.594L223.066 342.594L223.066 339.294L221.566 339.294L221.566 342.594Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.553 342.594L221.053 342.594L221.053 339.294L219.553 339.294L219.553 342.594Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.541 342.594L219.041 342.594L219.041 339.294L217.541 339.294L217.541 342.594Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.528 342.594L217.028 342.594L217.028 339.294L215.528 339.294L215.528 342.594Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.565 342.594L215.065 342.594L215.065 339.294L213.565 339.294L213.565 342.594Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.552 342.594L213.052 342.594L213.052 339.294L211.552 339.294L211.552 342.594Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.508 342.594L227.008 342.594L227.008 339.294L225.508 339.294L225.508 342.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.495 342.594L224.995 342.594L224.995 339.294L223.495 339.294L223.495 342.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.482 342.594L222.982 342.594L222.982 339.294L221.482 339.294L221.482 342.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.52 342.594L221.02 342.594L221.02 339.294L219.52 339.294L219.52 342.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.507 342.594L219.007 342.594L219.007 339.294L217.507 339.294L217.507 342.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494 342.594L216.994 342.594L216.994 339.294L215.494 339.294L215.494 342.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.481 342.594L214.981 342.594L214.981 339.294L213.481 339.294L213.481 342.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.469 342.594L212.969 342.594L212.969 339.294L211.469 339.294L211.469 342.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.508 342.862L227.008 342.862L227.008 342.562L225.508 342.562L225.508 342.862Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.495 342.862L224.995 342.862L224.995 342.562L223.495 342.562L223.495 342.862Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.482 342.862L222.982 342.862L222.982 342.562L221.482 342.562L221.482 342.862Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.52 342.862L221.02 342.862L221.02 342.562L219.52 342.562L219.52 342.862Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.507 342.862L219.007 342.862L219.007 342.562L217.507 342.562L217.507 342.862Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494 342.862L216.994 342.862L216.994 342.562L215.494 342.562L215.494 342.862Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.481 342.862L214.981 342.862L214.981 342.562L213.481 342.562L213.481 342.862Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.469 342.862L212.969 342.862L212.969 342.562L211.469 342.562L211.469 342.862Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.691 342.862L227.191 342.862L227.191 342.562L225.691 342.562L225.691 342.862Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.678 342.862L225.178 342.862L225.178 342.562L223.678 342.562L223.678 342.862Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.666 342.862L223.166 342.862L223.166 342.562L221.666 342.562L221.666 342.862Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.653 342.862L221.153 342.862L221.153 342.562L219.653 342.562L219.653 342.862Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.64 342.862L219.14 342.862L219.14 342.562L217.64 342.562L217.64 342.862Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.627 342.862L217.127 342.862L217.127 342.562L215.627 342.562L215.627 342.862Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.665 342.862L215.165 342.862L215.165 342.562L213.665 342.562L213.665 342.862Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.652 342.862L213.152 342.862L213.152 342.562L211.652 342.562L211.652 342.862Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.444 340.307L212.994 340.307L212.994 339.307L211.444 339.307L211.444 340.307Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.45 341.445L215 341.445L215 339.295L213.45 339.295L213.45 341.445Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.467 341.25L217.017 341.25L217.017 339.3L215.467 339.3L215.467 341.25Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.48 340.378L219.03 340.378L219.03 339.328L217.48 339.328L217.48 340.378Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.492 340.025L221.042 340.025L221.042 339.325L219.492 339.325L219.492 340.025Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.455 339.608L223.005 339.608L223.005 339.308L221.455 339.308L221.455 339.608Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.468 340.307L225.018 340.307L225.018 339.307L223.468 339.307L223.468 340.307Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.48 341.791L227.03 341.791L227.03 339.291L225.48 339.291L225.48 341.791Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.05 338.3H206.15V343.65H209.05V338.3Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.95 342.45H207V342.75H207.95V342.45Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.45 342.85H206.5V343.15H207.45V342.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.45 342.85H207.5V343.15H208.45V342.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.042 338.272L228.342 338.272L228.342 338.022L209.042 338.022L209.042 338.272Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.042 338.034L228.342 338.034L228.342 337.784L209.042 337.784L209.042 338.034Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1 338.05H206V338.3H209.1V338.05Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1 337.8H206V338.05H209.1V337.8Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.1 337.8H206V338.3H209.1V337.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.032 349.434L228.032 349.434L228.032 344.084L209.032 344.084L209.032 349.434Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.591 348.384L227.091 348.384L227.091 345.084L225.591 345.084L225.591 348.384Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.579 348.384L225.079 348.384L225.079 345.084L223.579 345.084L223.579 348.384Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.566 348.384L223.066 348.384L223.066 345.084L221.566 345.084L221.566 348.384Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.553 348.384L221.053 348.384L221.053 345.084L219.553 345.084L219.553 348.384Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.541 348.384L219.041 348.384L219.041 345.084L217.541 345.084L217.541 348.384Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.528 348.384L217.028 348.384L217.028 345.084L215.528 345.084L215.528 348.384Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.565 348.384L215.065 348.384L215.065 345.084L213.565 345.084L213.565 348.384Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.552 348.384L213.052 348.384L213.052 345.084L211.552 345.084L211.552 348.384Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.508 348.384L227.008 348.384L227.008 345.084L225.508 345.084L225.508 348.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.495 348.384L224.995 348.384L224.995 345.084L223.495 345.084L223.495 348.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.482 348.384L222.982 348.384L222.982 345.084L221.482 345.084L221.482 348.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.52 348.384L221.02 348.384L221.02 345.084L219.52 345.084L219.52 348.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.507 348.384L219.007 348.384L219.007 345.084L217.507 345.084L217.507 348.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494 348.384L216.994 348.384L216.994 345.084L215.494 345.084L215.494 348.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.481 348.384L214.981 348.384L214.981 345.084L213.481 345.084L213.481 348.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.469 348.384L212.969 348.384L212.969 345.084L211.469 345.084L211.469 348.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.508 348.702L227.008 348.702L227.008 348.402L225.508 348.402L225.508 348.702Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.495 348.702L224.995 348.702L224.995 348.402L223.495 348.402L223.495 348.702Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.482 348.702L222.982 348.702L222.982 348.402L221.482 348.402L221.482 348.702Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.52 348.702L221.02 348.702L221.02 348.402L219.52 348.402L219.52 348.702Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.507 348.702L219.007 348.702L219.007 348.402L217.507 348.402L217.507 348.702Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494 348.702L216.994 348.702L216.994 348.402L215.494 348.402L215.494 348.702Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.481 348.702L214.981 348.702L214.981 348.402L213.481 348.402L213.481 348.702Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.469 348.702L212.969 348.702L212.969 348.402L211.469 348.402L211.469 348.702Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.691 348.702L227.191 348.702L227.191 348.402L225.691 348.402L225.691 348.702Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.678 348.702L225.178 348.702L225.178 348.402L223.678 348.402L223.678 348.702Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.666 348.702L223.166 348.702L223.166 348.402L221.666 348.402L221.666 348.702Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.653 348.702L221.153 348.702L221.153 348.402L219.653 348.402L219.653 348.702Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.64 348.702L219.14 348.702L219.14 348.402L217.64 348.402L217.64 348.702Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.627 348.702L217.127 348.702L217.127 348.402L215.627 348.402L215.627 348.702Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.665 348.702L215.165 348.702L215.165 348.402L213.665 348.402L213.665 348.702Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.652 348.702L213.152 348.702L213.152 348.402L211.652 348.402L211.652 348.702Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.444 345.6L212.994 345.6L212.994 345.1L211.444 345.1L211.444 345.6Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.45 345.458L215 345.458L215 345.108L213.45 345.108L213.45 345.458Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.467 345.6L217.017 345.6L217.017 345.1L215.467 345.1L215.467 345.6Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.48 345.635L219.03 345.635L219.03 345.085L217.48 345.085L217.48 345.635Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.492 345.458L221.042 345.458L221.042 345.108L219.492 345.108L219.492 345.458Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.455 345.399L223.005 345.399L223.005 345.099L221.455 345.099L221.455 345.399Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.495 345.621L225.045 345.621L225.045 345.121L223.495 345.121L223.495 345.621Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.48 345.569L227.03 345.569L227.03 345.119L225.48 345.119L225.48 345.569Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.05 344.1H206.15V349.45H209.05V344.1Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.95 348.3H207V348.6H207.95V348.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.45 348.65H206.5V348.95H207.45V348.65Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.042 344.112L228.342 344.112L228.342 343.862L209.042 343.862L209.042 344.112Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.042 343.874L228.342 343.874L228.342 343.624L209.042 343.624L209.042 343.874Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1 343.85H206V344.1H209.1V343.85Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1 343.6H206V343.85H209.1V343.6Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.1 343.6H206V344.1H209.1V343.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.032 331.964L228.032 331.964L228.032 326.614L209.032 326.614L209.032 331.964Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.591 330.964L227.091 330.964L227.091 327.664L225.591 327.664L225.591 330.964Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.579 330.964L225.079 330.964L225.079 327.664L223.579 327.664L223.579 330.964Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.566 330.964L223.066 330.964L223.066 327.664L221.566 327.664L221.566 330.964Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.553 330.964L221.053 330.964L221.053 327.664L219.553 327.664L219.553 330.964Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.541 330.964L219.041 330.964L219.041 327.664L217.541 327.664L217.541 330.964Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.528 330.964L217.028 330.964L217.028 327.664L215.528 327.664L215.528 330.964Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.565 330.964L215.065 330.964L215.065 327.664L213.565 327.664L213.565 330.964Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.552 330.964L213.052 330.964L213.052 327.664L211.552 327.664L211.552 330.964Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.508 330.964L227.008 330.964L227.008 327.664L225.508 327.664L225.508 330.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.495 330.964L224.995 330.964L224.995 327.664L223.495 327.664L223.495 330.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.482 330.964L222.982 330.964L222.982 327.664L221.482 327.664L221.482 330.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.52 330.964L221.02 330.964L221.02 327.664L219.52 327.664L219.52 330.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.507 330.964L219.007 330.964L219.007 327.664L217.507 327.664L217.507 330.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494 330.964L216.994 330.964L216.994 327.664L215.494 327.664L215.494 330.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.481 330.964L214.981 330.964L214.981 327.664L213.481 327.664L213.481 330.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.469 330.964L212.969 330.964L212.969 327.664L211.469 327.664L211.469 330.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.508 331.231L227.008 331.231L227.008 330.931L225.508 330.931L225.508 331.231Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.495 331.231L224.995 331.231L224.995 330.931L223.495 330.931L223.495 331.231Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.482 331.231L222.982 331.231L222.982 330.931L221.482 330.931L221.482 331.231Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.52 331.231L221.02 331.231L221.02 330.931L219.52 330.931L219.52 331.231Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.507 331.231L219.007 331.231L219.007 330.931L217.507 330.931L217.507 331.231Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494 331.231L216.994 331.231L216.994 330.931L215.494 330.931L215.494 331.231Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.481 331.231L214.981 331.231L214.981 330.931L213.481 330.931L213.481 331.231Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.469 331.231L212.969 331.231L212.969 330.931L211.469 330.931L211.469 331.231Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.691 331.231L227.191 331.231L227.191 330.931L225.691 330.931L225.691 331.231Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.678 331.231L225.178 331.231L225.178 330.931L223.678 330.931L223.678 331.231Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.666 331.231L223.166 331.231L223.166 330.931L221.666 330.931L221.666 331.231Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.653 331.231L221.153 331.231L221.153 330.931L219.653 330.931L219.653 331.231Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.64 331.231L219.14 331.231L219.14 330.931L217.64 330.931L217.64 331.231Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.627 331.231L217.127 331.231L217.127 330.931L215.627 330.931L215.627 331.231Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.665 331.231L215.165 331.231L215.165 330.931L213.665 330.931L213.665 331.231Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.652 331.231L213.152 331.231L213.152 330.931L211.652 330.931L211.652 331.231Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.444 328.677L212.994 328.677L212.994 327.677L211.444 327.677L211.444 328.677Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.45 329.815L215 329.815L215 327.665L213.45 327.665L213.45 329.815Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.467 329.62L217.017 329.62L217.017 327.67L215.467 327.67L215.467 329.62Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.48 328.748L219.03 328.748L219.03 327.698L217.48 327.698L217.48 328.748Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.492 328.395L221.042 328.395L221.042 327.695L219.492 327.695L219.492 328.395Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.455 327.978L223.005 327.978L223.005 327.678L221.455 327.678L221.455 327.978Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.468 328.677L225.018 328.677L225.018 327.677L223.468 327.677L223.468 328.677Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.48 330.16L227.03 330.16L227.03 327.66L225.48 327.66L225.48 330.16Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.05 326.65H206.15V332H209.05V326.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.95 330.85H207V331.15H207.95V330.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.45 331.2H206.5V331.5H207.45V331.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.45 331.2H207.5V331.5H208.45V331.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.042 326.641L228.342 326.641L228.342 326.391L209.042 326.391L209.042 326.641Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.042 326.403L228.342 326.403L228.342 326.153L209.042 326.153L209.042 326.403Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1 326.4H206V326.65H209.1V326.4Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1 326.15H206V326.4H209.1V326.15Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.1 326.15H206V326.65H209.1V326.15Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.032 337.804L228.032 337.804L228.032 332.454L209.032 332.454L209.032 337.804Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.591 336.754L227.091 336.754L227.091 333.454L225.591 333.454L225.591 336.754Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.579 336.754L225.079 336.754L225.079 333.454L223.579 333.454L223.579 336.754Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.566 336.754L223.066 336.754L223.066 333.454L221.566 333.454L221.566 336.754Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.553 336.754L221.053 336.754L221.053 333.454L219.553 333.454L219.553 336.754Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.541 336.754L219.041 336.754L219.041 333.454L217.541 333.454L217.541 336.754Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.528 336.754L217.028 336.754L217.028 333.454L215.528 333.454L215.528 336.754Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.565 336.754L215.065 336.754L215.065 333.454L213.565 333.454L213.565 336.754Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.552 336.754L213.052 336.754L213.052 333.454L211.552 333.454L211.552 336.754Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.508 336.754L227.008 336.754L227.008 333.454L225.508 333.454L225.508 336.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.495 336.754L224.995 336.754L224.995 333.454L223.495 333.454L223.495 336.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.482 336.754L222.982 336.754L222.982 333.454L221.482 333.454L221.482 336.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.52 336.754L221.02 336.754L221.02 333.454L219.52 333.454L219.52 336.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.507 336.754L219.007 336.754L219.007 333.454L217.507 333.454L217.507 336.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494 336.754L216.994 336.754L216.994 333.454L215.494 333.454L215.494 336.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.481 336.754L214.981 336.754L214.981 333.454L213.481 333.454L213.481 336.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.469 336.754L212.969 336.754L212.969 333.454L211.469 333.454L211.469 336.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.508 337.072L227.008 337.072L227.008 336.772L225.508 336.772L225.508 337.072Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.495 337.072L224.995 337.072L224.995 336.772L223.495 336.772L223.495 337.072Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.482 337.072L222.982 337.072L222.982 336.772L221.482 336.772L221.482 337.072Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.52 337.072L221.02 337.072L221.02 336.772L219.52 336.772L219.52 337.072Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.507 337.072L219.007 337.072L219.007 336.772L217.507 336.772L217.507 337.072Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494 337.072L216.994 337.072L216.994 336.772L215.494 336.772L215.494 337.072Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.481 337.072L214.981 337.072L214.981 336.772L213.481 336.772L213.481 337.072Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.469 337.072L212.969 337.072L212.969 336.772L211.469 336.772L211.469 337.072Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.691 337.072L227.191 337.072L227.191 336.772L225.691 336.772L225.691 337.072Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.678 337.072L225.178 337.072L225.178 336.772L223.678 336.772L223.678 337.072Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.666 337.072L223.166 337.072L223.166 336.772L221.666 336.772L221.666 337.072Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.653 337.072L221.153 337.072L221.153 336.772L219.653 336.772L219.653 337.072Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.64 337.072L219.14 337.072L219.14 336.772L217.64 336.772L217.64 337.072Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.627 337.072L217.127 337.072L217.127 336.772L215.627 336.772L215.627 337.072Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.665 337.072L215.165 337.072L215.165 336.772L213.665 336.772L213.665 337.072Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.652 337.072L213.152 337.072L213.152 336.772L211.652 336.772L211.652 337.072Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.444 333.969L212.994 333.969L212.994 333.469L211.444 333.469L211.444 333.969Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.45 333.828L215 333.828L215 333.478L213.45 333.478L213.45 333.828Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.467 333.969L217.017 333.969L217.017 333.469L215.467 333.469L215.467 333.969Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.48 334.005L219.03 334.005L219.03 333.455L217.48 333.455L217.48 334.005Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.492 333.828L221.042 333.828L221.042 333.478L219.492 333.478L219.492 333.828Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.455 333.768L223.005 333.768L223.005 333.468L221.455 333.468L221.455 333.768Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.495 333.991L225.045 333.991L225.045 333.491L223.495 333.491L223.495 333.991Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.48 333.939L227.03 333.939L227.03 333.489L225.48 333.489L225.48 333.939Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.05 332.45H206.15V337.8H209.05V332.45Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.95 336.65H207V336.95H207.95V336.65Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.45 337H206.5V337.3H207.45V337Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.042 332.482L228.342 332.482L228.342 332.232L209.042 332.232L209.042 332.482Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.042 332.244L228.342 332.244L228.342 331.994L209.042 331.994L209.042 332.244Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1 332.2H206V332.45H209.1V332.2Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1 331.95H206V332.2H209.1V331.95Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.1 331.95H206V332.45H209.1V331.95Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.032 355.274L228.032 355.274L228.032 349.924L209.032 349.924L209.032 355.274Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.591 354.224L227.091 354.224L227.091 350.924L225.591 350.924L225.591 354.224Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.579 354.224L225.079 354.224L225.079 350.924L223.579 350.924L223.579 354.224Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.566 354.224L223.066 354.224L223.066 350.924L221.566 350.924L221.566 354.224Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.553 354.224L221.053 354.224L221.053 350.924L219.553 350.924L219.553 354.224Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.541 354.224L219.041 354.224L219.041 350.924L217.541 350.924L217.541 354.224Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.528 354.224L217.028 354.224L217.028 350.924L215.528 350.924L215.528 354.224Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.565 354.224L215.065 354.224L215.065 350.924L213.565 350.924L213.565 354.224Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.552 354.224L213.052 354.224L213.052 350.924L211.552 350.924L211.552 354.224Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.508 354.224L227.008 354.224L227.008 350.924L225.508 350.924L225.508 354.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.495 354.224L224.995 354.224L224.995 350.924L223.495 350.924L223.495 354.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.482 354.224L222.982 354.224L222.982 350.924L221.482 350.924L221.482 354.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.52 354.224L221.02 354.224L221.02 350.924L219.52 350.924L219.52 354.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.507 354.224L219.007 354.224L219.007 350.924L217.507 350.924L217.507 354.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494 354.224L216.994 354.224L216.994 350.924L215.494 350.924L215.494 354.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.481 354.224L214.981 354.224L214.981 350.924L213.481 350.924L213.481 354.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.469 354.224L212.969 354.224L212.969 350.924L211.469 350.924L211.469 354.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.508 354.492L227.008 354.492L227.008 354.192L225.508 354.192L225.508 354.492Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.495 354.492L224.995 354.492L224.995 354.192L223.495 354.192L223.495 354.492Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.482 354.492L222.982 354.492L222.982 354.192L221.482 354.192L221.482 354.492Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.52 354.492L221.02 354.492L221.02 354.192L219.52 354.192L219.52 354.492Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.507 354.492L219.007 354.492L219.007 354.192L217.507 354.192L217.507 354.492Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494 354.492L216.994 354.492L216.994 354.192L215.494 354.192L215.494 354.492Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.481 354.492L214.981 354.492L214.981 354.192L213.481 354.192L213.481 354.492Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.469 354.492L212.969 354.492L212.969 354.192L211.469 354.192L211.469 354.492Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.691 354.492L227.191 354.492L227.191 354.192L225.691 354.192L225.691 354.492Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.678 354.492L225.178 354.492L225.178 354.192L223.678 354.192L223.678 354.492Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.666 354.492L223.166 354.492L223.166 354.192L221.666 354.192L221.666 354.492Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.653 354.492L221.153 354.492L221.153 354.192L219.653 354.192L219.653 354.492Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.64 354.492L219.14 354.492L219.14 354.192L217.64 354.192L217.64 354.492Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.627 354.492L217.127 354.492L217.127 354.192L215.627 354.192L215.627 354.492Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.665 354.492L215.165 354.492L215.165 354.192L213.665 354.192L213.665 354.492Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.652 354.492L213.152 354.492L213.152 354.192L211.652 354.192L211.652 354.492Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.444 352.168L212.994 352.168L212.994 350.918L211.444 350.918L211.444 352.168Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.45 351.582L215 351.582L215 350.932L213.45 350.932L213.45 351.582Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.467 351.986L217.017 351.986L217.017 350.936L215.467 350.936L215.467 351.986Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.48 352.207L219.03 352.207L219.03 350.957L217.48 350.957L217.48 352.207Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.492 351.895L221.042 351.895L221.042 350.945L219.492 350.945L219.492 351.895Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.455 351.66L223.005 351.66L223.005 350.96L221.455 350.96L221.455 351.66Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.468 351.301L225.018 351.301L225.018 350.951L223.468 350.951L223.468 351.301Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.48 351.418L227.03 351.418L227.03 350.918L225.48 350.918L225.48 351.418Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.05 349.9H206.15V355.25H209.05V349.9Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.45 354.5H206.5V354.8H207.45V354.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.45 354.5H207.5V354.8H208.45V354.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.042 349.902L228.342 349.902L228.342 349.652L209.042 349.652L209.042 349.902Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.042 349.664L228.342 349.664L228.342 349.414L209.042 349.414L209.042 349.664Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1 349.7H206V349.95H209.1V349.7Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1 349.45H206V349.7H209.1V349.45Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.1 349.45H206V349.95H209.1V349.45Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.032 361.065L228.032 361.065L228.032 355.715L209.032 355.715L209.032 361.065Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.591 360.065L227.091 360.065L227.091 356.765L225.591 356.765L225.591 360.065Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.579 360.065L225.079 360.065L225.079 356.765L223.579 356.765L223.579 360.065Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.566 360.065L223.066 360.065L223.066 356.765L221.566 356.765L221.566 360.065Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.553 360.065L221.053 360.065L221.053 356.765L219.553 356.765L219.553 360.065Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.541 360.065L219.041 360.065L219.041 356.765L217.541 356.765L217.541 360.065Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.528 360.065L217.028 360.065L217.028 356.765L215.528 356.765L215.528 360.065Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.565 360.065L215.065 360.065L215.065 356.765L213.565 356.765L213.565 360.065Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.552 360.065L213.052 360.065L213.052 356.765L211.552 356.765L211.552 360.065Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.508 360.065L227.008 360.065L227.008 356.765L225.508 356.765L225.508 360.065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.495 360.065L224.995 360.065L224.995 356.765L223.495 356.765L223.495 360.065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.482 360.065L222.982 360.065L222.982 356.765L221.482 356.765L221.482 360.065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.52 360.065L221.02 360.065L221.02 356.765L219.52 356.765L219.52 360.065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.507 360.065L219.007 360.065L219.007 356.765L217.507 356.765L217.507 360.065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494 360.065L216.994 360.065L216.994 356.765L215.494 356.765L215.494 360.065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.481 360.065L214.981 360.065L214.981 356.765L213.481 356.765L213.481 360.065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.469 360.065L212.969 360.065L212.969 356.765L211.469 356.765L211.469 360.065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.508 360.332L227.008 360.332L227.008 360.032L225.508 360.032L225.508 360.332Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.495 360.332L224.995 360.332L224.995 360.032L223.495 360.032L223.495 360.332Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.482 360.332L222.982 360.332L222.982 360.032L221.482 360.032L221.482 360.332Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.52 360.332L221.02 360.332L221.02 360.032L219.52 360.032L219.52 360.332Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.507 360.332L219.007 360.332L219.007 360.032L217.507 360.032L217.507 360.332Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494 360.332L216.994 360.332L216.994 360.032L215.494 360.032L215.494 360.332Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.481 360.332L214.981 360.332L214.981 360.032L213.481 360.032L213.481 360.332Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.469 360.332L212.969 360.332L212.969 360.032L211.469 360.032L211.469 360.332Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.691 360.332L227.191 360.332L227.191 360.032L225.691 360.032L225.691 360.332Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.678 360.332L225.178 360.332L225.178 360.032L223.678 360.032L223.678 360.332Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.666 360.332L223.166 360.332L223.166 360.032L221.666 360.032L221.666 360.332Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.653 360.332L221.153 360.332L221.153 360.032L219.653 360.032L219.653 360.332Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.64 360.332L219.14 360.332L219.14 360.032L217.64 360.032L217.64 360.332Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.627 360.332L217.127 360.332L217.127 360.032L215.627 360.032L215.627 360.332Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.665 360.332L215.165 360.332L215.165 360.032L213.665 360.032L213.665 360.332Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.652 360.332L213.152 360.332L213.152 360.032L211.652 360.032L211.652 360.332Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.444 357.778L212.994 357.778L212.994 356.778L211.444 356.778L211.444 357.778Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.45 358.916L215 358.916L215 356.766L213.45 356.766L213.45 358.916Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.467 358.72L217.017 358.72L217.017 356.77L215.467 356.77L215.467 358.72Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.48 357.849L219.03 357.849L219.03 356.799L217.48 356.799L217.48 357.849Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.492 357.496L221.042 357.496L221.042 356.796L219.492 356.796L219.492 357.496Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.455 357.079L223.005 357.079L223.005 356.779L221.455 356.779L221.455 357.079Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.468 357.778L225.018 357.778L225.018 356.778L223.468 356.778L223.468 357.778Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.48 359.261L227.03 359.261L227.03 356.761L225.48 356.761L225.48 359.261Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.05 355.75H206.15V361.1H209.05V355.75Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.95 359.95H207V360.25H207.95V359.95Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.45 360.3H206.5V360.6H207.45V360.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.45 360.3H207.5V360.6H208.45V360.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.042 355.742L228.342 355.742L228.342 355.492L209.042 355.492L209.042 355.742Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.042 355.504L228.342 355.504L228.342 355.254L209.042 355.254L209.042 355.504Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1 355.5H206V355.75H209.1V355.5Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1 355.25H206V355.5H209.1V355.25Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.1 355.25H206V355.75H209.1V355.25Z",
    fill: "black"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.224 351.866L311.424 351.866L311.424 344.766L286.224 344.766L286.224 351.866Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.126 350.516L310.126 350.516L310.126 346.166L308.126 346.166L308.126 350.516Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.446 350.516L307.446 350.516L307.446 346.166L305.446 346.166L305.446 350.516Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.815 350.516L304.815 350.516L304.815 346.166L302.815 346.166L302.815 350.516Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.135 350.516L302.135 350.516L302.135 346.166L300.135 346.166L300.135 350.516Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.455 350.516L299.455 350.516L299.455 346.166L297.455 346.166L297.455 350.516Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.824 350.516L296.824 350.516L296.824 346.166L294.824 346.166L294.824 350.516Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.144 350.516L294.144 350.516L294.144 346.166L292.144 346.166L292.144 350.516Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.463 350.516L291.463 350.516L291.463 346.166L289.463 346.166L289.463 350.516Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.049 350.516L310.049 350.516L310.049 346.166L308.049 346.166L308.049 350.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.369 350.516L307.369 350.516L307.369 346.166L305.369 346.166L305.369 350.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.688 350.516L304.688 350.516L304.688 346.166L302.688 346.166L302.688 350.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.058 350.516L302.058 350.516L302.058 346.166L300.058 346.166L300.058 350.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.377 350.516L299.377 350.516L299.377 346.166L297.377 346.166L297.377 350.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.697 350.516L296.697 350.516L296.697 346.166L294.697 346.166L294.697 350.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.066 350.516L294.066 350.516L294.066 346.166L292.066 346.166L292.066 350.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.386 350.516L291.386 350.516L291.386 346.166L289.386 346.166L289.386 350.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.049 350.905L310.049 350.905L310.049 350.505L308.049 350.505L308.049 350.905Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.369 350.905L307.369 350.905L307.369 350.505L305.369 350.505L305.369 350.905Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.688 350.905L304.688 350.905L304.688 350.505L302.688 350.505L302.688 350.905Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.058 350.905L302.058 350.905L302.058 350.505L300.058 350.505L300.058 350.905Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.377 350.905L299.377 350.905L299.377 350.505L297.377 350.505L297.377 350.905Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.697 350.905L296.697 350.905L296.697 350.505L294.697 350.505L294.697 350.905Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.066 350.905L294.066 350.905L294.066 350.505L292.066 350.505L292.066 350.905Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.386 350.905L291.386 350.905L291.386 350.505L289.386 350.505L289.386 350.905Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.242 350.905L310.242 350.905L310.242 350.505L308.242 350.505L308.242 350.905Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.611 350.905L307.611 350.905L307.611 350.505L305.611 350.505L305.611 350.905Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.931 350.905L304.931 350.905L304.931 350.505L302.931 350.505L302.931 350.905Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.25 350.905L302.25 350.905L302.25 350.505L300.25 350.505L300.25 350.905Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.62 350.905L299.62 350.905L299.62 350.505L297.62 350.505L297.62 350.905Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.939 350.905L296.939 350.905L296.939 350.505L294.939 350.505L294.939 350.905Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.259 350.905L294.259 350.905L294.259 350.505L292.259 350.505L292.259 350.905Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.578 350.905L291.578 350.905L291.578 350.505L289.578 350.505L289.578 350.905Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.369 347.479L291.419 347.479L291.419 346.179L289.369 346.179L289.369 347.479Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.041 348.99L294.091 348.99L294.091 346.14L292.041 346.14L292.041 348.99Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.677 348.73L296.727 348.73L296.727 346.13L294.677 346.13L294.677 348.73Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.358 347.573L299.408 347.573L299.408 346.173L297.358 346.173L297.358 347.573Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.038 347.104L302.088 347.104L302.088 346.154L300.038 346.154L300.038 347.104Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.669 346.55L304.719 346.55L304.719 346.15L302.669 346.15L302.669 346.55Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.349 347.479L307.399 347.479L307.399 346.179L305.349 346.179L305.349 347.479Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.03 349.449L310.08 349.449L310.08 346.149L308.03 346.149L308.03 349.449Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.25 344.8H282.35V351.9H286.25V344.8Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.65 350.35H283.4V350.75H284.65V350.35Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284 350.85H282.75V351.25H284V350.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.35 350.85H284.1V351.25H285.35V350.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.236 344.814L311.836 344.814L311.836 344.514L286.236 344.514L286.236 344.814Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.236 344.465L311.836 344.465L311.836 344.115L286.236 344.115L286.236 344.465Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2 344.45H282.1V344.75H286.2V344.45Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2 344.15H282.1V344.5H286.2V344.15Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.2 344.15H282.1V344.8H286.2V344.15Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.224 359.629L311.424 359.629L311.424 352.529L286.224 352.529L286.224 359.629Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.126 358.229L310.126 358.229L310.126 353.879L308.126 353.879L308.126 358.229Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.446 358.229L307.446 358.229L307.446 353.879L305.446 353.879L305.446 358.229Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.815 358.229L304.815 358.229L304.815 353.879L302.815 353.879L302.815 358.229Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.135 358.229L302.135 358.229L302.135 353.879L300.135 353.879L300.135 358.229Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.455 358.229L299.455 358.229L299.455 353.879L297.455 353.879L297.455 358.229Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.824 358.229L296.824 358.229L296.824 353.879L294.824 353.879L294.824 358.229Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.144 358.229L294.144 358.229L294.144 353.879L292.144 353.879L292.144 358.229Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.463 358.229L291.463 358.229L291.463 353.879L289.463 353.879L289.463 358.229Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.049 358.229L310.049 358.229L310.049 353.879L308.049 353.879L308.049 358.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.369 358.229L307.369 358.229L307.369 353.879L305.369 353.879L305.369 358.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.688 358.229L304.688 358.229L304.688 353.879L302.688 353.879L302.688 358.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.058 358.229L302.058 358.229L302.058 353.879L300.058 353.879L300.058 358.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.377 358.229L299.377 358.229L299.377 353.879L297.377 353.879L297.377 358.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.697 358.229L296.697 358.229L296.697 353.879L294.697 353.879L294.697 358.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.066 358.229L294.066 358.229L294.066 353.879L292.066 353.879L292.066 358.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.386 358.229L291.386 358.229L291.386 353.879L289.386 353.879L289.386 358.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.049 358.618L310.049 358.618L310.049 358.218L308.049 358.218L308.049 358.618Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.369 358.618L307.369 358.618L307.369 358.218L305.369 358.218L305.369 358.618Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.688 358.618L304.688 358.618L304.688 358.218L302.688 358.218L302.688 358.618Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.058 358.618L302.058 358.618L302.058 358.218L300.058 358.218L300.058 358.618Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.377 358.618L299.377 358.618L299.377 358.218L297.377 358.218L297.377 358.618Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.697 358.618L296.697 358.618L296.697 358.218L294.697 358.218L294.697 358.618Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.066 358.618L294.066 358.618L294.066 358.218L292.066 358.218L292.066 358.618Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.386 358.618L291.386 358.618L291.386 358.218L289.386 358.218L289.386 358.618Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.242 358.618L310.242 358.618L310.242 358.218L308.242 358.218L308.242 358.618Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.611 358.618L307.611 358.618L307.611 358.218L305.611 358.218L305.611 358.618Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.931 358.618L304.931 358.618L304.931 358.218L302.931 358.218L302.931 358.618Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.25 358.618L302.25 358.618L302.25 358.218L300.25 358.218L300.25 358.618Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.62 358.618L299.62 358.618L299.62 358.218L297.62 358.218L297.62 358.618Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.939 358.618L296.939 358.618L296.939 358.218L294.939 358.218L294.939 358.618Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.259 358.618L294.259 358.618L294.259 358.218L292.259 358.218L292.259 358.618Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.578 358.618L291.578 358.618L291.578 358.218L289.578 358.218L289.578 358.618Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.369 354.53L291.419 354.53L291.419 353.88L289.369 353.88L289.369 354.53Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.041 354.342L294.091 354.342L294.091 353.892L292.041 353.892L292.041 354.342Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.677 354.53L296.727 354.53L296.727 353.88L294.677 353.88L294.677 354.53Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.358 354.577L299.408 354.577L299.408 353.877L297.358 353.877L297.358 354.577Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.038 354.342L302.088 354.342L302.088 353.892L300.038 353.892L300.038 354.342Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.669 354.263L304.719 354.263L304.719 353.863L302.669 353.863L302.669 354.263Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.319 354.542L307.369 354.542L307.369 353.892L305.319 353.892L305.319 354.542Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.03 354.489L310.08 354.489L310.08 353.889L308.03 353.889L308.03 354.489Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.25 352.5H282.35V359.6H286.25V352.5Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.65 358.1H283.4V358.5H284.65V358.1Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284 358.6H282.75V359H284V358.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.236 352.527L311.836 352.527L311.836 352.227L286.236 352.227L286.236 352.527Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.236 352.228L311.836 352.228L311.836 351.878L286.236 351.878L286.236 352.228Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2 352.2H282.1V352.5H286.2V352.2Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2 351.85H282.1V352.2H286.2V351.85Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.2 351.85H282.1V352.5H286.2V351.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.224 336.391L311.424 336.391L311.424 329.29L286.224 329.29L286.224 336.391Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.126 335.041L310.126 335.041L310.126 330.691L308.126 330.691L308.126 335.041Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.446 335.041L307.446 335.041L307.446 330.691L305.446 330.691L305.446 335.041Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.815 335.041L304.815 335.041L304.815 330.691L302.815 330.691L302.815 335.041Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.135 335.041L302.135 335.041L302.135 330.691L300.135 330.691L300.135 335.041Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.455 335.041L299.455 335.041L299.455 330.691L297.455 330.691L297.455 335.041Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.824 335.041L296.824 335.041L296.824 330.691L294.824 330.691L294.824 335.041Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.144 335.041L294.144 335.041L294.144 330.691L292.144 330.691L292.144 335.041Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.463 335.041L291.463 335.041L291.463 330.691L289.463 330.691L289.463 335.041Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.049 335.041L310.049 335.041L310.049 330.691L308.049 330.691L308.049 335.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.369 335.041L307.369 335.041L307.369 330.691L305.369 330.691L305.369 335.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.688 335.041L304.688 335.041L304.688 330.691L302.688 330.691L302.688 335.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.058 335.041L302.058 335.041L302.058 330.691L300.058 330.691L300.058 335.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.377 335.041L299.377 335.041L299.377 330.691L297.377 330.691L297.377 335.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.697 335.041L296.697 335.041L296.697 330.691L294.697 330.691L294.697 335.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.066 335.041L294.066 335.041L294.066 330.691L292.066 330.691L292.066 335.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.386 335.041L291.386 335.041L291.386 330.691L289.386 330.691L289.386 335.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.049 335.429L310.049 335.429L310.049 335.029L308.049 335.029L308.049 335.429Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.369 335.429L307.369 335.429L307.369 335.029L305.369 335.029L305.369 335.429Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.688 335.429L304.688 335.429L304.688 335.029L302.688 335.029L302.688 335.429Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.058 335.429L302.058 335.429L302.058 335.029L300.058 335.029L300.058 335.429Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.377 335.429L299.377 335.429L299.377 335.029L297.377 335.029L297.377 335.429Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.697 335.429L296.697 335.429L296.697 335.029L294.697 335.029L294.697 335.429Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.066 335.429L294.066 335.429L294.066 335.029L292.066 335.029L292.066 335.429Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.386 335.429L291.386 335.429L291.386 335.029L289.386 335.029L289.386 335.429Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.242 335.429L310.242 335.429L310.242 335.029L308.242 335.029L308.242 335.429Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.611 335.429L307.611 335.429L307.611 335.029L305.611 335.029L305.611 335.429Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.931 335.429L304.931 335.429L304.931 335.029L302.931 335.029L302.931 335.429Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.25 335.429L302.25 335.429L302.25 335.029L300.25 335.029L300.25 335.429Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.62 335.429L299.62 335.429L299.62 335.029L297.62 335.029L297.62 335.429Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.939 335.429L296.939 335.429L296.939 335.029L294.939 335.029L294.939 335.429Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.259 335.429L294.259 335.429L294.259 335.029L292.259 335.029L292.259 335.429Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.578 335.429L291.578 335.429L291.578 335.029L289.578 335.029L289.578 335.429Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.369 332.003L291.419 332.003L291.419 330.703L289.369 330.703L289.369 332.003Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.041 333.514L294.091 333.514L294.091 330.664L292.041 330.664L292.041 333.514Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.677 333.255L296.727 333.255L296.727 330.655L294.677 330.655L294.677 333.255Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.358 332.097L299.408 332.097L299.408 330.697L297.358 330.697L297.358 332.097Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.038 331.628L302.088 331.628L302.088 330.678L300.038 330.678L300.038 331.628Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.669 331.074L304.719 331.074L304.719 330.674L302.669 330.674L302.669 331.074Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.349 332.003L307.399 332.003L307.399 330.703L305.349 330.703L305.349 332.003Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.03 333.973L310.08 333.973L310.08 330.673L308.03 330.673L308.03 333.973Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.25 329.35H282.35V336.45H286.25V329.35Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.65 334.9H283.4V335.3H284.65V334.9Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284 335.4H282.75V335.8H284V335.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.35 335.4H284.1V335.8H285.35V335.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.236 329.338L311.836 329.338L311.836 329.038L286.236 329.038L286.236 329.338Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.236 328.99L311.836 328.99L311.836 328.64L286.236 328.64L286.236 328.99Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2 329H282.1V329.3H286.2V329Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2 328.7H282.1V329.05H286.2V328.7Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.2 328.7H282.1V329.35H286.2V328.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.224 344.153L311.424 344.153L311.424 337.053L286.224 337.053L286.224 344.153Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.126 342.803L310.126 342.803L310.126 338.453L308.126 338.453L308.126 342.803Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.446 342.803L307.446 342.803L307.446 338.453L305.446 338.453L305.446 342.803Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.815 342.803L304.815 342.803L304.815 338.453L302.815 338.453L302.815 342.803Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.135 342.803L302.135 342.803L302.135 338.453L300.135 338.453L300.135 342.803Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.455 342.803L299.455 342.803L299.455 338.453L297.455 338.453L297.455 342.803Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.824 342.803L296.824 342.803L296.824 338.453L294.824 338.453L294.824 342.803Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.144 342.803L294.144 342.803L294.144 338.453L292.144 338.453L292.144 342.803Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.463 342.803L291.463 342.803L291.463 338.453L289.463 338.453L289.463 342.803Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.049 342.803L310.049 342.803L310.049 338.453L308.049 338.453L308.049 342.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.369 342.803L307.369 342.803L307.369 338.453L305.369 338.453L305.369 342.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.688 342.803L304.688 342.803L304.688 338.453L302.688 338.453L302.688 342.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.058 342.803L302.058 342.803L302.058 338.453L300.058 338.453L300.058 342.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.377 342.803L299.377 342.803L299.377 338.453L297.377 338.453L297.377 342.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.697 342.803L296.697 342.803L296.697 338.453L294.697 338.453L294.697 342.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.066 342.803L294.066 342.803L294.066 338.453L292.066 338.453L292.066 342.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.386 342.803L291.386 342.803L291.386 338.453L289.386 338.453L289.386 342.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.049 343.142L310.049 343.142L310.049 342.742L308.049 342.742L308.049 343.142Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.369 343.142L307.369 343.142L307.369 342.742L305.369 342.742L305.369 343.142Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.688 343.142L304.688 343.142L304.688 342.742L302.688 342.742L302.688 343.142Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.058 343.142L302.058 343.142L302.058 342.742L300.058 342.742L300.058 343.142Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.377 343.142L299.377 343.142L299.377 342.742L297.377 342.742L297.377 343.142Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.697 343.142L296.697 343.142L296.697 342.742L294.697 342.742L294.697 343.142Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.066 343.142L294.066 343.142L294.066 342.742L292.066 342.742L292.066 343.142Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.386 343.142L291.386 343.142L291.386 342.742L289.386 342.742L289.386 343.142Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.242 343.142L310.242 343.142L310.242 342.742L308.242 342.742L308.242 343.142Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.611 343.142L307.611 343.142L307.611 342.742L305.611 342.742L305.611 343.142Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.931 343.142L304.931 343.142L304.931 342.742L302.931 342.742L302.931 343.142Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.25 343.142L302.25 343.142L302.25 342.742L300.25 342.742L300.25 343.142Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.62 343.142L299.62 343.142L299.62 342.742L297.62 342.742L297.62 343.142Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.939 343.142L296.939 343.142L296.939 342.742L294.939 342.742L294.939 343.142Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.259 343.142L294.259 343.142L294.259 342.742L292.259 342.742L292.259 343.142Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.578 343.142L291.578 343.142L291.578 342.742L289.578 342.742L289.578 343.142Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.369 339.104L291.419 339.104L291.419 338.454L289.369 338.454L289.369 339.104Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.041 338.917L294.091 338.917L294.091 338.466L292.041 338.466L292.041 338.917Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.677 339.104L296.727 339.104L296.727 338.454L294.677 338.454L294.677 339.104Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.358 339.151L299.408 339.151L299.408 338.451L297.358 338.451L297.358 339.151Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.038 338.917L302.088 338.917L302.088 338.466L300.038 338.466L300.038 338.917Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.669 338.837L304.719 338.837L304.719 338.437L302.669 338.437L302.669 338.837Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.319 339.066L307.369 339.066L307.369 338.416L305.319 338.416L305.319 339.066Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.03 339.063L310.08 339.063L310.08 338.463L308.03 338.463L308.03 339.063Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.25 337.05H282.35V344.15H286.25V337.05Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.65 342.6H283.4V343H284.65V342.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284 343.1H282.75V343.5H284V343.1Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.236 337.051L311.836 337.051L311.836 336.751L286.236 336.751L286.236 337.051Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.236 336.753L311.836 336.753L311.836 336.403L286.236 336.403L286.236 336.753Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2 336.75H282.1V337.05H286.2V336.75Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2 336.4H282.1V336.75H286.2V336.4Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.2 336.4H282.1V337.05H286.2V336.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.224 367.342L311.424 367.342L311.424 360.242L286.224 360.242L286.224 367.342Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.126 365.992L310.126 365.992L310.126 361.642L308.126 361.642L308.126 365.992Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.446 365.992L307.446 365.992L307.446 361.642L305.446 361.642L305.446 365.992Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.815 365.992L304.815 365.992L304.815 361.642L302.815 361.642L302.815 365.992Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.135 365.992L302.135 365.992L302.135 361.642L300.135 361.642L300.135 365.992Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.455 365.992L299.455 365.992L299.455 361.642L297.455 361.642L297.455 365.992Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.824 365.992L296.824 365.992L296.824 361.642L294.824 361.642L294.824 365.992Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.144 365.992L294.144 365.992L294.144 361.642L292.144 361.642L292.144 365.992Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.463 365.992L291.463 365.992L291.463 361.642L289.463 361.642L289.463 365.992Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.049 365.992L310.049 365.992L310.049 361.642L308.049 361.642L308.049 365.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.369 365.992L307.369 365.992L307.369 361.642L305.369 361.642L305.369 365.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.688 365.992L304.688 365.992L304.688 361.642L302.688 361.642L302.688 365.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.058 365.992L302.058 365.992L302.058 361.642L300.058 361.642L300.058 365.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.377 365.992L299.377 365.992L299.377 361.642L297.377 361.642L297.377 365.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.697 365.992L296.697 365.992L296.697 361.642L294.697 361.642L294.697 365.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.066 365.992L294.066 365.992L294.066 361.642L292.066 361.642L292.066 365.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.386 365.992L291.386 365.992L291.386 361.642L289.386 361.642L289.386 365.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.049 366.331L310.049 366.331L310.049 365.931L308.049 365.931L308.049 366.331Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.369 366.331L307.369 366.331L307.369 365.931L305.369 365.931L305.369 366.331Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.688 366.331L304.688 366.331L304.688 365.931L302.688 365.931L302.688 366.331Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.058 366.331L302.058 366.331L302.058 365.931L300.058 365.931L300.058 366.331Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.377 366.331L299.377 366.331L299.377 365.931L297.377 365.931L297.377 366.331Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.697 366.331L296.697 366.331L296.697 365.931L294.697 365.931L294.697 366.331Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.066 366.331L294.066 366.331L294.066 365.931L292.066 365.931L292.066 366.331Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.386 366.331L291.386 366.331L291.386 365.931L289.386 365.931L289.386 366.331Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.242 366.331L310.242 366.331L310.242 365.931L308.242 365.931L308.242 366.331Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.611 366.331L307.611 366.331L307.611 365.931L305.611 365.931L305.611 366.331Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.931 366.331L304.931 366.331L304.931 365.931L302.931 365.931L302.931 366.331Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.25 366.331L302.25 366.331L302.25 365.931L300.25 365.931L300.25 366.331Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.62 366.331L299.62 366.331L299.62 365.931L297.62 365.931L297.62 366.331Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.939 366.331L296.939 366.331L296.939 365.931L294.939 365.931L294.939 366.331Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.259 366.331L294.259 366.331L294.259 365.931L292.259 365.931L292.259 366.331Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.578 366.331L291.578 366.331L291.578 365.931L289.578 365.931L289.578 366.331Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.369 363.261L291.419 363.261L291.419 361.611L289.369 361.611L289.369 363.261Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.041 362.482L294.091 362.482L294.091 361.632L292.041 361.632L292.041 362.482Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.677 363.019L296.727 363.019L296.727 361.619L294.677 361.619L294.677 363.019Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.358 363.313L299.408 363.313L299.408 361.613L297.358 361.613L297.358 363.313Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.038 362.897L302.088 362.897L302.088 361.647L300.038 361.647L300.038 362.897Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.669 362.586L304.719 362.586L304.719 361.636L302.669 361.636L302.669 362.586Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.349 362.108L307.399 362.108L307.399 361.608L305.349 361.608L305.349 362.108Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.03 362.264L310.08 362.264L310.08 361.614L308.03 361.614L308.03 362.264Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.25 360.25H282.35V367.35H286.25V360.25Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284 366.3H282.75V366.7H284V366.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.35 366.3H284.1V366.7H285.35V366.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.236 360.24L311.836 360.24L311.836 359.94L286.236 359.94L286.236 360.24Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.236 359.941L311.836 359.941L311.836 359.591L286.236 359.591L286.236 359.941Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2 359.95H282.1V360.25H286.2V359.95Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2 359.6H282.1V359.95H286.2V359.6Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.2 359.6H282.1V360.25H286.2V359.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.224 375.055L311.424 375.055L311.424 367.955L286.224 367.955L286.224 375.055Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.126 373.705L310.126 373.705L310.126 369.355L308.126 369.355L308.126 373.705Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.446 373.705L307.446 373.705L307.446 369.355L305.446 369.355L305.446 373.705Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.815 373.705L304.815 373.705L304.815 369.355L302.815 369.355L302.815 373.705Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.135 373.705L302.135 373.705L302.135 369.355L300.135 369.355L300.135 373.705Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.455 373.705L299.455 373.705L299.455 369.355L297.455 369.355L297.455 373.705Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.824 373.705L296.824 373.705L296.824 369.355L294.824 369.355L294.824 373.705Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.144 373.705L294.144 373.705L294.144 369.355L292.144 369.355L292.144 373.705Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.463 373.705L291.463 373.705L291.463 369.355L289.463 369.355L289.463 373.705Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.049 373.705L310.049 373.705L310.049 369.355L308.049 369.355L308.049 373.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.369 373.705L307.369 373.705L307.369 369.355L305.369 369.355L305.369 373.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.688 373.705L304.688 373.705L304.688 369.355L302.688 369.355L302.688 373.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.058 373.705L302.058 373.705L302.058 369.355L300.058 369.355L300.058 373.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.377 373.705L299.377 373.705L299.377 369.355L297.377 369.355L297.377 373.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.697 373.705L296.697 373.705L296.697 369.355L294.697 369.355L294.697 373.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.066 373.705L294.066 373.705L294.066 369.355L292.066 369.355L292.066 373.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.386 373.705L291.386 373.705L291.386 369.355L289.386 369.355L289.386 373.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.049 374.094L310.049 374.094L310.049 373.694L308.049 373.694L308.049 374.094Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.369 374.094L307.369 374.094L307.369 373.694L305.369 373.694L305.369 374.094Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.688 374.094L304.688 374.094L304.688 373.694L302.688 373.694L302.688 374.094Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.058 374.094L302.058 374.094L302.058 373.694L300.058 373.694L300.058 374.094Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.377 374.094L299.377 374.094L299.377 373.694L297.377 373.694L297.377 374.094Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.697 374.094L296.697 374.094L296.697 373.694L294.697 373.694L294.697 374.094Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.066 374.094L294.066 374.094L294.066 373.694L292.066 373.694L292.066 374.094Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.386 374.094L291.386 374.094L291.386 373.694L289.386 373.694L289.386 374.094Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.242 374.094L310.242 374.094L310.242 373.694L308.242 373.694L308.242 374.094Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.611 374.094L307.611 374.094L307.611 373.694L305.611 373.694L305.611 374.094Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.931 374.094L304.931 374.094L304.931 373.694L302.931 373.694L302.931 374.094Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.25 374.094L302.25 374.094L302.25 373.694L300.25 373.694L300.25 374.094Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.62 374.094L299.62 374.094L299.62 373.694L297.62 373.694L297.62 374.094Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.939 374.094L296.939 374.094L296.939 373.694L294.939 373.694L294.939 374.094Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.259 374.094L294.259 374.094L294.259 373.694L292.259 373.694L292.259 374.094Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.578 374.094L291.578 374.094L291.578 373.694L289.578 373.694L289.578 374.094Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.369 370.667L291.419 370.667L291.419 369.367L289.369 369.367L289.369 370.667Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.041 372.179L294.091 372.179L294.091 369.329L292.041 369.329L292.041 372.179Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.677 371.919L296.727 371.919L296.727 369.319L294.677 369.319L294.677 371.919Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.358 370.761L299.408 370.761L299.408 369.361L297.358 369.361L297.358 370.761Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.038 370.292L302.088 370.292L302.088 369.342L300.038 369.342L300.038 370.292Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.669 369.739L304.719 369.739L304.719 369.339L302.669 369.339L302.669 369.739Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.349 370.667L307.399 370.667L307.399 369.367L305.349 369.367L305.349 370.667Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.03 372.637L310.08 372.637L310.08 369.337L308.03 369.337L308.03 372.637Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.25 368H282.35V375.1H286.25V368Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.65 373.55H283.4V373.95H284.65V373.55Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284 374.05H282.75V374.45H284V374.05Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.35 374.05H284.1V374.45H285.35V374.05Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.236 368.003L311.836 368.003L311.836 367.703L286.236 367.703L286.236 368.003Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.236 367.654L311.836 367.654L311.836 367.304L286.236 367.304L286.236 367.654Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2 367.65H282.1V367.95H286.2V367.65Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2 367.35H282.1V367.7H286.2V367.35Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.2 367.35H282.1V368H286.2V367.35Z",
    fill: "black"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.713 342.405L352.913 342.405L352.913 335.305L327.713 335.305L327.713 342.405Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.615 341.055L351.615 341.055L351.615 336.705L349.615 336.705L349.615 341.055Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.935 341.055L348.935 341.055L348.935 336.705L346.935 336.705L346.935 341.055Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.304 341.055L346.304 341.055L346.304 336.705L344.304 336.705L344.304 341.055Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.624 341.055L343.624 341.055L343.624 336.705L341.624 336.705L341.624 341.055Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.943 341.055L340.943 341.055L340.943 336.705L338.943 336.705L338.943 341.055Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.312 341.055L338.312 341.055L338.313 336.705L336.313 336.705L336.312 341.055Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.632 341.055L335.632 341.055L335.632 336.705L333.632 336.705L333.632 341.055Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.952 341.055L332.952 341.055L332.952 336.705L330.952 336.705L330.952 341.055Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.538 341.055L351.538 341.055L351.538 336.705L349.538 336.705L349.538 341.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.857 341.055L348.857 341.055L348.857 336.705L346.857 336.705L346.857 341.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.177 341.055L346.177 341.055L346.177 336.705L344.177 336.705L344.177 341.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.547 341.055L343.547 341.055L343.547 336.705L341.547 336.705L341.547 341.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.866 341.055L340.866 341.055L340.866 336.705L338.866 336.705L338.866 341.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.186 341.055L338.186 341.055L338.186 336.705L336.186 336.705L336.186 341.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.555 341.055L335.555 341.055L335.555 336.705L333.555 336.705L333.555 341.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.875 341.055L332.875 341.055L332.875 336.705L330.875 336.705L330.875 341.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.538 341.444L351.538 341.444L351.538 341.044L349.538 341.044L349.538 341.444Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.857 341.444L348.857 341.444L348.857 341.044L346.857 341.044L346.857 341.444Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.177 341.444L346.177 341.444L346.177 341.044L344.177 341.044L344.177 341.444Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.547 341.444L343.547 341.444L343.547 341.044L341.547 341.044L341.547 341.444Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.866 341.444L340.866 341.444L340.866 341.044L338.866 341.044L338.866 341.444Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.186 341.444L338.186 341.444L338.186 341.044L336.186 341.044L336.186 341.444Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.555 341.444L335.555 341.444L335.555 341.044L333.555 341.044L333.555 341.444Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.875 341.444L332.875 341.444L332.875 341.044L330.875 341.044L330.875 341.444Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.731 341.444L351.731 341.444L351.731 341.044L349.731 341.044L349.731 341.444Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.1 341.444L349.1 341.444L349.1 341.044L347.1 341.044L347.1 341.444Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.42 341.444L346.42 341.444L346.42 341.044L344.42 341.044L344.42 341.444Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.739 341.444L343.739 341.444L343.739 341.044L341.739 341.044L341.739 341.444Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.109 341.444L341.109 341.444L341.109 341.044L339.109 341.044L339.109 341.444Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.428 341.444L338.428 341.444L338.428 341.044L336.428 341.044L336.428 341.444Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.748 341.444L335.748 341.444L335.748 341.044L333.748 341.044L333.748 341.444Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.117 341.444L333.117 341.444L333.117 341.044L331.117 341.044L331.117 341.444Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.858 338.018L332.908 338.018L332.908 336.718L330.858 336.718L330.858 338.018Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.53 339.529L335.58 339.529L335.58 336.679L333.53 336.679L333.53 339.529Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.166 339.269L338.216 339.269L338.216 336.669L336.166 336.669L336.166 339.269Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.846 338.111L340.896 338.111L340.896 336.711L338.846 336.711L338.846 338.111Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.527 337.643L343.577 337.643L343.577 336.693L341.527 336.693L341.527 337.643Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.207 337.089L346.257 337.089L346.257 336.689L344.207 336.689L344.207 337.089Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.838 338.018L348.888 338.018L348.888 336.718L346.838 336.718L346.838 338.018Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.518 339.988L351.568 339.988L351.568 336.688L349.518 336.688L349.518 339.988Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.75 335.35H323.85V342.45H327.75V335.35Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.15 340.9H324.9V341.3H326.15V340.9Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.5 341.4H324.25V341.8H325.5V341.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.85 341.4H325.6V341.8H326.85V341.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.725 335.353L353.325 335.353L353.325 335.053L327.725 335.053L327.725 335.353Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.725 335.004L353.325 335.004L353.325 334.654L327.725 334.654L327.725 335.004Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.7 335H323.6V335.3H327.7V335Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.7 334.7H323.6V335.05H327.7V334.7Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.7 334.7H323.6V335.35H327.7V334.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.713 350.168L352.913 350.168L352.913 343.068L327.713 343.068L327.713 350.168Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.615 348.768L351.615 348.768L351.615 344.418L349.615 344.418L349.615 348.768Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.935 348.768L348.935 348.768L348.935 344.418L346.935 344.418L346.935 348.768Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.304 348.768L346.304 348.768L346.304 344.418L344.304 344.418L344.304 348.768Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.624 348.768L343.624 348.768L343.624 344.418L341.624 344.418L341.624 348.768Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.943 348.768L340.943 348.768L340.943 344.418L338.943 344.418L338.943 348.768Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.312 348.768L338.312 348.768L338.313 344.418L336.313 344.418L336.312 348.768Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.632 348.768L335.632 348.768L335.632 344.418L333.632 344.418L333.632 348.768Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.952 348.768L332.952 348.768L332.952 344.418L330.952 344.418L330.952 348.768Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.538 348.768L351.538 348.768L351.538 344.418L349.538 344.418L349.538 348.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.857 348.768L348.857 348.768L348.857 344.418L346.857 344.418L346.857 348.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.177 348.768L346.177 348.768L346.177 344.418L344.177 344.418L344.177 348.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.547 348.768L343.547 348.768L343.547 344.418L341.547 344.418L341.547 348.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.866 348.768L340.866 348.768L340.866 344.418L338.866 344.418L338.866 348.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.186 348.768L338.186 348.768L338.186 344.418L336.186 344.418L336.186 348.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.555 348.768L335.555 348.768L335.555 344.418L333.555 344.418L333.555 348.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.875 348.768L332.875 348.768L332.875 344.418L330.875 344.418L330.875 348.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.538 349.157L351.538 349.157L351.538 348.757L349.538 348.757L349.538 349.157Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.857 349.157L348.857 349.157L348.857 348.757L346.857 348.757L346.857 349.157Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.177 349.157L346.177 349.157L346.177 348.757L344.177 348.757L344.177 349.157Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.547 349.157L343.547 349.157L343.547 348.757L341.547 348.757L341.547 349.157Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.866 349.157L340.866 349.157L340.866 348.757L338.866 348.757L338.866 349.157Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.186 349.157L338.186 349.157L338.186 348.757L336.186 348.757L336.186 349.157Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.555 349.157L335.555 349.157L335.555 348.757L333.555 348.757L333.555 349.157Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.875 349.157L332.875 349.157L332.875 348.757L330.875 348.757L330.875 349.157Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.731 349.157L351.731 349.157L351.731 348.757L349.731 348.757L349.731 349.157Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.1 349.157L349.1 349.157L349.1 348.757L347.1 348.757L347.1 349.157Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.42 349.157L346.42 349.157L346.42 348.757L344.42 348.757L344.42 349.157Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.739 349.157L343.739 349.157L343.739 348.757L341.739 348.757L341.739 349.157Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.109 349.157L341.109 349.157L341.109 348.757L339.109 348.757L339.109 349.157Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.428 349.157L338.428 349.157L338.428 348.757L336.428 348.757L336.428 349.157Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.748 349.157L335.748 349.157L335.748 348.757L333.748 348.757L333.748 349.157Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.117 349.157L333.117 349.157L333.117 348.757L331.117 348.757L331.117 349.157Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.858 345.069L332.908 345.069L332.908 344.419L330.858 344.419L330.858 345.069Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.53 344.881L335.58 344.881L335.58 344.431L333.53 344.431L333.53 344.881Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.166 345.069L338.216 345.069L338.216 344.419L336.166 344.419L336.166 345.069Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.846 345.115L340.896 345.115L340.896 344.415L338.846 344.415L338.846 345.115Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.527 344.881L343.577 344.881L343.577 344.431L341.527 344.431L341.527 344.881Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.207 344.802L346.257 344.802L346.257 344.402L344.207 344.402L344.207 344.802Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.858 345.081L348.908 345.081L348.908 344.431L346.858 344.431L346.858 345.081Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.518 345.028L351.568 345.028L351.568 344.428L349.518 344.428L349.518 345.028Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.75 343.05H323.85V350.15H327.75V343.05Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.15 348.65H324.9V349.05H326.15V348.65Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.5 349.1H324.25V349.5H325.5V349.1Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.725 343.065L353.325 343.065L353.325 342.765L327.725 342.765L327.725 343.065Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.725 342.767L353.325 342.767L353.325 342.417L327.725 342.417L327.725 342.767Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.7 342.75H323.6V343.05H327.7V342.75Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.7 342.4H323.6V342.75H327.7V342.4Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.7 342.4H323.6V343.05H327.7V342.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.713 326.979L352.913 326.979L352.913 319.879L327.713 319.879L327.713 326.979Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.615 325.579L351.615 325.579L351.615 321.229L349.615 321.229L349.615 325.579Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.935 325.579L348.935 325.579L348.935 321.229L346.935 321.229L346.935 325.579Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.304 325.579L346.304 325.579L346.304 321.229L344.304 321.229L344.304 325.579Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.624 325.579L343.624 325.579L343.624 321.229L341.624 321.229L341.624 325.579Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.943 325.579L340.943 325.579L340.943 321.229L338.943 321.229L338.943 325.579Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.312 325.579L338.312 325.579L338.313 321.229L336.313 321.229L336.312 325.579Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.632 325.579L335.632 325.579L335.632 321.229L333.632 321.229L333.632 325.579Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.952 325.579L332.952 325.579L332.952 321.229L330.952 321.229L330.952 325.579Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.538 325.579L351.538 325.579L351.538 321.229L349.538 321.229L349.538 325.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.857 325.579L348.857 325.579L348.857 321.229L346.857 321.229L346.857 325.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.177 325.579L346.177 325.579L346.177 321.229L344.177 321.229L344.177 325.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.547 325.579L343.547 325.579L343.547 321.229L341.547 321.229L341.547 325.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.866 325.579L340.866 325.579L340.866 321.229L338.866 321.229L338.866 325.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.186 325.579L338.186 325.579L338.186 321.229L336.186 321.229L336.186 325.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.555 325.579L335.555 325.579L335.555 321.229L333.555 321.229L333.555 325.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.875 325.579L332.875 325.579L332.875 321.229L330.875 321.229L330.875 325.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.538 325.968L351.538 325.968L351.538 325.568L349.538 325.568L349.538 325.968Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.857 325.968L348.857 325.968L348.857 325.568L346.857 325.568L346.857 325.968Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.177 325.968L346.177 325.968L346.177 325.568L344.177 325.568L344.177 325.968Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.547 325.968L343.547 325.968L343.547 325.568L341.547 325.568L341.547 325.968Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.866 325.968L340.866 325.968L340.866 325.568L338.866 325.568L338.866 325.968Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.186 325.968L338.186 325.968L338.186 325.568L336.186 325.568L336.186 325.968Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.555 325.968L335.555 325.968L335.555 325.568L333.555 325.568L333.555 325.968Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.875 325.968L332.875 325.968L332.875 325.568L330.875 325.568L330.875 325.968Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.731 325.968L351.731 325.968L351.731 325.568L349.731 325.568L349.731 325.968Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.1 325.968L349.1 325.968L349.1 325.568L347.1 325.568L347.1 325.968Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.42 325.968L346.42 325.968L346.42 325.568L344.42 325.568L344.42 325.968Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.739 325.968L343.739 325.968L343.739 325.568L341.739 325.568L341.739 325.968Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.109 325.968L341.109 325.968L341.109 325.568L339.109 325.568L339.109 325.968Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.428 325.968L338.428 325.968L338.428 325.568L336.428 325.568L336.428 325.968Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.748 325.968L335.748 325.968L335.748 325.568L333.748 325.568L333.748 325.968Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.117 325.968L333.117 325.968L333.117 325.568L331.117 325.568L331.117 325.968Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.858 322.542L332.908 322.542L332.908 321.242L330.858 321.242L330.858 322.542Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.53 324.053L335.58 324.053L335.58 321.203L333.53 321.203L333.53 324.053Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.166 323.794L338.216 323.794L338.216 321.194L336.166 321.194L336.166 323.794Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.846 322.636L340.896 322.636L340.896 321.236L338.846 321.236L338.846 322.636Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.527 322.167L343.577 322.167L343.577 321.217L341.527 321.217L341.527 322.167Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.207 321.613L346.257 321.613L346.257 321.213L344.207 321.213L344.207 321.613Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.838 322.542L348.888 322.542L348.888 321.242L346.838 321.242L346.838 322.542Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.518 324.512L351.568 324.512L351.568 321.212L349.518 321.212L349.518 324.512Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.75 319.85H323.85V326.95H327.75V319.85Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.15 325.45H324.9V325.85H326.15V325.45Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.5 325.95H324.25V326.35H325.5V325.95Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.85 325.95H325.6V326.35H326.85V325.95Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.725 319.877L353.325 319.877L353.325 319.577L327.725 319.577L327.725 319.877Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.725 319.578L353.325 319.578L353.325 319.229L327.725 319.229L327.725 319.578Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.7 319.55H323.6V319.85H327.7V319.55Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.7 319.2H323.6V319.55H327.7V319.2Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.7 319.2H323.6V319.85H327.7V319.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.713 334.692L352.913 334.692L352.913 327.592L327.713 327.592L327.713 334.692Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.615 333.342L351.615 333.342L351.615 328.992L349.615 328.992L349.615 333.342Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.935 333.342L348.935 333.342L348.935 328.992L346.935 328.992L346.935 333.342Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.304 333.342L346.304 333.342L346.304 328.992L344.304 328.992L344.304 333.342Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.624 333.342L343.624 333.342L343.624 328.992L341.624 328.992L341.624 333.342Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.943 333.342L340.943 333.342L340.943 328.992L338.943 328.992L338.943 333.342Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.312 333.342L338.312 333.342L338.313 328.992L336.313 328.992L336.312 333.342Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.632 333.342L335.632 333.342L335.632 328.992L333.632 328.992L333.632 333.342Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.952 333.342L332.952 333.342L332.952 328.992L330.952 328.992L330.952 333.342Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.538 333.342L351.538 333.342L351.538 328.992L349.538 328.992L349.538 333.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.857 333.342L348.857 333.342L348.857 328.992L346.857 328.992L346.857 333.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.177 333.342L346.177 333.342L346.177 328.992L344.177 328.992L344.177 333.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.547 333.342L343.547 333.342L343.547 328.992L341.547 328.992L341.547 333.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.866 333.342L340.866 333.342L340.866 328.992L338.866 328.992L338.866 333.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.186 333.342L338.186 333.342L338.186 328.992L336.186 328.992L336.186 333.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.555 333.342L335.555 333.342L335.555 328.992L333.555 328.992L333.555 333.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.875 333.342L332.875 333.342L332.875 328.992L330.875 328.992L330.875 333.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.538 333.681L351.538 333.681L351.538 333.281L349.538 333.281L349.538 333.681Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.857 333.681L348.857 333.681L348.857 333.281L346.857 333.281L346.857 333.681Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.177 333.681L346.177 333.681L346.177 333.281L344.177 333.281L344.177 333.681Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.547 333.681L343.547 333.681L343.547 333.281L341.547 333.281L341.547 333.681Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.866 333.681L340.866 333.681L340.866 333.281L338.866 333.281L338.866 333.681Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.186 333.681L338.186 333.681L338.186 333.281L336.186 333.281L336.186 333.681Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.555 333.681L335.555 333.681L335.555 333.281L333.555 333.281L333.555 333.681Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.875 333.681L332.875 333.681L332.875 333.281L330.875 333.281L330.875 333.681Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.731 333.681L351.731 333.681L351.731 333.281L349.731 333.281L349.731 333.681Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.1 333.681L349.1 333.681L349.1 333.281L347.1 333.281L347.1 333.681Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.42 333.681L346.42 333.681L346.42 333.281L344.42 333.281L344.42 333.681Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.739 333.681L343.739 333.681L343.739 333.281L341.739 333.281L341.739 333.681Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.109 333.681L341.109 333.681L341.109 333.281L339.109 333.281L339.109 333.681Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.428 333.681L338.428 333.681L338.428 333.281L336.428 333.281L336.428 333.681Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.748 333.681L335.748 333.681L335.748 333.281L333.748 333.281L333.748 333.681Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.117 333.681L333.117 333.681L333.117 333.281L331.117 333.281L331.117 333.681Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.858 329.643L332.908 329.643L332.908 328.993L330.858 328.993L330.858 329.643Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.53 329.455L335.58 329.455L335.58 329.005L333.53 329.005L333.53 329.455Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.166 329.643L338.216 329.643L338.216 328.993L336.166 328.993L336.166 329.643Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.846 329.69L340.896 329.69L340.896 328.99L338.846 328.99L338.846 329.69Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.527 329.455L343.577 329.455L343.577 329.005L341.527 329.005L341.527 329.455Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.207 329.376L346.257 329.376L346.257 328.976L344.207 328.976L344.207 329.376Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.858 329.605L348.908 329.605L348.908 328.955L346.858 328.955L346.858 329.605Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.518 329.602L351.568 329.602L351.568 329.002L349.518 329.002L349.518 329.602Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.75 327.6H323.85V334.7H327.75V327.6Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.15 333.15H324.9V333.55H326.15V333.15Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.5 333.65H324.25V334.05H325.5V333.65Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.725 327.59L353.325 327.59L353.325 327.29L327.725 327.29L327.725 327.59Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.725 327.291L353.325 327.291L353.325 326.941L327.725 326.941L327.725 327.291Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.7 327.3H323.6V327.6H327.7V327.3Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.7 326.95H323.6V327.3H327.7V326.95Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.7 326.95H323.6V327.6H327.7V326.95Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.713 357.881L352.913 357.881L352.913 350.781L327.713 350.781L327.713 357.881Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.615 356.531L351.615 356.531L351.615 352.181L349.615 352.181L349.615 356.531Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.935 356.531L348.935 356.531L348.935 352.181L346.935 352.181L346.935 356.531Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.304 356.531L346.304 356.531L346.304 352.181L344.304 352.181L344.304 356.531Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.624 356.531L343.624 356.531L343.624 352.181L341.624 352.181L341.624 356.531Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.943 356.531L340.943 356.531L340.943 352.181L338.943 352.181L338.943 356.531Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.312 356.531L338.312 356.531L338.313 352.181L336.313 352.181L336.312 356.531Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.632 356.531L335.632 356.531L335.632 352.181L333.632 352.181L333.632 356.531Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.952 356.531L332.952 356.531L332.952 352.181L330.952 352.181L330.952 356.531Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.538 356.531L351.538 356.531L351.538 352.181L349.538 352.181L349.538 356.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.857 356.531L348.857 356.531L348.857 352.181L346.857 352.181L346.857 356.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.177 356.531L346.177 356.531L346.177 352.181L344.177 352.181L344.177 356.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.547 356.531L343.547 356.531L343.547 352.181L341.547 352.181L341.547 356.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.866 356.531L340.866 356.531L340.866 352.181L338.866 352.181L338.866 356.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.186 356.531L338.186 356.531L338.186 352.181L336.186 352.181L336.186 356.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.555 356.531L335.555 356.531L335.555 352.181L333.555 352.181L333.555 356.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.875 356.531L332.875 356.531L332.875 352.181L330.875 352.181L330.875 356.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.538 356.92L351.538 356.92L351.538 356.52L349.538 356.52L349.538 356.92Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.857 356.92L348.857 356.92L348.857 356.52L346.857 356.52L346.857 356.92Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.177 356.92L346.177 356.92L346.177 356.52L344.177 356.52L344.177 356.92Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.547 356.92L343.547 356.92L343.547 356.52L341.547 356.52L341.547 356.92Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.866 356.92L340.866 356.92L340.866 356.52L338.866 356.52L338.866 356.92Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.186 356.92L338.186 356.92L338.186 356.52L336.186 356.52L336.186 356.92Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.555 356.92L335.555 356.92L335.555 356.52L333.555 356.52L333.555 356.92Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.875 356.92L332.875 356.92L332.875 356.52L330.875 356.52L330.875 356.92Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.731 356.92L351.731 356.92L351.731 356.52L349.731 356.52L349.731 356.92Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.1 356.92L349.1 356.92L349.1 356.52L347.1 356.52L347.1 356.92Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.42 356.92L346.42 356.92L346.42 356.52L344.42 356.52L344.42 356.92Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.739 356.92L343.739 356.92L343.739 356.52L341.739 356.52L341.739 356.92Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.109 356.92L341.109 356.92L341.109 356.52L339.109 356.52L339.109 356.92Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.428 356.92L338.428 356.92L338.428 356.52L336.428 356.52L336.428 356.92Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.748 356.92L335.748 356.92L335.748 356.52L333.748 356.52L333.748 356.92Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.117 356.92L333.117 356.92L333.117 356.52L331.117 356.52L331.117 356.92Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.858 353.8L332.908 353.8L332.908 352.15L330.858 352.15L330.858 353.8Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.53 353.021L335.58 353.021L335.58 352.171L333.53 352.171L333.53 353.021Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.166 353.557L338.216 353.557L338.216 352.158L336.166 352.158L336.166 353.557Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.846 353.852L340.896 353.852L340.896 352.152L338.846 352.152L338.846 353.852Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.527 353.436L343.577 353.436L343.577 352.186L341.527 352.186L341.527 353.436Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.207 353.125L346.257 353.125L346.257 352.175L344.207 352.175L344.207 353.125Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.838 352.647L348.888 352.647L348.888 352.147L346.838 352.147L346.838 352.647Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.518 352.803L351.568 352.803L351.568 352.153L349.518 352.153L349.518 352.803Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.75 350.8H323.85V357.9H327.75V350.8Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.5 356.85H324.25V357.25H325.5V356.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.85 356.85H325.6V357.25H326.85V356.85Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.725 350.779L353.325 350.779L353.325 350.479L327.725 350.479L327.725 350.779Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.725 350.48L353.325 350.48L353.325 350.13L327.725 350.13L327.725 350.48Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.7 350.5H323.6V350.8H327.7V350.5Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.7 350.15H323.6V350.5H327.7V350.15Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.7 350.15H323.6V350.8H327.7V350.15Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.713 365.594L352.913 365.594L352.913 358.494L327.713 358.494L327.713 365.594Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.615 364.244L351.615 364.244L351.615 359.894L349.615 359.894L349.615 364.244Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.935 364.244L348.935 364.244L348.935 359.894L346.935 359.894L346.935 364.244Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.304 364.244L346.304 364.244L346.304 359.894L344.304 359.894L344.304 364.244Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.624 364.244L343.624 364.244L343.624 359.894L341.624 359.894L341.624 364.244Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.943 364.244L340.943 364.244L340.943 359.894L338.943 359.894L338.943 364.244Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.312 364.244L338.312 364.244L338.313 359.894L336.313 359.894L336.312 364.244Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.632 364.244L335.632 364.244L335.632 359.894L333.632 359.894L333.632 364.244Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.952 364.244L332.952 364.244L332.952 359.894L330.952 359.894L330.952 364.244Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.538 364.244L351.538 364.244L351.538 359.894L349.538 359.894L349.538 364.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.857 364.244L348.857 364.244L348.857 359.894L346.857 359.894L346.857 364.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.177 364.244L346.177 364.244L346.177 359.894L344.177 359.894L344.177 364.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.547 364.244L343.547 364.244L343.547 359.894L341.547 359.894L341.547 364.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.866 364.244L340.866 364.244L340.866 359.894L338.866 359.894L338.866 364.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.186 364.244L338.186 364.244L338.186 359.894L336.186 359.894L336.186 364.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.555 364.244L335.555 364.244L335.555 359.894L333.555 359.894L333.555 364.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.875 364.244L332.875 364.244L332.875 359.894L330.875 359.894L330.875 364.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.538 364.633L351.538 364.633L351.538 364.233L349.538 364.233L349.538 364.633Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.857 364.633L348.857 364.633L348.857 364.233L346.857 364.233L346.857 364.633Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.177 364.633L346.177 364.633L346.177 364.233L344.177 364.233L344.177 364.633Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.547 364.633L343.547 364.633L343.547 364.233L341.547 364.233L341.547 364.633Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.866 364.633L340.866 364.633L340.866 364.233L338.866 364.233L338.866 364.633Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.186 364.633L338.186 364.633L338.186 364.233L336.186 364.233L336.186 364.633Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.555 364.633L335.555 364.633L335.555 364.233L333.555 364.233L333.555 364.633Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.875 364.633L332.875 364.633L332.875 364.233L330.875 364.233L330.875 364.633Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.731 364.633L351.731 364.633L351.731 364.233L349.731 364.233L349.731 364.633Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.1 364.633L349.1 364.633L349.1 364.233L347.1 364.233L347.1 364.633Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.42 364.633L346.42 364.633L346.42 364.233L344.42 364.233L344.42 364.633Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.739 364.633L343.739 364.633L343.739 364.233L341.739 364.233L341.739 364.633Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.109 364.633L341.109 364.633L341.109 364.233L339.109 364.233L339.109 364.633Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.428 364.633L338.428 364.633L338.428 364.233L336.428 364.233L336.428 364.633Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.748 364.633L335.748 364.633L335.748 364.233L333.748 364.233L333.748 364.633Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.117 364.633L333.117 364.633L333.117 364.233L331.117 364.233L331.117 364.633Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.858 361.206L332.908 361.206L332.908 359.906L330.858 359.906L330.858 361.206Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.53 362.718L335.58 362.718L335.58 359.868L333.53 359.868L333.53 362.718Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.166 362.458L338.216 362.458L338.216 359.858L336.166 359.858L336.166 362.458Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.846 361.3L340.896 361.3L340.896 359.9L338.846 359.9L338.846 361.3Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.527 360.831L343.577 360.831L343.577 359.881L341.527 359.881L341.527 360.831Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.207 360.277L346.257 360.277L346.257 359.877L344.207 359.877L344.207 360.277Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.838 361.206L348.888 361.206L348.888 359.906L346.838 359.906L346.838 361.206Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.518 363.176L351.568 363.176L351.568 359.876L349.518 359.876L349.518 363.176Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.75 358.55H323.85V365.65H327.75V358.55Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.15 364.1H324.9V364.5H326.15V364.1Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.5 364.6H324.25V365H325.5V364.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.85 364.6H325.6V365H326.85V364.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.725 358.542L353.325 358.542L353.325 358.242L327.725 358.242L327.725 358.542Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.725 358.193L353.325 358.193L353.325 357.843L327.725 357.843L327.725 358.193Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.7 358.2H323.6V358.5H327.7V358.2Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.7 357.9H323.6V358.25H327.7V357.9Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.7 357.9H323.6V358.55H327.7V357.9Z",
    fill: "black"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.35 383.2C156.925 383.2 169.55 382.081 169.55 380.7C169.55 379.319 156.925 378.2 141.35 378.2C125.776 378.2 113.15 379.319 113.15 380.7C113.15 382.081 125.776 383.2 141.35 383.2Z",
    fill: "#53C983"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.45 376.4H113.55C113.45 376.4 113.4 376.35 113.4 376.25V367.95C113.4 367.85 113.45 367.8 113.55 367.8H114.45C114.55 367.8 114.6 367.9 114.6 367.95V376.25C114.6 376.35 114.55 376.4 114.45 376.4Z",
    fill: "#0A331A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.9 371.6H113.5V370.95H111.1C111 370.95 110.9 370.85 110.9 370.75V367.2H111.3V370.55H113.7C113.8 370.55 113.9 370.65 113.9 370.75V371.6Z",
    fill: "#0A331A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.95 367.4H112.55V370.7H112.95V367.4Z",
    fill: "#0A331A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112 369.5H111.1V369.1H111.8V367.4H112.2V369.3C112.2 369.45 112.1 369.5 112 369.5Z",
    fill: "#0A331A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.05 369H109.7C109.6 369 109.5 368.9 109.5 368.8V366.9H109.9V368.6H111V369H111.05Z",
    fill: "#0A331A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.45 370.75H114.05V369.9C114.05 369.8 114.15 369.7 114.25 369.7H116.65V366.35H117.05V369.9C117.05 370 116.95 370.1 116.85 370.1H114.45V370.75Z",
    fill: "#0A331A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.9 369H116C115.9 369 115.8 368.9 115.8 368.8V366.9H116.2V368.6H116.9V369Z",
    fill: "#0A331A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.15 369.35H114.25V368.95H114.95V367.25H115.35V369.15C115.35 369.25 115.25 369.35 115.15 369.35Z",
    fill: "#0A331A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.35 369.35H116.9V368.95H118.15V367.25H118.55V369.15C118.55 369.25 118.45 369.35 118.35 369.35Z",
    fill: "#0A331A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119 368.15H109C108.75 368.15 108.55 367.95 108.55 367.7V361.5C108.55 361.25 108.75 361.05 109 361.05H119C119.25 361.05 119.45 361.25 119.45 361.5V367.7C119.45 367.95 119.25 368.15 119 368.15Z",
    fill: "#126836"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 361,
    width: 12,
    height: 8
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M119 368.15H109C108.75 368.15 108.55 367.95 108.55 367.7V361.5C108.55 361.25 108.75 361.05 109 361.05H119C119.25 361.05 119.45 361.25 119.45 361.5V367.7C119.45 367.95 119.25 368.15 119 368.15Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.2 368.15H114.2C113.95 368.15 113.75 367.95 113.75 367.7V361.5C113.75 361.25 113.95 361.05 114.2 361.05H124.2C124.45 361.05 124.65 361.25 124.65 361.5V367.7C124.65 367.95 124.45 368.15 124.2 368.15Z",
    fill: "#1E8749"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M365.65 373.7H364.9C364.8 373.7 364.75 373.65 364.75 373.55V366.7C364.75 366.6 364.8 366.55 364.9 366.55H365.65C365.75 366.55 365.8 366.6 365.8 366.7V373.55C365.8 373.6 365.7 373.7 365.65 373.7Z",
    fill: "#0A331A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M365.2 369.7H364.85V369.15H362.85C362.75 369.15 362.7 369.05 362.7 369V366.1H363.05V368.85H365.05C365.15 368.85 365.2 368.95 365.2 369V369.7Z",
    fill: "#0A331A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M364.45 366.25H364.1V369H364.45V366.25Z",
    fill: "#0A331A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M363.6 368H362.85V367.65H363.45V366.25H363.8V367.8C363.8 367.9 363.7 368 363.6 368Z",
    fill: "#0A331A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M362.85 367.55H361.75C361.65 367.55 361.6 367.45 361.6 367.4V365.85H361.95V367.25H362.85V367.55Z",
    fill: "#0A331A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M365.65 369H365.3V368.3C365.3 368.2 365.4 368.15 365.45 368.15H367.45V365.4H367.8V368.3C367.8 368.4 367.7 368.45 367.65 368.45H365.65V369Z",
    fill: "#0A331A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M367.65 367.6H366.9C366.8 367.6 366.75 367.5 366.75 367.45V365.9H367.1V367.3H367.65V367.6Z",
    fill: "#0A331A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M366.25 367.85H365.5V367.5H366.1V366.1H366.451V367.65C366.401 367.8 366.35 367.85 366.25 367.85Z",
    fill: "#0A331A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M368.85 367.85H367.65V367.5H368.7V366.1H369.05V367.65C369.05 367.75 368.95 367.85 368.85 367.85Z",
    fill: "#0A331A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M369.4 366.85H361.15C360.95 366.85 360.8 366.7 360.8 366.5V361.4C360.8 361.2 360.95 361.05 361.15 361.05H369.4C369.6 361.05 369.75 361.2 369.75 361.4V366.5C369.8 366.7 369.6 366.85 369.4 366.85Z",
    fill: "#126836"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 360,
    y: 361,
    width: 10,
    height: 6
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M369.4 366.85H361.15C360.95 366.85 360.8 366.7 360.8 366.5V361.4C360.8 361.2 360.95 361.05 361.15 361.05H369.4C369.6 361.05 369.75 361.2 369.75 361.4V366.5C369.8 366.7 369.6 366.85 369.4 366.85Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.7 366.85H365.45C365.25 366.85 365.1 366.7 365.1 366.5V361.4C365.1 361.2 365.25 361.05 365.45 361.05H373.7C373.9 361.05 374.05 361.2 374.05 361.4V366.5C374.1 366.7 373.9 366.85 373.7 366.85Z",
    fill: "#1E8749"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M252.7 81.95C208.35 81.95 172.4 117.9 172.4 162.25C172.4 206.6 252.7 311.05 252.7 311.05C252.7 311.05 333 206.55 333 162.2C333 117.85 297.05 81.95 252.7 81.95ZM252.7 203.95C229.65 203.95 211 185.25 211 162.25C211 139.2 229.7 120.55 252.7 120.55C275.7 120.55 294.4 139.25 294.4 162.25C294.4 185.25 275.75 203.95 252.7 203.95Z",
    fill: "#FFE600"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M365.35 383.25C365.35 383.25 374.25 380 372.8 377.2C371.35 374.4 282.1 377.1 282.1 377.1L284 374.45C284 374.45 361 374.35 365.9 374.35C370.8 374.35 381.55 374.8 379.6 378.3C377.65 381.75 366.45 384.5 366.45 384.5L365.35 383.25Z",
    fill: "#53C983"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M161.65 353.85H123.95V380.55H161.65V353.85Z",
    className: "illustration_primary-ultralight"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M117.45 380.581H123.95V353.881H117.45V380.581Z",
    className: "illustration_primary-ultralight"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M161.65 353.85H123.95L129.55 339.3H167.2L161.65 353.85Z",
    className: "illustration_primary-ultralight"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M168.9 338.15H130.3V339.5H168.9V338.15Z",
    className: "illustration_primary_default"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M117.45 353.85H123.95L129.55 339.3H111.45L117.45 353.85Z",
    className: "illustration_primary-ultralight"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M110.971 339.506H130.271V338.156H110.971V339.506Z",
    fill: "#C4C9DC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M136.45 341.65H133.65L129.35 352.2H132.15L136.45 341.65Z",
    className: "illustration_primary-ultralight"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M135.95 341.65H133.15L128.85 352.2H131.65L135.95 341.65Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M140.75 341.65H137.95L133.65 352.2H136.5L140.75 341.65Z",
    className: "illustration_primary-ultralight"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M140.25 341.65H137.45L133.15 352.2H135.95L140.25 341.65Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 341.65H159.7L155.45 352.2H158.25L162.5 341.65Z",
    className: "illustration_primary-ultralight"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M162 341.65H159.2L154.9 352.2H157.7L162 341.65Z",
    fill: "#FFE600"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M157.1 341.65H145.3L141 352.2H152.85L157.1 341.65Z",
    className: "illustration_primary-ultralight"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M156.65 341.65H143.15L138.85 352.2H152.35L156.65 341.65Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 353.85H122.4V355.2H162.5V353.85Z",
    className: "illustration_primary-ultralight"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M158.2 359.15H129.65V361.3H158.2V359.15Z",
    className: "illustration_primary-ultralight"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M157.8 359.15H128.7V361.3H157.8V359.15Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M132.1 368.65H129.1V378H132.1V368.65Z",
    className: "illustration_primary-ultralight"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M131.7 368.65H128.7V378H131.7V368.65Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 368.65H133.5V378H136.5V368.65Z",
    className: "illustration_primary-ultralight"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M136.15 368.65H133.15V378H136.15V368.65Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M152.85 368.65H138.05V380.55H152.85V368.65Z",
    className: "illustration_primary-ultralight"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M152.4 368.65H137.6V380.55H152.4V368.65Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M158.2 368.65H155.2V378H158.2V368.65Z",
    className: "illustration_primary-ultralight"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M157.8 368.65H154.8V378H157.8V368.65Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 366H122.4V367.35H162.5V366Z",
    className: "illustration_primary-ultralight"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M142.7 350.7C143.004 350.7 143.25 350.454 143.25 350.15C143.25 349.846 143.004 349.6 142.7 349.6C142.397 349.6 142.15 349.846 142.15 350.15C142.15 350.454 142.397 350.7 142.7 350.7Z",
    fill: "#FDDEA5"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M142.15 352.2C142.15 351.9 142.25 350.6 142.5 350.6H142.85C143.15 350.6 143.2 351.9 143.2 352.2H142.15Z",
    className: "illustration_primary_default"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M144.2 350.7C144.504 350.7 144.75 350.454 144.75 350.15C144.75 349.846 144.504 349.6 144.2 349.6C143.897 349.6 143.65 349.846 143.65 350.15C143.65 350.454 143.897 350.7 144.2 350.7Z",
    fill: "#FDDEA5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M143.65 352.2C143.65 351.9 143.75 350.6 144 350.6H144.35C144.65 350.6 144.7 351.9 144.7 352.2H143.65Z",
    className: "illustration_primary_default"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M323.3 287.65H323.2C323.1 287.65 323 287.55 323 287.45V273.35C323 273.25 323.1 273.15 323.2 273.15H323.3C323.4 273.15 323.5 273.25 323.5 273.35V287.45C323.5 287.55 323.4 287.65 323.3 287.65Z",
    className: "illustration_primary_default"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M324.5 285.7H324.35C324.25 285.7 324.2 285.65 324.2 285.55V274.7C324.2 274.6 324.25 274.55 324.35 274.55H324.5C324.6 274.55 324.65 274.65 324.65 274.7V285.55C324.65 285.65 324.6 285.7 324.5 285.7Z",
    className: "illustration_primary_default"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M325.7 285.3H325.5C325.4 285.3 325.35 285.25 325.35 285.15V276.75C325.35 276.65 325.4 276.6 325.5 276.6H325.7C325.8 276.6 325.85 276.65 325.85 276.75V285.15C325.85 285.2 325.75 285.3 325.7 285.3Z",
    className: "illustration_primary_default"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M326.2 295.15H322.75C322.45 295.15 322.15 294.9 322.15 294.55V281.2C322.15 280.9 322.4 280.6 322.75 280.6H326.2C326.5 280.6 326.8 280.85 326.8 281.2V294.55C326.75 294.9 326.5 295.15 326.2 295.15Z",
    className: "illustration_primary_default"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M328.35 295.15H320.55C320.2 295.15 319.95 294.9 319.95 294.55V288C319.95 287.65 320.2 287.4 320.55 287.4H328.35C328.7 287.4 328.95 287.65 328.95 288V294.55C328.95 294.9 328.7 295.15 328.35 295.15Z",
    className: "illustration_primary-ultralight"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M335.85 380.65H313.05L316.95 307.5H332L335.85 380.65Z",
    className: "illustration_primary-ultralight"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 313,
    y: 307,
    width: 23,
    height: 74
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M335.85 380.65H313.05L316.95 307.5H332L335.85 380.65Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.451 299.6L329.75 386.95L301.75 382.75L311.4 297.6L324.451 299.6Z",
    className: "illustration_primary-ultralight"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M303.9 301.9C303.9 298.8 313.1 293.35 324.5 293.35C335.85 293.35 345.1 298.8 345.1 301.9C330.2 301.9 317 301.9 303.9 301.9Z",
    className: "illustration_primary-ultralight"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 303,
    y: 293,
    width: 43,
    height: 9
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M303.9 301.9C303.9 298.8 313.1 293.35 324.5 293.35C335.85 293.35 345.1 298.8 345.1 301.9C330.2 301.9 317 301.9 303.9 301.9Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.75 285.6C326.75 285.6 314.45 296.3 321.7 305.9C328.95 315.5 303.9 320.9 303.9 320.9L287.9 287.05L324.5 279.5L326.75 285.6Z",
    className: "illustration_primary-ultralight"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M333.3 304.4H328.55C328.15 304.4 327.8 304.05 327.8 303.65V298.7C327.8 298.3 328.15 297.95 328.55 297.95H333.3C333.7 297.95 334.05 298.3 334.05 298.7V303.65C334.05 304.1 333.7 304.4 333.3 304.4Z",
    className: "illustration_primary-ultralight"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M332.6 304.4H327.85C327.45 304.4 327.1 304.05 327.1 303.65V298.7C327.1 298.3 327.45 297.95 327.85 297.95H332.6C333 297.95 333.35 298.3 333.35 298.7V303.65C333.35 304.1 333 304.4 332.6 304.4Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M331.85 300.65C332.154 300.65 332.4 300.404 332.4 300.1C332.4 299.796 332.154 299.55 331.85 299.55C331.547 299.55 331.3 299.796 331.3 300.1C331.3 300.404 331.547 300.65 331.85 300.65Z",
    fill: "#FDDEA5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M331.75 304.1L331.35 302.15C331.35 301.85 331.45 300.55 331.7 300.55H332.05C332.35 300.55 332.4 301.85 332.4 302.15L332 304.1C331.95 304.25 331.75 304.25 331.75 304.1Z",
    className: "illustration_primary_default"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M351.35 301.9C351.35 305.95 339.3 313.1 324.45 313.1C309.6 313.1 297.55 305.95 297.55 301.9C316.95 301.9 334.25 301.9 351.35 301.9Z",
    className: "illustration_primary-ultralight"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M321.1 319.5C322.122 319.5 322.951 318.672 322.951 317.65C322.951 316.628 322.122 315.8 321.1 315.8C320.079 315.8 319.25 316.628 319.25 317.65C319.25 318.672 320.079 319.5 321.1 319.5Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M320.55 330.6C321.572 330.6 322.4 329.772 322.4 328.75C322.4 327.728 321.572 326.9 320.55 326.9C319.528 326.9 318.7 327.728 318.7 328.75C318.7 329.772 319.528 330.6 320.55 330.6Z",
    fill: "#FFE600"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M320 341.65C321.022 341.65 321.85 340.822 321.85 339.8C321.85 338.778 321.022 337.95 320 337.95C318.979 337.95 318.15 338.778 318.15 339.8C318.15 340.822 318.979 341.65 320 341.65Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M319.45 352.75C320.472 352.75 321.3 351.922 321.3 350.9C321.3 349.878 320.472 349.05 319.45 349.05C318.428 349.05 317.6 349.878 317.6 350.9C317.6 351.922 318.428 352.75 319.45 352.75Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M318.9 363.8C319.922 363.8 320.75 362.972 320.75 361.95C320.75 360.928 319.922 360.1 318.9 360.1C317.879 360.1 317.05 360.928 317.05 361.95C317.05 362.972 317.879 363.8 318.9 363.8Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M275.85 390.15C296.506 390.15 313.25 388.001 313.25 385.35C313.25 382.699 296.506 380.55 275.85 380.55C255.195 380.55 238.45 382.699 238.45 385.35C238.45 388.001 255.195 390.15 275.85 390.15Z",
    fill: "#53C983"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M203.45 395.75C230.65 395.75 252.7 393.601 252.7 390.95C252.7 388.299 230.65 386.15 203.45 386.15C176.25 386.15 154.2 388.299 154.2 390.95C154.2 393.601 176.25 395.75 203.45 395.75Z",
    fill: "#53C983"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M347.5 387.85C360.313 387.85 370.7 386.596 370.7 385.05C370.7 383.504 360.313 382.25 347.5 382.25C334.687 382.25 324.3 383.504 324.3 385.05C324.3 386.596 334.687 387.85 347.5 387.85Z",
    fill: "#53C983"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M222.3 209.3C232.4 255.2 258.9 318.5 311.2 326.3C314.6 326.75 318 327 321.4 327C322.4 327 323.2 327.8 323.15 328.75C323.15 329.75 322.3 330.5 321.35 330.5C317.8 330.4 314.2 330.1 310.7 329.55C257.35 320.45 231.7 256.55 222.3 209.3Z",
    fill: "#FFE600"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M198.7 347.65C184.65 298.4 183.2 227.35 246.05 215.05C249.95 214.35 254.25 213.7 258.2 213.4C266.35 212.75 274.5 212.95 282.6 213.75C274.5 213.15 266.3 213.1 258.25 213.85C254.35 214.15 250.05 214.9 246.2 215.7C204.35 224.7 191.45 259.9 193.55 299.05C194.4 315.15 197.3 331.2 202.1 346.6C202.7 348.7 199.5 349.95 198.7 347.65Z",
    fill: "#FFE600"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M157.95 345.25C197.9 331.45 235.6 302.05 248.7 260.6C253.1 246.9 254.6 232.35 253.85 218C254.9 232.4 253.7 247 249.55 260.85C239.35 296.1 211 323.25 179.05 339.8C172.55 343.15 165.95 346.2 159.05 348.6C156.75 349.25 155.65 346.05 157.95 345.25Z",
    fill: "#FFE600"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M338.438 361.534L362.238 361.534L362.238 350.784L338.438 350.784L338.438 361.534Z",
    className: "illustration_primary-ultralight"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M355.502 359.434L358.602 359.434L358.602 352.834L355.502 352.834L355.502 359.434Z",
    className: "illustration_primary-ultralight"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M351.457 359.434L354.557 359.434L354.557 352.834L351.457 352.834L351.457 359.434Z",
    className: "illustration_primary-ultralight"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M347.412 359.434L350.512 359.434L350.512 352.834L347.412 352.834L347.412 359.434Z",
    className: "illustration_primary-ultralight"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M343.366 359.434L346.466 359.434L346.466 352.834L343.366 352.834L343.366 359.434Z",
    className: "illustration_primary-ultralight"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M355.334 359.434L358.434 359.434L358.434 352.834L355.334 352.834L355.334 359.434Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M351.288 359.434L354.388 359.434L354.388 352.834L351.288 352.834L351.288 359.434Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M347.243 359.434L350.343 359.434L350.343 352.834L347.243 352.834L347.243 359.434Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M343.197 359.434L346.297 359.434L346.297 352.834L343.197 352.834L343.197 359.434Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M355.334 360.031L358.434 360.031L358.434 359.481L355.334 359.481L355.334 360.031Z",
    className: "illustration_primary-ultralight"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M351.288 360.031L354.388 360.031L354.388 359.481L351.288 359.481L351.288 360.031Z",
    className: "illustration_primary-ultralight"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M347.243 360.031L350.343 360.031L350.343 359.481L347.243 359.481L347.243 360.031Z",
    className: "illustration_primary-ultralight"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M343.197 360.031L346.297 360.031L346.297 359.481L343.197 359.481L343.197 360.031Z",
    className: "illustration_primary-ultralight"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M355.705 360.031L358.805 360.031L358.805 359.481L355.705 359.481L355.705 360.031Z",
    className: "illustration_primary-lightest"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M351.66 360.031L354.76 360.031L354.76 359.481L351.66 359.481L351.66 360.031Z",
    className: "illustration_primary-lightest"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M347.614 360.031L350.714 360.031L350.714 359.481L347.614 359.481L347.614 360.031Z",
    className: "illustration_primary-lightest"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M343.569 360.031L346.669 360.031L346.669 359.481L343.569 359.481L343.569 360.031Z",
    className: "illustration_primary-lightest"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 350.75H332.55V361.5H338.45V350.75Z",
    className: "illustration_primary-ultralight"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 350,
    width: 7,
    height: 12
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 350.75H332.55V361.5H338.45V350.75Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.65 356.95V356.9C328.7 356.9 334.2 355.95 336.3 352.9C338.45 349.85 344.7 343.55 344.75 343.5L344.8 343.55C344.75 343.6 338.45 349.9 336.35 352.95C334.2 356 328.7 356.95 328.65 356.95Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 350,
    width: 7,
    height: 12
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 350.75H332.55V361.5H338.45V350.75Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.7 358.2V358.15C329.75 358.15 334.05 357.85 334.55 357.85C335 357.85 337.35 356.2 339.4 353.45C341.4 350.8 345.7 347.5 345.75 347.5L345.8 347.55C345.75 347.6 341.45 350.85 339.45 353.5C337.5 356.1 335.1 357.95 334.55 357.95C334 357.9 329.7 358.2 329.7 358.2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 350,
    width: 7,
    height: 12
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 350.75H332.55V361.5H338.45V350.75Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.25 366.25C341.25 366.25 341 364.65 340.3 363.1C339.65 361.65 338.45 359.9 336.45 359.8C332.6 359.6 328.65 359.8 328.65 359.8V359.75C328.7 359.75 332.65 359.55 336.45 359.75C338.05 359.85 339.4 361 340.35 363.1C341.05 364.7 341.3 366.25 341.3 366.25H341.25Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 350,
    width: 7,
    height: 12
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 350.75H332.55V361.5H338.45V350.75Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.45 352.05C330.65 352.05 328.75 351.6 328.65 351.6V351.55C328.7 351.55 334 352.8 335.3 351.2C336.6 349.6 338.8 345.85 338.8 345.8L338.85 345.85C338.85 345.9 336.65 349.6 335.3 351.25C334.8 351.85 333.65 352.05 332.45 352.05Z",
    fill: "white"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M338.477 350.742L362.627 350.742L362.627 350.242L338.477 350.242L338.477 350.742Z",
    className: "illustration_primary-ultralight"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M338.477 350.257L362.627 350.257L362.627 349.757L338.477 349.757L338.477 350.257Z",
    className: "illustration_primary-ultralight"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 350.3H332.2V350.8H338.45V350.3Z",
    className: "illustration_primary-ultralight"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 349.8H332.2V350.3H338.45V349.8Z",
    className: "illustration_primary-ultralight"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.45 349.8H332.2V350.8H338.45V349.8Z",
    fill: "black"
  }))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M338.438 349.79L362.238 349.79L362.238 342.94L338.438 342.94L338.438 349.79Z",
    className: "illustration_primary-ultralight"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M343.167 349.485L344.017 349.485L344.017 343.285L343.167 343.285L343.167 349.485Z",
    className: "illustration_primary-ultralight"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M343.304 349.485L344.154 349.485L344.154 343.285L343.304 343.285L343.304 349.485Z",
    className: "illustration_primary-lightest"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 342.9H332.55V349.75H338.45V342.9Z",
    className: "illustration_primary-ultralight"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 342,
    width: 7,
    height: 8
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 342.9H332.55V349.75H338.45V342.9Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.65 345.2V345.15C328.7 345.15 334.2 344.2 336.3 341.15C336.45 340.9 336.55 340.75 336.65 340.55C337.2 339.65 337.7 338.75 344.75 331.7L344.8 331.75C337.8 338.75 337.25 339.7 336.7 340.55C336.6 340.75 336.5 340.9 336.35 341.15C334.2 344.25 328.7 345.2 328.65 345.2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 342,
    width: 7,
    height: 8
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 342.9H332.55V349.75H338.45V342.9Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.7 346.45V346.4C329.75 346.4 334.05 346.1 334.55 346.1C335 346.1 337.35 344.45 339.4 341.7C339.6 341.45 339.7 341.25 339.8 341.05C340.2 340.3 340.55 339.65 345.75 335.75L345.8 335.8C340.6 339.7 340.3 340.35 339.9 341.1C339.8 341.3 339.7 341.5 339.5 341.75C337.55 344.35 335.15 346.2 334.6 346.2C334 346.15 329.7 346.45 329.7 346.45Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 342,
    width: 7,
    height: 8
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 342.9H332.55V349.75H338.45V342.9Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.25 354.5C341.25 354.5 341 352.9 340.3 351.35C339.65 349.9 338.45 348.15 336.45 348.05C332.6 347.8 328.65 348.05 328.65 348.05V348C328.7 348 332.65 347.8 336.45 348C338.05 348.1 339.4 349.25 340.35 351.35C341.05 352.95 341.3 354.5 341.3 354.5H341.25Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 342,
    width: 7,
    height: 8
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 342.9H332.55V349.75H338.45V342.9Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.35 347.5C334.15 347.5 333.9 347.4 333.75 347.2C333.6 347 333.45 346.55 333.85 345.6C332.95 345.05 331.4 344.4 328.65 343.75V343.7C331.4 344.35 333 345 333.85 345.55C334.1 345 334.55 344.25 335.3 343.35C336.6 341.75 338.8 334.15 338.8 334.1H338.85C338.85 334.2 336.65 341.75 335.3 343.4C334.55 344.35 334.1 345.05 333.85 345.6C334.8 346.2 334.95 346.7 334.95 346.9C334.95 347.15 334.8 347.4 334.5 347.5C334.55 347.45 334.45 347.5 334.35 347.5ZM333.9 345.6C333.55 346.5 333.7 346.95 333.8 347.15C334 347.45 334.35 347.5 334.55 347.4C334.75 347.35 334.95 347.15 334.95 346.85C334.95 346.65 334.8 346.2 333.9 345.6Z",
    fill: "white"
  }))), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M338.477 342.888L362.627 342.888L362.627 342.388L338.477 342.388L338.477 342.888Z",
    className: "illustration_primary-ultralight"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M338.477 342.403L362.627 342.403L362.627 341.903L338.477 341.903L338.477 342.403Z",
    className: "illustration_primary_default"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 342.45H332.2V342.95H338.45V342.45Z",
    className: "illustration_primary-ultralight"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 341.95H332.2V342.45H338.45V341.95Z",
    className: "illustration_primary-ultralight"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.45 341.95H332.2V342.95H338.45V341.95Z",
    fill: "black"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M349.2 345.5H347.6V343.9H345.9V345.5H344.3V347.2H345.9V348.8H347.6V347.2H349.2V345.5Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M338.438 373.267L362.238 373.267L362.238 362.517L338.438 362.517L338.438 373.267Z",
    className: "illustration_primary-ultralight"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M355.502 371.217L358.602 371.217L358.602 364.617L355.502 364.617L355.502 371.217Z",
    className: "illustration_primary-ultralight"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M351.457 371.217L354.557 371.217L354.557 364.617L351.457 364.617L351.457 371.217Z",
    className: "illustration_primary-ultralight"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M347.412 371.217L350.512 371.217L350.512 364.617L347.412 364.617L347.412 371.217Z",
    className: "illustration_primary-ultralight"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M343.366 371.217L346.466 371.217L346.466 364.617L343.366 364.617L343.366 371.217Z",
    className: "illustration_primary-ultralight"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M355.334 371.217L358.434 371.217L358.434 364.617L355.334 364.617L355.334 371.217Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M351.288 371.217L354.388 371.217L354.388 364.617L351.288 364.617L351.288 371.217Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M347.243 371.217L350.343 371.217L350.343 364.617L347.243 364.617L347.243 371.217Z",
    fill: "#FFE600"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M343.197 371.217L346.297 371.217L346.297 364.617L343.197 364.617L343.197 371.217Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M355.334 371.764L358.434 371.764L358.434 371.214L355.334 371.214L355.334 371.764Z",
    className: "illustration_primary-ultralight"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M351.288 371.764L354.388 371.764L354.388 371.214L351.288 371.214L351.288 371.764Z",
    className: "illustration_primary-ultralight"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M347.243 371.764L350.343 371.764L350.343 371.214L347.243 371.214L347.243 371.764Z",
    className: "illustration_primary-ultralight"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M343.197 371.764L346.297 371.764L346.297 371.214L343.197 371.214L343.197 371.764Z",
    className: "illustration_primary-ultralight"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M355.705 371.764L358.805 371.764L358.805 371.214L355.705 371.214L355.705 371.764Z",
    className: "illustration_primary-lightest"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M351.66 371.764L354.76 371.764L354.76 371.214L351.66 371.214L351.66 371.764Z",
    className: "illustration_primary-lightest"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M347.614 371.764L350.714 371.764L350.714 371.214L347.614 371.214L347.614 371.764Z",
    className: "illustration_primary-lightest"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M343.569 371.764L346.669 371.764L346.669 371.214L343.569 371.214L343.569 371.764Z",
    className: "illustration_primary-lightest"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 362.5H332.55V373.25H338.45V362.5Z",
    className: "illustration_primary-ultralight"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 362,
    width: 7,
    height: 12
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 362.5H332.55V373.25H338.45V362.5Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.65 368.7V368.65C328.7 368.65 334.2 367.7 336.3 364.65C338.45 361.6 344.7 355.3 344.75 355.25L344.8 355.3C344.75 355.35 338.45 361.65 336.35 364.7C334.2 367.75 328.7 368.7 328.65 368.7Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 362,
    width: 7,
    height: 12
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 362.5H332.55V373.25H338.45V362.5Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.7 369.95V369.9C329.75 369.9 334.05 369.6 334.55 369.6C335 369.6 337.35 367.95 339.4 365.2C341.4 362.55 345.7 359.25 345.75 359.25L345.8 359.3C345.75 359.35 341.45 362.6 339.45 365.25C337.5 367.85 335.1 369.7 334.55 369.7C334 369.65 329.7 369.95 329.7 369.95Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 362,
    width: 7,
    height: 12
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 362.5H332.55V373.25H338.45V362.5Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.25 378C341.25 378 341 376.4 340.3 374.85C339.65 373.4 338.45 371.65 336.45 371.55C332.6 371.35 328.65 371.55 328.65 371.55V371.5C328.7 371.5 332.65 371.3 336.45 371.5C338.05 371.6 339.4 372.75 340.35 374.85C341.05 376.45 341.3 378 341.3 378H341.25Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 362,
    width: 7,
    height: 12
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 362.5H332.55V373.25H338.45V362.5Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.45 363.8C330.65 363.8 328.75 363.35 328.65 363.35V363.3C328.7 363.3 334 364.55 335.3 362.95C336.6 361.35 338.8 357.6 338.8 357.6L338.85 357.65C338.85 357.7 336.65 361.4 335.3 363.05C334.8 363.6 333.65 363.8 332.45 363.8Z",
    fill: "white"
  }))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M338.477 362.525L362.627 362.525L362.627 362.025L338.477 362.025L338.477 362.525Z",
    className: "illustration_primary-ultralight"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M338.477 362.041L362.627 362.041L362.627 361.541L338.477 361.541L338.477 362.041Z",
    className: "illustration_primary-ultralight"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 362H332.2V362.5H338.45V362Z",
    className: "illustration_primary-ultralight"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 361.5H332.2V362H338.45V361.5Z",
    className: "illustration_primary-ultralight"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.45 361.5H332.2V362.5H338.45V361.5Z",
    fill: "black"
  }))), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M338.438 385.051L362.238 385.051L362.238 374.301L338.438 374.301L338.438 385.051Z",
    className: "illustration_primary-ultralight"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M355.502 382.951L358.602 382.951L358.602 376.351L355.502 376.351L355.502 382.951Z",
    className: "illustration_primary-ultralight"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M351.457 382.951L354.557 382.951L354.557 376.351L351.457 376.351L351.457 382.951Z",
    className: "illustration_primary-ultralight"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M347.412 382.951L350.512 382.951L350.512 376.351L347.412 376.351L347.412 382.951Z",
    className: "illustration_primary-ultralight"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M343.366 382.951L346.466 382.951L346.466 376.351L343.366 376.351L343.366 382.951Z",
    className: "illustration_primary-ultralight"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M355.334 382.951L358.434 382.951L358.434 376.351L355.334 376.351L355.334 382.951Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M351.288 382.951L354.388 382.951L354.388 376.351L351.288 376.351L351.288 382.951Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M347.243 382.951L350.343 382.951L350.343 376.351L347.243 376.351L347.243 382.951Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M343.197 382.951L346.297 382.951L346.297 376.351L343.197 376.351L343.197 382.951Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M355.334 383.548L358.434 383.548L358.434 382.998L355.334 382.998L355.334 383.548Z",
    className: "illustration_primary-ultralight"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M351.288 383.548L354.388 383.548L354.388 382.998L351.288 382.998L351.288 383.548Z",
    className: "illustration_primary-ultralight"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M347.243 383.548L350.343 383.548L350.343 382.998L347.243 382.998L347.243 383.548Z",
    className: "illustration_primary-ultralight"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M343.197 383.548L346.297 383.548L346.297 382.998L343.197 382.998L343.197 383.548Z",
    className: "illustration_primary-ultralight"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M355.705 383.548L358.805 383.548L358.805 382.998L355.705 382.998L355.705 383.548Z",
    className: "illustration_primary-lightest"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M351.66 383.548L354.76 383.548L354.76 382.998L351.66 382.998L351.66 383.548Z",
    className: "illustration_primary-lightest"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M347.614 383.548L350.714 383.548L350.714 382.998L347.614 382.998L347.614 383.548Z",
    className: "illustration_primary-lightest"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M343.569 383.548L346.669 383.548L346.669 382.998L343.569 382.998L343.569 383.548Z",
    className: "illustration_primary-lightest"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 374.25H332.55V385H338.45V374.25Z",
    className: "illustration_primary-ultralight"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 374,
    width: 7,
    height: 11
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 374.25H332.55V385H338.45V374.25Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.65 380.45V380.4C328.7 380.4 334.2 379.45 336.3 376.4C338.45 373.35 344.7 367.05 344.75 367L344.8 367.05C344.75 367.1 338.45 373.4 336.35 376.45C334.2 379.5 328.7 380.45 328.65 380.45Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 374,
    width: 7,
    height: 11
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 374.25H332.55V385H338.45V374.25Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.7 381.7V381.65C329.75 381.65 334.05 381.35 334.55 381.35C335 381.35 337.35 379.7 339.4 376.95C341.4 374.3 345.7 371 345.75 371L345.8 371.05C345.75 371.1 341.45 374.35 339.45 377C337.5 379.6 335.1 381.45 334.55 381.45C334 381.4 329.7 381.7 329.7 381.7Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 374,
    width: 7,
    height: 11
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 374.25H332.55V385H338.45V374.25Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.25 389.75C341.25 389.75 341 388.15 340.3 386.6C339.65 385.15 338.45 383.4 336.45 383.3C332.6 383.05 328.65 383.3 328.65 383.3V383.25C328.7 383.25 332.65 383 336.45 383.25C338.05 383.35 339.4 384.5 340.35 386.6C341.05 388.2 341.3 389.75 341.3 389.75H341.25Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 374,
    width: 7,
    height: 11
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 374.25H332.55V385H338.45V374.25Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.45 375.55C330.65 375.55 328.75 375.1 328.65 375.1V375.05C328.7 375.05 334 376.3 335.3 374.7C336.6 373.1 338.8 369.35 338.8 369.3L338.85 369.35C338.85 369.4 336.65 373.1 335.3 374.75C334.8 375.35 333.65 375.55 332.45 375.55Z",
    fill: "white"
  }))), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M338.477 374.259L362.627 374.259L362.627 373.759L338.477 373.759L338.477 374.259Z",
    className: "illustration_primary-ultralight"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M338.477 373.774L362.627 373.774L362.627 373.274L338.477 373.274L338.477 373.774Z",
    className: "illustration_primary-ultralight"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 373.8H332.2V374.3H338.45V373.8Z",
    className: "illustration_primary-ultralight"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M338.45 373.3H332.2V373.8H338.45V373.3Z",
    className: "illustration_primary-ultralight"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.45 373.3H332.2V374.3H338.45V373.3Z",
    fill: "black"
  }))), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M349.55 345.5H347.95V343.9H346.25V345.5H344.65V347.2H346.25V348.8H347.95V347.2H349.55V345.5Z",
    className: "illustration_primary_default"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M355.503 347.738L358.603 347.738L358.603 344.338L355.503 344.338L355.503 347.738Z",
    className: "illustration_primary-ultralight"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M355.334 347.738L358.434 347.738L358.434 344.338L355.334 344.338L355.334 347.738Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M355.334 348.316L358.434 348.316L358.434 347.766L355.334 347.766L355.334 348.316Z",
    className: "illustration_primary-ultralight"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M355.705 348.316L358.805 348.316L358.805 347.766L355.705 347.766L355.705 348.316Z",
    className: "illustration_primary-lightest"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M284.3 359.55V376.1H277.55V385.8H241.55V366.45L257.75 359.55H284.3Z",
    className: "illustration_primary-ultralight"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M295.85 374.05H255.9V382.4H295.85V374.05Z",
    className: "illustration_primary-ultralight"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M300.55 366.45V385.8H293.3V376.1H277.55V385.8H268.1V366.45L284.3 359.55L300.55 366.45Z",
    className: "illustration_primary-ultralight"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M300.55 368.15H268.1V369.65H300.55V368.15Z",
    className: "illustration_primary-ultralight"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.561 369.669H268.111V368.169H241.561V369.669Z",
    fill: "black"
  }))), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M284.3 359.55L268.1 366.6H241.55V366.45L257.75 359.55H284.3Z",
    className: "illustration_primary_default"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M268.25 349.05H263.3V363.7H268.25V349.05Z",
    className: "illustration_primary-ultralight"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M260.457 363.766H263.307V349.115H260.457V363.766Z",
    className: "illustration_primary-ultralight"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M268.7 347.85H263.2V349.05H268.7V347.85Z",
    className: "illustration_primary-ultralight"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M259.985 349.078H263.185V347.879H259.985V349.078Z",
    className: "illustration_primary-ultralight"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M268.25 349.05H263.3V349.95H268.25V349.05Z",
    className: "illustration_primary-ultralight"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M268.25 352.8H263.3V353.7H268.25V352.8Z",
    className: "illustration_primary-ultralight"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M268.25 356.5H263.3V357.4H268.25V356.5Z",
    className: "illustration_primary-ultralight"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M268.25 360.2H263.3V361.1H268.25V360.2Z",
    className: "illustration_primary-ultralight"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M238.05 349.95H185.65L212.5 339.4L238.05 349.95Z",
    className: "illustration_primary-ultralight"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M170.45 349.95H185.65L212.6 339.4H202.9L170.45 349.95Z",
    className: "illustration_primary_default"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M241.6 374.8H167.55V391.1H241.6V374.8Z",
    className: "illustration_primary-lighter"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M225.1 376.25H221.65H215.5H212.05H205.9H202.45H196.3H191.5V390.4H192.85V387C192.85 385.95 193.6 385.1 194.55 385.1C195 385.1 195.45 385.3 195.75 385.65C196.05 386 196.25 386.45 196.25 387V390.4H197.6V387C197.6 385.95 198.4 385.1 199.3 385.1C199.75 385.1 200.2 385.3 200.5 385.65C200.8 386 201 386.5 201 387V390.35H202.35V387C202.35 385.95 203.1 385.1 204.05 385.1C204.5 385.1 204.95 385.3 205.25 385.65C205.55 386 205.75 386.45 205.75 387V390.4H207.1V387C207.1 385.95 207.9 385.1 208.8 385.1C209.25 385.1 209.7 385.3 210 385.65C210.3 386 210.5 386.5 210.5 387V390.35H211.85V387C211.85 385.95 212.6 385.1 213.55 385.1C214 385.1 214.45 385.3 214.75 385.65C215.05 386 215.25 386.45 215.25 387V390.4H216.6V387C216.6 385.95 217.4 385.1 218.3 385.1C218.75 385.1 219.2 385.3 219.5 385.65C219.8 386 220 386.5 220 387V390.35H221.35V387C221.35 385.95 222.1 385.1 223.05 385.1C223.5 385.1 223.95 385.3 224.25 385.65C224.55 386 224.75 386.45 224.75 387V390.4H226.1V387C226.1 385.95 226.9 385.1 227.8 385.1C228.25 385.1 228.7 385.3 229 385.65C229.3 386 229.5 386.5 229.5 387V390.35H230.85V376.2H225.1V376.25Z",
    className: "illustration_primary-ultralight"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M225.95 376.25H222.5H216.35H212.9H206.75H203.3H197.15H192.35V390.4H193.7V387C193.7 385.95 194.45 385.1 195.4 385.1C195.85 385.1 196.3 385.3 196.6 385.65C196.9 386 197.1 386.45 197.1 387V390.4H198.45V387C198.45 385.95 199.25 385.1 200.15 385.1C200.6 385.1 201.05 385.3 201.35 385.65C201.65 386 201.85 386.5 201.85 387V390.35H203.2V387C203.2 385.95 203.95 385.1 204.9 385.1C205.35 385.1 205.8 385.3 206.1 385.65C206.4 386 206.6 386.45 206.6 387V390.4H207.95V387C207.95 385.95 208.75 385.1 209.65 385.1C210.1 385.1 210.55 385.3 210.85 385.65C211.15 386 211.35 386.5 211.35 387V390.35H212.7V387C212.7 385.95 213.45 385.1 214.4 385.1C214.85 385.1 215.3 385.3 215.6 385.65C215.9 386 216.1 386.45 216.1 387V390.4H217.45V387C217.45 385.95 218.25 385.1 219.15 385.1C219.6 385.1 220.05 385.3 220.35 385.65C220.65 386 220.85 386.5 220.85 387V390.35H222.2V387C222.2 385.95 222.95 385.1 223.9 385.1C224.35 385.1 224.8 385.3 225.1 385.65C225.4 386 225.6 386.45 225.6 387V390.4H226.95V387C226.95 385.95 227.75 385.1 228.65 385.1C229.1 385.1 229.55 385.3 229.85 385.65C230.15 386 230.35 386.5 230.35 387V390.35H231.7V376.2H225.95V376.25Z",
    className: "illustration_primary-ultralight"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M247.35 367.95H177.1V378.4H247.35V367.95Z",
    className: "illustration_primary-ultralight"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M194.45 390.15H192.1V391.1H194.45V390.15Z",
    className: "illustration_primary-ultralight"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M199.25 390.15H196.9V391.1H199.25V390.15Z",
    className: "illustration_primary-ultralight"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M204.05 390.15H201.7V391.1H204.05V390.15Z",
    className: "illustration_primary-ultralight"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M208.9 390.15H206.55V391.1H208.9V390.15Z",
    className: "illustration_primary-ultralight"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M213.7 390.15H211.35V391.1H213.7V390.15Z",
    className: "illustration_primary-ultralight"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M218.5 390.15H216.15V391.1H218.5V390.15Z",
    className: "illustration_primary-ultralight"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M223.3 390.15H220.95V391.1H223.3V390.15Z",
    className: "illustration_primary-ultralight"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M228.1 390.15H225.75V391.1H228.1V390.15Z",
    className: "illustration_primary-ultralight"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M232.9 390.15H230.55V391.1H232.9V390.15Z",
    className: "illustration_primary-ultralight"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M219.3 379.6H205.1V382.35H219.3V379.6Z",
    className: "illustration_primary-ultralight"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M189.95 378.35H187.45V390.35H189.95V378.35Z",
    className: "illustration_primary-ultralight"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M187.45 378.35H184.1V390.35H187.45V378.35Z",
    className: "illustration_primary-lighter"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M159.519 378.396H177.069V367.946H159.519V378.396Z",
    className: "illustration_primary-lighter"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M182.95 378.35H180.45V390.35H182.95V378.35Z",
    className: "illustration_primary-ultralight"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M180.45 378.35H177.1V390.35H180.45V378.35Z",
    className: "illustration_primary-lighter"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M238.05 349.75H185.65V368.5H238.05V349.75Z",
    className: "illustration_primary-ultralight"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M170.468 368.476H185.668V349.726H170.468V368.476Z",
    className: "illustration_primary-lighter"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M243.55 349.75H182.95V350.85H243.55V349.75Z",
    className: "illustration_primary-ultralight"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M168.312 350.822H182.962V349.722H168.312V350.822Z",
    className: "illustration_primary-ultralight"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M240.2 378.35H237.7V390.35H240.2V378.35Z",
    className: "illustration_primary-ultralight"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M237.65 378.35H234.3V390.35H237.65V378.35Z",
    className: "illustration_primary-lighter"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M247.35 378.4H244.85V390.4H247.35V378.4Z",
    className: "illustration_primary-ultralight"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M244.85 378.4H241.5V390.4H244.85V378.4Z",
    className: "illustration_primary-lighter"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M248.35 367.95H176.1V369.2H248.35V367.95Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M248.35 375.6H176.1V376.85H248.35V375.6Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M186.997 391.09H190.297V390.14H186.997V391.09Z",
    className: "illustration_primary-ultralight"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M187 390.15H183.8V391.1H187V390.15Z",
    className: "illustration_primary-lighter"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M179.942 391.09H183.242V390.14H179.942V391.09Z",
    className: "illustration_primary-ultralight"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M179.95 390.15H176.75V391.1H179.95V390.15Z",
    className: "illustration_primary-lighter"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M244.33 391.09H247.63V390.14H244.33V391.09Z",
    className: "illustration_primary-ultralight"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M244.35 390.15H241.15V391.1H244.35V390.15Z",
    className: "illustration_primary-lighter"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M237.275 391.09H240.575V390.14H237.275V391.09Z",
    className: "illustration_primary-ultralight"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M237.3 390.15H234.1V391.1H237.3V390.15Z",
    className: "illustration_primary-lighter"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M158.41 369.239H176.06V367.989H158.41V369.239Z",
    className: "illustration_primary-ultralight"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M158.41 376.889H176.06V375.639H158.41V376.889Z",
    className: "illustration_primary-ultralight"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M175.15 378.35H173.25V390.35H175.15V378.35Z",
    className: "illustration_primary-ultralight"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M173.25 378.35H170.7V390.35H173.25V378.35Z",
    className: "illustration_primary-lighter"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M172.898 391.09H175.398V390.14H172.898V391.09Z",
    className: "illustration_primary-ultralight"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M172.9 390.15H170.5V391.1H172.9V390.15Z",
    className: "illustration_primary-lighter"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M168.3 378.35H166.9V390.35H168.3V378.35Z",
    className: "illustration_primary-ultralight"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M166.9 378.35H159.5V390.35H166.9V378.35Z",
    className: "illustration_primary-lighter"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M166.62 391.09H168.47V390.14H166.62V391.09Z",
    className: "illustration_primary-ultralight"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M166.6 390.15H159.3V391.1H166.6V390.15Z",
    className: "illustration_primary-lighter"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M193.25 390.15H190.9V391.1H193.25V390.15Z",
    className: "illustration_primary-ultralight"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M198.05 390.15H195.7V391.1H198.05V390.15Z",
    className: "illustration_primary-ultralight"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M202.85 390.15H200.5V391.1H202.85V390.15Z",
    className: "illustration_primary-ultralight"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M207.65 390.15H205.3V391.1H207.65V390.15Z",
    className: "illustration_primary-ultralight"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M212.45 390.15H210.1V391.1H212.45V390.15Z",
    className: "illustration_primary-ultralight"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M217.3 390.15H214.95V391.1H217.3V390.15Z",
    className: "illustration_primary-ultralight"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M222.1 390.15H219.75V391.1H222.1V390.15Z",
    className: "illustration_primary-ultralight"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M226.9 390.15H224.55V391.1H226.9V390.15Z",
    className: "illustration_primary-ultralight"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M231.7 390.15H229.35V391.1H231.7V390.15Z",
    className: "illustration_primary-ultralight"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M219.7 379.6H205.5V382.35H219.7V379.6Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M193.9 371H179.7V373.75H193.9V371Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M210.3 371H196.1V373.75H210.3V371Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M190.85 352.55H189V366.6H190.85V352.55Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M194.2 352.55H192.35V366.6H194.2V352.55Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M197.55 352.55H195.7V366.6H197.55V352.55Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M200.85 352.55H199V366.6H200.85V352.55Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M204.2 352.55H202.35V366.6H204.2V352.55Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M222.45 352.55H220.6V366.6H222.45V352.55Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M225.8 352.55H223.95V366.6H225.8V352.55Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M229.15 352.55H227.3V366.6H229.15V352.55Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M232.45 352.55H230.6V366.6H232.45V352.55Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M235.8 352.55H233.95V366.6H235.8V352.55Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M226.7 371H212.5V373.75H226.7V371Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M243.1 371H228.9V373.75H243.1V371Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M212.8 347.3C213.96 347.3 214.9 346.36 214.9 345.2C214.9 344.04 213.96 343.1 212.8 343.1C211.64 343.1 210.7 344.04 210.7 345.2C210.7 346.36 211.64 347.3 212.8 347.3Z",
    className: "illustration_primary-lighter"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M212.55 362.95C215.036 362.95 217.05 360.935 217.05 358.45C217.05 355.965 215.036 353.95 212.55 353.95C210.065 353.95 208.05 355.965 208.05 358.45C208.05 360.935 210.065 362.95 212.55 362.95Z",
    className: "illustration_primary-lighter"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M213.1 362.95C215.585 362.95 217.6 360.935 217.6 358.45C217.6 355.965 215.585 353.95 213.1 353.95C210.615 353.95 208.6 355.965 208.6 358.45C208.6 360.935 210.615 362.95 213.1 362.95Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M212.4 347.3C213.56 347.3 214.5 346.36 214.5 345.2C214.5 344.04 213.56 343.1 212.4 343.1C211.24 343.1 210.3 344.04 210.3 345.2C210.3 346.36 211.24 347.3 212.4 347.3Z",
    fill: "#FFE600"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M213.1 358.8C213.294 358.8 213.45 358.643 213.45 358.45C213.45 358.257 213.294 358.1 213.1 358.1C212.907 358.1 212.75 358.257 212.75 358.45C212.75 358.643 212.907 358.8 213.1 358.8Z",
    className: "illustration_primary-lighter"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M216.05 356.55C216 356.5 215.9 356.45 215.85 356.5L213.3 358.15C213.25 358.2 213.2 358.3 213.25 358.35C213.3 358.4 213.4 358.45 213.45 358.4L216 356.75C216.1 356.75 216.1 356.65 216.05 356.55Z",
    className: "illustration_primary-lighter"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M213.2 360.8H213.35C213.45 360.8 213.55 360.7 213.5 360.6L213.35 358.75C213.35 358.65 213.25 358.55 213.15 358.6H213C212.9 358.6 212.8 358.7 212.85 358.8L213 360.65C213 360.75 213.1 360.8 213.2 360.8Z",
    className: "illustration_primary-lighter"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M217.75 332.7H211.9V335.1H217.75V332.7Z",
    className: "illustration_primary-ultralight"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M212.55 332.7H211.9V339.55H212.55V332.7Z",
    className: "illustration_primary-ultralight"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M249.05 396.6H248.15C248.05 396.6 248 396.55 248 396.45V388.15C248 388.05 248.05 388 248.15 388H249.05C249.15 388 249.2 388.05 249.2 388.15V396.45C249.2 396.55 249.15 396.6 249.05 396.6Z",
    fill: "#0A331A"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M248.5 391.8H248.1V391.15H245.7C245.6 391.15 245.5 391.05 245.5 390.95V387.4H245.9V390.75H248.3C248.4 390.75 248.5 390.85 248.5 390.95V391.8Z",
    fill: "#0A331A"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M247.55 387.6H247.15V390.9H247.55V387.6Z",
    fill: "#0A331A"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M246.6 389.7H245.7V389.3H246.4V387.6H246.8V389.5C246.8 389.65 246.7 389.7 246.6 389.7Z",
    fill: "#0A331A"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M245.7 389.2H244.35C244.25 389.2 244.15 389.1 244.15 389V387.1H244.55V388.8H245.65V389.2H245.7Z",
    fill: "#0A331A"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M249.1 390.95H248.7V390.1C248.7 390 248.8 389.9 248.9 389.9H251.3V386.55H251.7V390.1C251.7 390.2 251.6 390.3 251.5 390.3H249.1V390.95Z",
    fill: "#0A331A"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M251.5 389.2H250.6C250.5 389.2 250.4 389.1 250.4 389V387.1H250.8V388.8H251.5V389.2Z",
    fill: "#0A331A"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M249.751 389.55H248.851V389.15H249.551V387.45H249.951V389.35C250.001 389.45 249.901 389.55 249.751 389.55Z",
    fill: "#0A331A"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M252.95 389.55H251.5V389.15H252.75V387.45H253.15V389.35C253.2 389.45 253.1 389.55 252.95 389.55Z",
    fill: "#0A331A"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M253.6 388.35H243.6C243.35 388.35 243.15 388.15 243.15 387.9V381.7C243.15 381.45 243.35 381.25 243.6 381.25H253.6C253.85 381.25 254.05 381.45 254.05 381.7V387.9C254.05 388.15 253.85 388.35 253.6 388.35Z",
    fill: "#126836"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 243,
    y: 381,
    width: 12,
    height: 8
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M253.6 388.35H243.6C243.35 388.35 243.15 388.15 243.15 387.9V381.7C243.15 381.45 243.35 381.25 243.6 381.25H253.6C253.85 381.25 254.05 381.45 254.05 381.7V387.9C254.05 388.15 253.85 388.35 253.6 388.35Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.85 388.35H248.85C248.6 388.35 248.4 388.15 248.4 387.9V381.7C248.4 381.45 248.6 381.25 248.85 381.25H258.85C259.1 381.25 259.3 381.45 259.3 381.7V387.9C259.3 388.15 259.1 388.35 258.85 388.35Z",
    fill: "#1E8749"
  }))), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M301.7 392.1H300.8C300.7 392.1 300.65 392 300.65 391.95V383.65C300.65 383.55 300.7 383.5 300.8 383.5H301.7C301.8 383.5 301.85 383.55 301.85 383.65V391.95C301.85 392 301.8 392.1 301.7 392.1Z",
    fill: "#0A331A"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M301.15 387.25H300.75V386.6H298.35C298.25 386.6 298.15 386.5 298.15 386.4V382.85H298.55V386.2H300.95C301.05 386.2 301.15 386.3 301.15 386.4V387.25Z",
    fill: "#0A331A"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M300.2 383.1H299.8V386.45H300.2V383.1Z",
    fill: "#0A331A"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M299.25 385.2H298.35V384.8H299.05V383.1H299.45V385C299.45 385.1 299.35 385.2 299.25 385.2Z",
    fill: "#0A331A"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M298.35 384.65H297C296.9 384.65 296.8 384.55 296.8 384.45V382.55H297.2V384.25H298.3V384.65H298.35Z",
    fill: "#0A331A"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M301.75 386.45H301.35V385.6C301.35 385.5 301.45 385.4 301.55 385.4H303.95V382H304.35V385.55C304.35 385.65 304.25 385.75 304.15 385.75H301.75V386.45Z",
    fill: "#0A331A"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M304.15 384.7H303.25C303.15 384.7 303.05 384.6 303.05 384.5V382.6H303.45V384.3H304.15V384.7Z",
    fill: "#0A331A"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M302.4 385.05H301.5V384.65H302.201V382.95H302.6V384.85C302.65 384.95 302.55 385.05 302.4 385.05Z",
    fill: "#0A331A"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M305.6 385H304.15V384.6H305.4V382.9H305.8V384.8C305.85 384.9 305.75 385 305.6 385Z",
    fill: "#0A331A"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M306.25 383.8H296.25C296 383.8 295.8 383.6 295.8 383.35V377.15C295.8 376.9 296 376.7 296.25 376.7H306.25C306.5 376.7 306.7 376.9 306.7 377.15V383.35C306.7 383.6 306.5 383.8 306.25 383.8Z",
    fill: "#126836"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_359_45721",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 376,
    width: 12,
    height: 8
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M306.25 383.8H296.25C296 383.8 295.8 383.6 295.8 383.35V377.15C295.8 376.9 296 376.7 296.25 376.7H306.25C306.5 376.7 306.7 376.9 306.7 377.15V383.35C306.7 383.6 306.5 383.8 306.25 383.8Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_359_45721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.5 383.8H301.5C301.25 383.8 301.05 383.6 301.05 383.35V377.15C301.05 376.9 301.25 376.7 301.5 376.7H311.5C311.75 376.7 311.95 376.9 311.95 377.15V383.35C311.95 383.6 311.75 383.8 311.5 383.8Z",
    fill: "#1E8749"
  }))), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M349.75 367.45C332.1 376.95 312.5 371.7 298.95 357.8C278.5 336.7 269.4 304.6 263 276.6C269.55 302.35 277.75 328.75 294.5 349.8C303.5 361 316.85 370.1 331.7 369.2C337.35 368.9 343.05 367.4 347.95 364.5C349.9 363.3 351.75 366.2 349.75 367.45Z",
    fill: "#FFE600"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M279.75 259C278.85 258.15 276.65 256.05 278.65 253.85C281 251.25 288.55 249.25 297.5 249.25C303.3 246.05 310.9 244.6 316.45 245.65C322.45 246.75 323.4 250.2 323.5 250.75C327.7 252.35 329.75 254.7 328.25 256.85C326.2 259.75 318.6 261.15 313.5 262.1C301.7 264.25 285.45 264.5 279.75 259Z",
    className: "illustration_primary-lighter"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9501 282.45C95.9001 281.5 93.3501 279.15 96.4501 277.15C100.15 274.75 110.9 273.4 123.15 274.2C131.75 271.5 142.4 270.75 149.75 272.3C157.7 273.95 158.3 277.55 158.35 278.1C163.75 280.1 166.1 282.65 163.55 284.7C160.2 287.45 149.5 288.15 142.35 288.65C125.9 289.75 103.65 288.5 96.9501 282.45Z",
    className: "illustration_primary-lighter"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M252.3 190.65C236.6 190.65 223.85 177.9 223.85 162.2C223.85 160.15 225.55 158.45 227.6 158.45C229.65 158.45 231.35 160.15 231.35 162.2C231.35 173.75 240.75 183.15 252.3 183.15C263.85 183.15 273.25 173.75 273.25 162.2C273.25 160.15 274.95 158.45 277 158.45C279.05 158.45 280.75 160.15 280.75 162.2C280.7 177.9 267.95 190.65 252.3 190.65Z",
    fill: "#FFE600"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M262.8 408.55C262.8 408.55 274.25 403.1 276.95 399.15C279.65 395.2 278.9 388.75 278.9 388.75H282.1C282.1 388.75 285.45 396.85 286.2 399.15C286.95 401.45 282.55 408.05 282.55 408.05C282.55 408.05 263.45 408.6 262.8 408.55Z",
    fill: "#53C983"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M340.8 387.1C340.8 387.1 329.85 395.5 320.55 395.75C311.25 396 282.75 396.6 282.75 396.6L281 401.45C281 401.45 312.8 402.05 325.6 398.65C338.4 395.2 348.85 387.1 348.85 387.1H340.8Z",
    fill: "#53C983"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M137.6 381.8C137.6 381.8 121.1 393.5 137.25 396.85C151 399.7 191 401.7 195.7 394.3C199.65 388.1 184.95 392.55 180.45 395.2C173.9 399 119.6 396.65 141.35 383.75C148.8 379.35 142.8 381.2 142.8 381.2L137.6 381.8Z",
    fill: "#53C983"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M228.1 394.3C228.1 394.3 226.2 402.3 238.9 404.3C251.6 406.25 274.9 404.3 274.9 404.3L279.8 399.75C279.8 399.75 249.8 402.05 243.55 399.75C237.35 397.45 234.85 394.35 234.85 394.35H228.1V394.3Z",
    fill: "#53C983"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M147.9 384.2C147.9 386.4 145.85 386.45 143.65 386.45C141.45 386.45 139.95 386.4 139.95 384.2C139.95 382 141.75 380.2 143.95 380.2C146.15 380.2 147.9 382 147.9 384.2Z",
    fill: "#1E8749"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M332.9 386.2C332.9 388.4 330.85 388.45 328.65 388.45C326.45 388.45 324.95 388.4 324.95 386.2C324.95 384 326.75 382.2 328.95 382.2C331.15 382.25 332.9 384 332.9 386.2Z",
    fill: "#1E8749"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M200.65 396.6C200.65 398.8 198.6 398.85 196.4 398.85C194.2 398.85 192.7 398.8 192.7 396.6C192.7 394.4 194.5 392.6 196.7 392.6C198.85 392.65 200.65 394.4 200.65 396.6Z",
    fill: "#1E8749"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M228.4 396.6C228.4 398.8 226.35 398.85 224.15 398.85C221.95 398.85 220.45 398.8 220.45 396.6C220.45 394.4 222.25 392.6 224.45 392.6C226.6 392.65 228.4 394.4 228.4 396.6Z",
    fill: "#1E8749"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M368.75 386.2C368.75 388.4 366.7 388.45 364.5 388.45C362.3 388.45 360.8 388.4 360.8 386.2C360.8 384 362.6 382.2 364.8 382.2C366.95 382.25 368.75 384 368.75 386.2Z",
    fill: "#1E8749"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M135.25 383.8C135.25 386 133.2 386.05 131 386.05C128.8 386.05 127.3 386 127.3 383.8C127.3 381.6 129.1 379.8 131.3 379.8C133.5 379.8 135.25 381.6 135.25 383.8Z",
    fill: "#1E8749"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M289.8 393.85C290.242 393.85 290.6 393.492 290.6 393.05C290.6 392.608 290.242 392.25 289.8 392.25C289.358 392.25 289 392.608 289 393.05C289 393.492 289.358 393.85 289.8 393.85Z",
    fill: "#DA7665"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M289.6 399L289 396.1C289 395.7 289.15 393.75 289.55 393.75H290.1C290.5 393.75 290.65 395.7 290.65 396.1L290.05 399C289.9 399.2 289.65 399.2 289.6 399Z",
    className: "illustration_primary_default"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M282.1 394.6C282.542 394.6 282.9 394.242 282.9 393.8C282.9 393.358 282.542 393 282.1 393C281.658 393 281.3 393.358 281.3 393.8C281.3 394.242 281.658 394.6 282.1 394.6Z",
    fill: "#ECBBB2"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M281.9 399.75L281.3 396.85C281.3 396.45 281.45 394.5 281.85 394.5H282.4C282.8 394.5 282.95 396.45 282.95 396.85L282.35 399.75C282.25 399.95 281.95 399.95 281.9 399.75Z",
    className: "illustration_primary_default"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M274.65 383.6C275.009 383.6 275.3 383.309 275.3 382.95C275.3 382.591 275.009 382.3 274.65 382.3C274.291 382.3 274 382.591 274 382.95C274 383.309 274.291 383.6 274.65 383.6Z",
    fill: "#FDDEA5"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M274.55 387.55L274.05 385.3C274.05 385 274.15 383.45 274.45 383.45H274.9C275.2 383.45 275.3 384.95 275.3 385.3L274.8 387.55C274.8 387.7 274.55 387.7 274.55 387.55Z",
    className: "illustration_primary_default"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M371.2 378.45C371.504 378.45 371.75 378.204 371.75 377.9C371.75 377.596 371.504 377.35 371.2 377.35C370.897 377.35 370.65 377.596 370.65 377.9C370.65 378.204 370.897 378.45 371.2 378.45Z",
    fill: "#FDDEA5"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M371.1 381.85L370.7 379.9C370.7 379.6 370.8 378.3 371.05 378.3H371.4C371.7 378.3 371.75 379.6 371.75 379.9L371.35 381.85C371.3 382 371.15 382 371.1 381.85Z",
    className: "illustration_primary_default"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M373.45 377.4C373.754 377.4 374 377.154 374 376.85C374 376.546 373.754 376.3 373.45 376.3C373.147 376.3 372.9 376.546 372.9 376.85C372.9 377.154 373.147 377.4 373.45 377.4Z",
    fill: "#FDDEA5"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M373.3 380.85L372.9 378.9C372.9 378.6 373 377.3 373.25 377.3H373.6C373.9 377.3 373.95 378.6 373.95 378.9L373.55 380.85C373.55 380.95 373.35 380.95 373.3 380.85Z",
    className: "illustration_primary_default"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M341.4 384.9C341.704 384.9 341.95 384.654 341.95 384.35C341.95 384.046 341.704 383.8 341.4 383.8C341.096 383.8 340.85 384.046 340.85 384.35C340.85 384.654 341.096 384.9 341.4 384.9Z",
    fill: "#4A2D16"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M341.3 388.35L340.9 386.4C340.9 386.1 341 384.8 341.25 384.8H341.6C341.9 384.8 341.95 386.1 341.95 386.4L341.55 388.35C341.5 388.5 341.3 388.5 341.3 388.35Z",
    className: "illustration_primary_default"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M219.3 389.7C219.604 389.7 219.85 389.454 219.85 389.15C219.85 388.846 219.604 388.6 219.3 388.6C218.996 388.6 218.75 388.846 218.75 389.15C218.75 389.454 218.996 389.7 219.3 389.7Z",
    fill: "#4A2D16"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M219.15 393.15L218.75 391.2C218.75 390.9 218.85 389.6 219.1 389.6H219.45C219.75 389.6 219.8 390.9 219.8 391.2L219.4 393.15C219.4 393.3 219.2 393.3 219.15 393.15Z",
    className: "illustration_primary_default"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M216.65 389.85C216.954 389.85 217.2 389.604 217.2 389.3C217.2 388.996 216.954 388.75 216.65 388.75C216.346 388.75 216.1 388.996 216.1 389.3C216.1 389.604 216.346 389.85 216.65 389.85Z",
    fill: "#FCBD4C"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M216.55 393.3L216.15 391.35C216.15 391.05 216.25 389.75 216.5 389.75H216.85C217.15 389.75 217.2 391.05 217.2 391.35L216.8 393.3C216.75 393.45 216.55 393.45 216.55 393.3Z",
    className: "illustration_primary_default"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M207 389.85C207.304 389.85 207.55 389.604 207.55 389.3C207.55 388.996 207.304 388.75 207 388.75C206.696 388.75 206.45 388.996 206.45 389.3C206.45 389.604 206.696 389.85 207 389.85Z",
    fill: "#FCBD4C"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M206.85 393.3L206.45 391.35C206.45 391.05 206.55 389.75 206.8 389.75H207.15C207.45 389.75 207.5 391.05 207.5 391.35L207.1 393.3C207.05 393.45 206.9 393.45 206.85 393.3Z",
    className: "illustration_primary_default"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M204.55 390.2C204.854 390.2 205.1 389.954 205.1 389.65C205.1 389.346 204.854 389.1 204.55 389.1C204.246 389.1 204 389.346 204 389.65C204 389.954 204.246 390.2 204.55 390.2Z",
    fill: "#7A4E30"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M204.45 393.65L204.05 391.7C204.05 391.4 204.15 390.1 204.4 390.1H204.75C205.05 390.1 205.1 391.4 205.1 391.7L204.7 393.65C204.65 393.8 204.45 393.8 204.45 393.65Z",
    className: "illustration_primary_default"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M200.2 390.2C200.504 390.2 200.75 389.954 200.75 389.65C200.75 389.346 200.504 389.1 200.2 389.1C199.897 389.1 199.65 389.346 199.65 389.65C199.65 389.954 199.897 390.2 200.2 390.2Z",
    fill: "#FEDEDF"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M200.05 393.65L199.65 391.7C199.65 391.4 199.75 390.1 200 390.1H200.35C200.65 390.1 200.7 391.4 200.7 391.7L200.3 393.65C200.25 393.8 200.1 393.8 200.05 393.65Z",
    className: "illustration_primary_default"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M214.95 390.2C215.254 390.2 215.5 389.954 215.5 389.65C215.5 389.346 215.254 389.1 214.95 389.1C214.647 389.1 214.4 389.346 214.4 389.65C214.4 389.954 214.647 390.2 214.95 390.2Z",
    fill: "#FEDEDF"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M214.8 393.65L214.4 391.7C214.4 391.4 214.5 390.1 214.75 390.1H215.1C215.4 390.1 215.45 391.4 215.45 391.7L215.05 393.65C215 393.8 214.85 393.8 214.8 393.65Z",
    className: "illustration_primary_default"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M138.6 378.35C138.904 378.35 139.15 378.104 139.15 377.8C139.15 377.496 138.904 377.25 138.6 377.25C138.297 377.25 138.05 377.496 138.05 377.8C138.05 378.104 138.297 378.35 138.6 378.35Z",
    fill: "#FCBD4C"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M138.45 381.8L138.05 379.85C138.05 379.55 138.15 378.25 138.4 378.25H138.75C139.05 378.25 139.1 379.55 139.1 379.85L138.7 381.8C138.7 381.95 138.5 381.95 138.45 381.8Z",
    className: "illustration_primary_default"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M153.4 378.6C153.704 378.6 153.95 378.354 153.95 378.05C153.95 377.746 153.704 377.5 153.4 377.5C153.096 377.5 152.85 377.746 152.85 378.05C152.85 378.354 153.096 378.6 153.4 378.6Z",
    fill: "#FCBD4C"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M153.3 382.05L152.9 380.1C152.9 379.8 153 378.5 153.25 378.5H153.6C153.9 378.5 153.95 379.8 153.95 380.1L153.55 382.05C153.5 382.2 153.35 382.2 153.3 382.05Z",
    className: "illustration_primary_default"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilities);
export default __webpack_public_path__ + "static/media/Facilities.7677d785.svg";
export { ForwardRef as ReactComponent };